(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire91fc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire91fc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("81oe6", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                /\b(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        'OnePlus': [
                            '304',
                            '403',
                            '203'
                        ],
                        '*': OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    'Nokia'
                ]
            ],
            [
                // Google
                /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Archos
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i // Infinix XPad
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i // Nvidia Shield TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                // SmartTV from Unidentified Vendors
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i // Nvidia Portable
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i // OnePlus Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i // Motorola 360
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i // Sony SmartWatch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i // LG G Watch R
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i // Apple HomePod
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i // LibWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    'LibWeb'
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Touch'
                ],
                VERSION
            ],
            [
                // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

// TODO generate on build from git tag
var $c4ea45f2e7d6a641$exports = {};
$c4ea45f2e7d6a641$exports = JSON.parse("{\"name\":\"@slashid/slashid\",\"private\":false,\"publishConfig\":{\"access\":\"public\"},\"version\":\"3.30.0\",\"description\":\"Client SDK for the /id platform\",\"homepage\":\"https://slashid.com\",\"author\":\"SlashID\",\"license\":\"MIT\",\"main\":\"./dist/bundle/slashid.js\",\"module\":\"./dist/esmodule/slashid.esm.js\",\"esmodule\":\"./dist/esmodule/slashid.esm.js\",\"commonjs\":\"./dist/commonjs/slashid.cjs.js\",\"bundle\":\"./dist/bundle/slashid.js\",\"types\":\"./dist/types/slashid.d.ts\",\"exports\":{\".\":{\"require\":\"./dist/commonjs/slashid.cjs.js\",\"import\":\"./dist/esmodule/slashid.esm.js\",\"default\":\"./dist/commonjs/slashid.cjs.js\",\"types\":\"./dist/types/slashid.d.ts\"}},\"targets\":{\"esmodule\":{\"source\":\"src/targets/package.ts\",\"context\":\"browser\",\"isLibrary\":true,\"outputFormat\":\"esmodule\",\"engines\":{\"browsers\":[\"and_chr >= 73\",\"chrome >= 73\",\"and_ff >= 67\",\"android >= 114\",\"edge >= 79\",\"samsung >= 11.2\",\"safari >= 13\",\"ios_saf >= 13.1\",\"opera >= 60\",\"firefox >= 67\",\"unreleased and_chr versions\",\"unreleased chrome versions\",\"unreleased and_ff versions\",\"unreleased android versions\",\"unreleased edge versions\",\"unreleased samsung versions\",\"unreleased safari versions\",\"unreleased ios_saf versions\",\"unreleased opera versions\",\"unreleased firefox versions\"]}},\"commonjs\":{\"source\":\"src/targets/package.ts\",\"context\":\"node\",\"isLibrary\":true,\"outputFormat\":\"commonjs\",\"engines\":{\"node\":\">= 12\"}},\"bundle\":{\"source\":\"src/targets/bundle.ts\",\"context\":\"browser\",\"outputFormat\":\"global\",\"engines\":{\"browsers\":[\"> 0.5%\",\"last 2 versions\",\"not dead\"]}},\"page\":{\"source\":\"static/sdk.html\",\"context\":\"browser\",\"engines\":{\"browsers\":[\"and_chr >= 73\",\"chrome >= 73\",\"and_ff >= 67\",\"android >= 114\",\"edge >= 79\",\"samsung >= 11.2\",\"safari >= 13\",\"ios_saf >= 13.1\",\"opera >= 60\",\"firefox >= 67\",\"unreleased and_chr versions\",\"unreleased chrome versions\",\"unreleased and_ff versions\",\"unreleased android versions\",\"unreleased edge versions\",\"unreleased samsung versions\",\"unreleased safari versions\",\"unreleased ios_saf versions\",\"unreleased opera versions\",\"unreleased firefox versions\"]}},\"types\":{\"source\":\"src/targets/package.ts\"}},\"files\":[\"dist/*\"],\"keywords\":[\"slashid\",\"SlashID\",\"auth\",\"openid\",\"authentication\",\"jwt\",\"browser\"],\"scripts\":{\"clean\":\"rm -rf dist docs\",\"lint\":\"eslint ./src --ext .ts\",\"format\":\"prettier --config .prettierrc.json 'src/**/*.ts' --write\",\"test:ts\":\"tsc --project tsconfig.json --noEmit\",\"test:unit\":\"jest\",\"test:unit:watch\":\"jest --watch\",\"test:unit:ci\":\"jest --ci\",\"test:integration\":\"playwright test\",\"build\":\"rm -rf dist && parcel build --no-cache && cp compat/esmodule/package.json dist/esmodule\",\"docs\":\"rm -rf docs && typedoc\",\"dist\":\"npm run lint && npm run build\",\"all\":\"npm run dist && npm run docs\",\"serve:all\":\"parcel serve 'static/*.html' --port 8080 --no-cache\",\"serve:example\":\"parcel serve static/index.html --port 8080 --no-cache\",\"serve:jump\":\"parcel serve static/sdk.html --port 8080 --no-cache\",\"serve:docs\":\"parcel serve docs/index.html --port 8081 --no-cache\",\"push:docs\":\"aws s3 sync docs s3://slashiddoc/sdk/v$(node tools/version.js --major) && (aws cloudfront create-invalidation --distribution-id ETLBNGAAF97EN --paths \\\"/*\\\")\",\"changeset\":\"changeset\",\"prepublishOnly\":\"npm run all\",\"publish:ci\":\"npm run build && changeset publish\"},\"devDependencies\":{\"@changesets/cli\":\"^2.29.8\",\"@parcel/core\":\"2.16.4\",\"@parcel/packager-ts\":\"2.16.4\",\"@parcel/resolver-default\":\"2.16.4\",\"@parcel/transformer-babel\":\"2.16.4\",\"@parcel/transformer-js\":\"2.16.4\",\"@parcel/transformer-json\":\"2.16.4\",\"@parcel/transformer-react-refresh-wrap\":\"2.16.4\",\"@parcel/transformer-typescript-types\":\"2.16.4\",\"@playwright/test\":\"1.62.1\",\"@types/jest\":\"^28.1.7\",\"@types/node\":\"~24.13.0\",\"@types/qrcode\":\"^1.5.0\",\"@types/ua-parser-js\":\"^0.7.39\",\"@typescript-eslint/eslint-plugin\":\"^4.15.1\",\"@typescript-eslint/parser\":\"^4.15.1\",\"danger\":\"^13.0.7\",\"eslint\":\"^7.20.0\",\"eslint-config-prettier\":\"^8.5.0\",\"eslint-plugin-prettier\":\"^4.2.1\",\"https-proxy-agent\":\"^7.0.5\",\"isomorphic-fetch\":\"^3.0.0\",\"jest\":\"^28.1.3\",\"jest-environment-jsdom\":\"^28.1.3\",\"jest-fetch-mock\":\"^3.0.3\",\"parcel\":\"2.16.4\",\"prettier\":\"^2.7.1\",\"ts-jest\":\"^28.0.8\",\"typedoc\":\"^0.23.00\",\"typedoc-plugin-mdn-links\":\"^2.0.0\",\"typedoc-plugin-missing-exports\":\"^1.0.0\",\"typescript\":\"~4.9.5\"},\"dependencies\":{\"compare-versions\":\"^6.1.0\",\"docdash\":\"^2.0.2\",\"jwt-decode\":\"^3.1.2\",\"qrcode\":\"^1.5.1\",\"querystring-es3\":\"^0.2.1\",\"regenerator-runtime\":\"^0.14.1\",\"ua-parser-js\":\"^1.0.37\",\"url\":\"^0.11.0\",\"uuid\":\"^11.1.1\"},\"resolutions\":{\"@babel/runtime\":\"7.26.10\",\"@babel/helpers\":\"7.26.10\",\"jest-environment-jsdom/**/form-data\":\"4.0.6\",\"brace-expansion\":\"^2.1.3\",\"cross-spawn\":\">=7.0.5\",\"js-yaml\":\"^4.3.0\",\"qs\":\">=6.14.1\",\"undici\":\">=6.27.0 <7\",\"fast-uri\":\">=3.1.4 <4\"}}");


const [$2ebaab364aa833bc$var$major, $2ebaab364aa833bc$var$minor, $2ebaab364aa833bc$var$patch] = (0, $c4ea45f2e7d6a641$exports.version).split(".");
const $2ebaab364aa833bc$export$f9582ef3c55143f = {
    major: $2ebaab364aa833bc$var$major,
    minor: $2ebaab364aa833bc$var$minor,
    patch: $2ebaab364aa833bc$var$patch,
    raw: (0, $c4ea45f2e7d6a641$exports.version)
};


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ const $d34fdaa1d1a4aef1$export$2812a1fb15aca49c = "https://api.slashid.com".replace(/\/+$/, "");
class $d34fdaa1d1a4aef1$export$fa89be98fe0936f2 {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $d34fdaa1d1a4aef1$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $d34fdaa1d1a4aef1$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === 'function' ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === 'function' ? accessToken : async ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const $d34fdaa1d1a4aef1$export$ac4f8128ea29c5 = new $d34fdaa1d1a4aef1$export$fa89be98fe0936f2();
class $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    static{
        this.jsonRegex = /^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$/i;
    }
    constructor(configuration = $d34fdaa1d1a4aef1$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url: url,
                init: init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = undefined;
            try {
                response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            } catch (e) {
                for (const middleware of this.middleware)if (middleware.onError) response = await middleware.onError({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    error: e,
                    response: response ? response.clone() : undefined
                }) || response;
                if (response === undefined) {
                    if (e instanceof Error) throw new $d34fdaa1d1a4aef1$export$26e841bcf1aeb894(e, 'The request failed and the interceptors did not return an alternative response');
                    else throw e;
                }
            }
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    async request(context, initOverrides) {
        const { url: url, init: init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && response.status >= 200 && response.status < 300) return response;
        throw new $d34fdaa1d1a4aef1$export$286baf652d0b1206(response, 'Response returned an error code');
    }
    async createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += '?' + this.configuration.queryParamsStringify(context.query);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
        const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async ()=>initOverrides;
        const initParams = {
            method: context.method,
            headers: headers,
            body: context.body,
            credentials: this.configuration.credentials
        };
        const overriddenInit = {
            ...initParams,
            ...await initOverrideFn({
                init: initParams,
                context: context
            })
        };
        let body;
        if ($d34fdaa1d1a4aef1$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $d34fdaa1d1a4aef1$var$isBlob(overriddenInit.body)) body = overriddenInit.body;
        else if (this.isJsonMime(headers['Content-Type'])) body = JSON.stringify(overriddenInit.body);
        else body = overriddenInit.body;
        const init = {
            ...overriddenInit,
            body: body
        };
        return {
            url: url,
            init: init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function $d34fdaa1d1a4aef1$var$isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
function $d34fdaa1d1a4aef1$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $d34fdaa1d1a4aef1$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg), this.response = response, this.name = "ResponseError";
        // restore prototype chain
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) Object.setPrototypeOf(this, actualProto);
    }
}
class $d34fdaa1d1a4aef1$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg), this.cause = cause, this.name = "FetchError";
        // restore prototype chain
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) Object.setPrototypeOf(this, actualProto);
    }
}
class $d34fdaa1d1a4aef1$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg), this.field = field, this.name = "RequiredError";
        // restore prototype chain
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) Object.setPrototypeOf(this, actualProto);
    }
}
const $d34fdaa1d1a4aef1$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};
function $d34fdaa1d1a4aef1$export$ac4103b836844853(params, prefix = '') {
    return Object.keys(params).map((key)=>$d34fdaa1d1a4aef1$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join('&');
}
function $d34fdaa1d1a4aef1$var$querystringSingleKey(key, value, keyPrefix = '') {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $d34fdaa1d1a4aef1$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $d34fdaa1d1a4aef1$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $d34fdaa1d1a4aef1$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $d34fdaa1d1a4aef1$export$825e789796ab7275(data, fn) {
    const result = {};
    for (const key of Object.keys(data))result[key] = fn(data[key]);
    return result;
}
function $d34fdaa1d1a4aef1$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
class $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4 {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class $d34fdaa1d1a4aef1$export$20446dc680588cc3 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class $d34fdaa1d1a4aef1$export$9d707f60a06b41f8 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class $d34fdaa1d1a4aef1$export$bf40ae8c274ef99b {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $0ee1bbca4508c5f9$export$6c620df6ac3163e7(value) {
    return true;
}
function $0ee1bbca4508c5f9$export$9a91be5fb3879fb9(json) {
    return $0ee1bbca4508c5f9$export$39dc308db371e81(json, false);
}
function $0ee1bbca4508c5f9$export$39dc308db371e81(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'httpcode': json['httpcode'] == null ? undefined : json['httpcode'],
        'message': json['message'] == null ? undefined : json['message']
    };
}
function $0ee1bbca4508c5f9$export$797f61dd859e886c(json) {
    return $0ee1bbca4508c5f9$export$e27654f1161bf727(json, false);
}
function $0ee1bbca4508c5f9$export$e27654f1161bf727(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'httpcode': value['httpcode'],
        'message': value['message']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $2fe66fc720cb845e$export$c42998494c7bf084(value) {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('last_cursor' in value) || value['last_cursor'] === undefined) return false;
    return true;
}
function $2fe66fc720cb845e$export$9cb18d1b352dd2fa(json) {
    return $2fe66fc720cb845e$export$e8f3b3aaa7a9ed4d(json, false);
}
function $2fe66fc720cb845e$export$e8f3b3aaa7a9ed4d(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'limit': json['limit'],
        'next_cursor': json['next_cursor'] == null ? undefined : json['next_cursor'],
        'prev_cursor': json['prev_cursor'] == null ? undefined : json['prev_cursor'],
        'last_cursor': json['last_cursor'],
        'total_count': json['total_count'] == null ? undefined : json['total_count']
    };
}
function $2fe66fc720cb845e$export$2cf647af823d3021(json) {
    return $2fe66fc720cb845e$export$575328d0a23897ad(json, false);
}
function $2fe66fc720cb845e$export$575328d0a23897ad(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'limit': value['limit'],
        'next_cursor': value['next_cursor'],
        'prev_cursor': value['prev_cursor'],
        'last_cursor': value['last_cursor'],
        'total_count': value['total_count']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $0bc7af6bb5f0dd50$export$2caf5cdeee54129b(value) {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    if (!('total_count' in value) || value['total_count'] === undefined) return false;
    return true;
}
function $0bc7af6bb5f0dd50$export$c449262465ba2bb9(json) {
    return $0bc7af6bb5f0dd50$export$3fe7617ab48f3b5c(json, false);
}
function $0bc7af6bb5f0dd50$export$3fe7617ab48f3b5c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'limit': json['limit'],
        'offset': json['offset'],
        'total_count': json['total_count']
    };
}
function $0bc7af6bb5f0dd50$export$9c53a26884a83ec6(json) {
    return $0bc7af6bb5f0dd50$export$6086ad926c65669f(json, false);
}
function $0bc7af6bb5f0dd50$export$6086ad926c65669f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'limit': value['limit'],
        'offset': value['offset'],
        'total_count': value['total_count']
    };
}


function $a32bba956ade8bec$export$90742f18fb91b1a8(value) {
    return true;
}
function $a32bba956ade8bec$export$70023f934842ce53(json) {
    return $a32bba956ade8bec$export$9057b09091c07cb0(json, false);
}
function $a32bba956ade8bec$export$9057b09091c07cb0(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'pagination': json['pagination'] == null ? undefined : (0, $0bc7af6bb5f0dd50$export$c449262465ba2bb9)(json['pagination']),
        'cursor_pagination': json['cursor_pagination'] == null ? undefined : (0, $2fe66fc720cb845e$export$9cb18d1b352dd2fa)(json['cursor_pagination'])
    };
}
function $a32bba956ade8bec$export$a688b751866cf7f3(json) {
    return $a32bba956ade8bec$export$2ff47c2b24f48359(json, false);
}
function $a32bba956ade8bec$export$2ff47c2b24f48359(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'pagination': (0, $0bc7af6bb5f0dd50$export$9c53a26884a83ec6)(value['pagination']),
        'cursor_pagination': (0, $2fe66fc720cb845e$export$2cf647af823d3021)(value['cursor_pagination'])
    };
}


function $14533c91dcba43d9$export$2b7c18f96ce69490(value) {
    return true;
}
function $14533c91dcba43d9$export$53557473c48f27d7(json) {
    return $14533c91dcba43d9$export$488f61d1ca30688d(json, false);
}
function $14533c91dcba43d9$export$488f61d1ca30688d(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9))
    };
}
function $14533c91dcba43d9$export$9f307ab67ab58299(json) {
    return $14533c91dcba43d9$export$7fec3eac3838a27b(json, false);
}
function $14533c91dcba43d9$export$7fec3eac3838a27b(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $4a3198d5ca100d97$export$7d97f8bab00baf95(value) {
    return true;
}
function $4a3198d5ca100d97$export$b860effd636f4c33(json) {
    return $4a3198d5ca100d97$export$d11a34d219cd35f6(json, false);
}
function $4a3198d5ca100d97$export$d11a34d219cd35f6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : json['result']
    };
}
function $4a3198d5ca100d97$export$98b678070add2b13(json) {
    return $4a3198d5ca100d97$export$a73815b81b894e0c(json, false);
}
function $4a3198d5ca100d97$export$a73815b81b894e0c(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $e81eb330fb3a5f78$export$6e1216be97f1c012(value) {
    return true;
}
function $e81eb330fb3a5f78$export$16028d5073b65888(json) {
    return $e81eb330fb3a5f78$export$9423100a03fc92a1(json, false);
}
function $e81eb330fb3a5f78$export$9423100a03fc92a1(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : json['result']
    };
}
function $e81eb330fb3a5f78$export$aa51becaf6dd0f05(json) {
    return $e81eb330fb3a5f78$export$f71c15a0b7c857a7(json, false);
}
function $e81eb330fb3a5f78$export$f71c15a0b7c857a7(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


class $fe4f85292cc128f9$export$95d3101c7670792a extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for deleteAttributesBucketName without sending the request
     */ async deleteAttributesBucketNameRequestOpts(requestParameters) {
        if (requestParameters['bucketName'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('bucketName', 'Required parameter "bucketName" was null or undefined when calling deleteAttributesBucketName().');
        const queryParameters = {};
        if (requestParameters['attributes'] != null) queryParameters['attributes'] = requestParameters['attributes'].join($d34fdaa1d1a4aef1$export$83cb526776fb323d["csv"]);
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes/{bucket_name}`;
        urlPath = urlPath.replace('{bucket_name}', encodeURIComponent(String(requestParameters['bucketName'])));
        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Delete attributes from a single bucket
     */ async deleteAttributesBucketNameRaw(requestParameters, initOverrides) {
        const requestOptions = await this.deleteAttributesBucketNameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Delete attributes from a single bucket
     */ async deleteAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.deleteAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getAttributes without sending the request
     */ async getAttributesRequestOpts(requestParameters) {
        const queryParameters = {};
        if (requestParameters['buckets'] != null) queryParameters['buckets'] = requestParameters['buckets'].join($d34fdaa1d1a4aef1$export$83cb526776fb323d["csv"]);
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve attributes from multiple buckets
     */ async getAttributesRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getAttributesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4a3198d5ca100d97$export$b860effd636f4c33)(jsonValue));
    }
    /**
     * Retrieve attributes from multiple buckets
     */ async getAttributes(requestParameters = {}, initOverrides) {
        const response = await this.getAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getAttributesBucketName without sending the request
     */ async getAttributesBucketNameRequestOpts(requestParameters) {
        if (requestParameters['bucketName'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('bucketName', 'Required parameter "bucketName" was null or undefined when calling getAttributesBucketName().');
        const queryParameters = {};
        if (requestParameters['attributes'] != null) queryParameters['attributes'] = requestParameters['attributes'].join($d34fdaa1d1a4aef1$export$83cb526776fb323d["csv"]);
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes/{bucket_name}`;
        urlPath = urlPath.replace('{bucket_name}', encodeURIComponent(String(requestParameters['bucketName'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve attributes from a single bucket
     */ async getAttributesBucketNameRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getAttributesBucketNameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e81eb330fb3a5f78$export$16028d5073b65888)(jsonValue));
    }
    /**
     * Retrieve attributes from a single bucket
     */ async getAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.getAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for patchAttributes without sending the request
     */ async patchAttributesRequestOpts(requestParameters) {
        if (requestParameters['body'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('body', 'Required parameter "body" was null or undefined when calling patchAttributes().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes`;
        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body']
        };
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in multiple buckets
     */ async patchAttributesRaw(requestParameters, initOverrides) {
        const requestOptions = await this.patchAttributesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in multiple buckets
     */ async patchAttributes(requestParameters, initOverrides) {
        const response = await this.patchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for patchAttributesBucketName without sending the request
     */ async patchAttributesBucketNameRequestOpts(requestParameters) {
        if (requestParameters['bucketName'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('bucketName', 'Required parameter "bucketName" was null or undefined when calling patchAttributesBucketName().');
        if (requestParameters['body'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('body', 'Required parameter "body" was null or undefined when calling patchAttributesBucketName().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes/{bucket_name}`;
        urlPath = urlPath.replace('{bucket_name}', encodeURIComponent(String(requestParameters['bucketName'])));
        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body']
        };
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in a single bucket
     */ async patchAttributesBucketNameRaw(requestParameters, initOverrides) {
        const requestOptions = await this.patchAttributesBucketNameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in a single bucket
     */ async patchAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.patchAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for putAttributes without sending the request
     */ async putAttributesRequestOpts(requestParameters) {
        if (requestParameters['body'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('body', 'Required parameter "body" was null or undefined when calling putAttributes().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes`;
        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body']
        };
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in multiple buckets
     */ async putAttributesRaw(requestParameters, initOverrides) {
        const requestOptions = await this.putAttributesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in multiple buckets
     */ async putAttributes(requestParameters, initOverrides) {
        const response = await this.putAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for putAttributesBucketName without sending the request
     */ async putAttributesBucketNameRequestOpts(requestParameters) {
        if (requestParameters['bucketName'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('bucketName', 'Required parameter "bucketName" was null or undefined when calling putAttributesBucketName().');
        if (requestParameters['body'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('body', 'Required parameter "body" was null or undefined when calling putAttributesBucketName().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attributes/{bucket_name}`;
        urlPath = urlPath.replace('{bucket_name}', encodeURIComponent(String(requestParameters['bucketName'])));
        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body']
        };
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in a single bucket
     */ async putAttributesBucketNameRaw(requestParameters, initOverrides) {
        const requestOptions = await this.putAttributesBucketNameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in a single bucket
     */ async putAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.putAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $4928fc6e055557be$export$7962c6bffc1da42 = {
    UiCustomization: 'ui_customization',
    AuthnContextUpdate: 'authn_context_update',
    Proxy: 'proxy',
    WebauthnCreate: 'webauthn_create',
    WebauthnGet: 'webauthn_get',
    Nonce: 'nonce',
    Otp: 'otp',
    Oidc: 'oidc',
    Saml: 'saml',
    PasswordSet: 'password_set',
    PasswordVerify: 'password_verify',
    PasswordReset: 'password_reset',
    TotpRegister: 'totp_register',
    TotpVerify: 'totp_verify'
};
function $4928fc6e055557be$export$502c59bb772ffe2d(value) {
    for(const key in $4928fc6e055557be$export$7962c6bffc1da42)if (Object.prototype.hasOwnProperty.call($4928fc6e055557be$export$7962c6bffc1da42, key)) {
        if ($4928fc6e055557be$export$7962c6bffc1da42[key] === value) return true;
    }
    return false;
}
function $4928fc6e055557be$export$7da7fa2b5d7d85f3(json) {
    return $4928fc6e055557be$export$b1e18bb9237bd017(json, false);
}
function $4928fc6e055557be$export$b1e18bb9237bd017(json, ignoreDiscriminator) {
    return json;
}
function $4928fc6e055557be$export$e418cafec408031e(value) {
    return value;
}
function $4928fc6e055557be$export$6fd17dd08f0911c0(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $de7a41d74bacaf54$export$bab851ae817d28dd(value) {
    return true;
}
function $de7a41d74bacaf54$export$703f66b537d92f5c(json) {
    return $de7a41d74bacaf54$export$a4e33e976363db18(json, false);
}
function $de7a41d74bacaf54$export$a4e33e976363db18(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge': json['challenge'] == null ? undefined : json['challenge']
    };
}
function $de7a41d74bacaf54$export$91e7f239824ee67f(json) {
    return $de7a41d74bacaf54$export$4183e1b86e92544d(json, false);
}
function $de7a41d74bacaf54$export$4183e1b86e92544d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge': value['challenge']
    };
}


function $724855765ee7b294$export$88b5d910b589cf13(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $724855765ee7b294$export$dea5b50d6ead812(json) {
    return $724855765ee7b294$export$fe0ec9eae36a9b35(json, false);
}
function $724855765ee7b294$export$fe0ec9eae36a9b35(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $de7a41d74bacaf54$export$703f66b537d92f5c)(json['data'])
    };
}
function $724855765ee7b294$export$2ddc20e282619fc3(json) {
    return $724855765ee7b294$export$a33e244bf6a2173a(json, false);
}
function $724855765ee7b294$export$a33e244bf6a2173a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $de7a41d74bacaf54$export$91e7f239824ee67f)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $7db72f67fb5328df$export$1d9a2093aa5b8546(value) {
    return true;
}
function $7db72f67fb5328df$export$bb8ecc995265609e(json) {
    return $7db72f67fb5328df$export$fe08176e0964d56a(json, false);
}
function $7db72f67fb5328df$export$fe08176e0964d56a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'otp': json['otp'] == null ? undefined : json['otp']
    };
}
function $7db72f67fb5328df$export$6da0bcef5e0a8fdb(json) {
    return $7db72f67fb5328df$export$cfc1a1bdc81cbc49(json, false);
}
function $7db72f67fb5328df$export$cfc1a1bdc81cbc49(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'otp': value['otp']
    };
}


function $af49bef5227abaac$export$3e31be0f0b2d293a(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $af49bef5227abaac$export$1898d4ed4a0ad45e(json) {
    return $af49bef5227abaac$export$4285315b0ce1487c(json, false);
}
function $af49bef5227abaac$export$4285315b0ce1487c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $7db72f67fb5328df$export$bb8ecc995265609e)(json['data'])
    };
}
function $af49bef5227abaac$export$9e8a349f91c23ca8(json) {
    return $af49bef5227abaac$export$8a3df6692beb66e1(json, false);
}
function $af49bef5227abaac$export$8a3df6692beb66e1(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $7db72f67fb5328df$export$6da0bcef5e0a8fdb)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $a47bfef30af6e532$export$3e7a5827055f8c1f(value) {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}
function $a47bfef30af6e532$export$531fea8f5c0d835d(json) {
    return $a47bfef30af6e532$export$d9419205450c9d50(json, false);
}
function $a47bfef30af6e532$export$d9419205450c9d50(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'password': json['password']
    };
}
function $a47bfef30af6e532$export$b0b890df0497afa3(json) {
    return $a47bfef30af6e532$export$9da0aa9f56b5e22c(json, false);
}
function $a47bfef30af6e532$export$9da0aa9f56b5e22c(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'password': value['password']
    };
}



function $d4fbb53a71eaa6ed$export$40bbbf642a3a69ad(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $d4fbb53a71eaa6ed$export$5d2326fd568db8d0(json) {
    return $d4fbb53a71eaa6ed$export$d45d032a25047716(json, false);
}
function $d4fbb53a71eaa6ed$export$d45d032a25047716(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $a47bfef30af6e532$export$531fea8f5c0d835d)(json['data'])
    };
}
function $d4fbb53a71eaa6ed$export$7b6f5d07bfad78e9(json) {
    return $d4fbb53a71eaa6ed$export$30498b4f9bce2ee8(json, false);
}
function $d4fbb53a71eaa6ed$export$30498b4f9bce2ee8(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $a47bfef30af6e532$export$b0b890df0497afa3)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $826f67b0386d9ba3$export$a964533c60d268fd(value) {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}
function $826f67b0386d9ba3$export$fe9d75047753248b(json) {
    return $826f67b0386d9ba3$export$756838b7787a84f1(json, false);
}
function $826f67b0386d9ba3$export$756838b7787a84f1(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'password': json['password']
    };
}
function $826f67b0386d9ba3$export$69b7ca2907b53e3d(json) {
    return $826f67b0386d9ba3$export$7eb6f6b1b2504b5(json, false);
}
function $826f67b0386d9ba3$export$7eb6f6b1b2504b5(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'password': value['password']
    };
}



function $9d784bf62f605cb4$export$c8ecde44d2fa41f4(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $9d784bf62f605cb4$export$17063cb6a2c93912(json) {
    return $9d784bf62f605cb4$export$539bcbef6d641f12(json, false);
}
function $9d784bf62f605cb4$export$539bcbef6d641f12(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $826f67b0386d9ba3$export$fe9d75047753248b)(json['data'])
    };
}
function $9d784bf62f605cb4$export$751a8f178b8690f0(json) {
    return $9d784bf62f605cb4$export$f9e0cbfd14bb234c(json, false);
}
function $9d784bf62f605cb4$export$f9e0cbfd14bb234c(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $826f67b0386d9ba3$export$69b7ca2907b53e3d)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $6ecaead147c84207$export$486889bd75e3b780(value) {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}
function $6ecaead147c84207$export$3fe1672863804c9d(json) {
    return $6ecaead147c84207$export$f4579e3d10a997c7(json, false);
}
function $6ecaead147c84207$export$f4579e3d10a997c7(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'password': json['password']
    };
}
function $6ecaead147c84207$export$27fad2cccc00f212(json) {
    return $6ecaead147c84207$export$eee99d8cb4356730(json, false);
}
function $6ecaead147c84207$export$eee99d8cb4356730(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'password': value['password']
    };
}



function $7f786948a266bffc$export$52d6565f54833912(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $7f786948a266bffc$export$6d7d3f7497bac8da(json) {
    return $7f786948a266bffc$export$10d1c2ecf0d72392(json, false);
}
function $7f786948a266bffc$export$10d1c2ecf0d72392(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $6ecaead147c84207$export$3fe1672863804c9d)(json['data'])
    };
}
function $7f786948a266bffc$export$b7b281ec8692f580(json) {
    return $7f786948a266bffc$export$1f19ff42973890f0(json, false);
}
function $7f786948a266bffc$export$1f19ff42973890f0(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $6ecaead147c84207$export$27fad2cccc00f212)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $373d409386ced32a$export$92ceb7a6bfbf2d2d(value) {
    return true;
}
function $373d409386ced32a$export$ef169f01af6d5676(json) {
    return $373d409386ced32a$export$54cbfb7c20102b70(json, false);
}
function $373d409386ced32a$export$54cbfb7c20102b70(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'otp': json['otp'] == null ? undefined : json['otp']
    };
}
function $373d409386ced32a$export$87e83845366bd7e3(json) {
    return $373d409386ced32a$export$33f37fca2694feba(json, false);
}
function $373d409386ced32a$export$33f37fca2694feba(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'otp': value['otp']
    };
}



function $d51ae7cbbc51c603$export$be01d18bf69a8fa(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $d51ae7cbbc51c603$export$d0c1bdc637e5e895(json) {
    return $d51ae7cbbc51c603$export$b44518c38b369723(json, false);
}
function $d51ae7cbbc51c603$export$b44518c38b369723(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $373d409386ced32a$export$ef169f01af6d5676)(json['data'])
    };
}
function $d51ae7cbbc51c603$export$167110d9a40e7fcd(json) {
    return $d51ae7cbbc51c603$export$266a35fce4ca630a(json, false);
}
function $d51ae7cbbc51c603$export$266a35fce4ca630a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $373d409386ced32a$export$87e83845366bd7e3)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $2c7831b69ebca13d$export$a3014234fe6a2b9b(value) {
    return true;
}
function $2c7831b69ebca13d$export$d31be9a6034a3ec9(json) {
    return $2c7831b69ebca13d$export$e09d6c39e39b5175(json, false);
}
function $2c7831b69ebca13d$export$e09d6c39e39b5175(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'otp': json['otp'] == null ? undefined : json['otp']
    };
}
function $2c7831b69ebca13d$export$a789f8fc51697f53(json) {
    return $2c7831b69ebca13d$export$c4a7aceb1a05cb0d(json, false);
}
function $2c7831b69ebca13d$export$c4a7aceb1a05cb0d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'otp': value['otp']
    };
}


function $b43d0362e5d79393$export$752b6405c46bdbd6(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $b43d0362e5d79393$export$66ec8e67bf59fda(json) {
    return $b43d0362e5d79393$export$afdbafa9ab0915af(json, false);
}
function $b43d0362e5d79393$export$afdbafa9ab0915af(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : (0, $2c7831b69ebca13d$export$d31be9a6034a3ec9)(json['data'])
    };
}
function $b43d0362e5d79393$export$1be77b6cf29772e6(json) {
    return $b43d0362e5d79393$export$7bef7fd54853e8fc(json, false);
}
function $b43d0362e5d79393$export$7bef7fd54853e8fc(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': (0, $2c7831b69ebca13d$export$a789f8fc51697f53)(value['data'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $2df56662f473ee2e$export$a5ca1d3b297dbd23(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $2df56662f473ee2e$export$14a4778736916973(json) {
    return $2df56662f473ee2e$export$dbc4437c51d4130d(json, false);
}
function $2df56662f473ee2e$export$dbc4437c51d4130d(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : json['data']
    };
}
function $2df56662f473ee2e$export$2704f2dae5463d10(json) {
    return $2df56662f473ee2e$export$338e37b81ded745a(json, false);
}
function $2df56662f473ee2e$export$338e37b81ded745a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': value['data']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a02165fac8ac2cd9$export$de882eb450d20938(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $a02165fac8ac2cd9$export$33a30dd12c6f8c8d(json) {
    return $a02165fac8ac2cd9$export$d4d9b4c10592863c(json, false);
}
function $a02165fac8ac2cd9$export$d4d9b4c10592863c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type']),
        'data': json['data'] == null ? undefined : json['data']
    };
}
function $a02165fac8ac2cd9$export$1181dc7f727e9334(json) {
    return $a02165fac8ac2cd9$export$7d1133c8da02c775(json, false);
}
function $a02165fac8ac2cd9$export$7d1133c8da02c775(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type']),
        'data': value['data']
    };
}


function $00af686f6122a4d2$export$f2a65bfde9fd2807(json) {
    return $00af686f6122a4d2$export$f931041f10007c40(json, false);
}
function $00af686f6122a4d2$export$f931041f10007c40(json, ignoreDiscriminator) {
    if (json == null) return json;
    switch(json['challenge_type']){
        case 'nonce':
            return Object.assign({}, (0, $724855765ee7b294$export$fe0ec9eae36a9b35)(json, true), {
                challenge_type: 'nonce'
            });
        case 'otp':
            return Object.assign({}, (0, $af49bef5227abaac$export$4285315b0ce1487c)(json, true), {
                challenge_type: 'otp'
            });
        case 'password_reset':
            return Object.assign({}, (0, $d4fbb53a71eaa6ed$export$d45d032a25047716)(json, true), {
                challenge_type: 'password_reset'
            });
        case 'password_set':
            return Object.assign({}, (0, $9d784bf62f605cb4$export$539bcbef6d641f12)(json, true), {
                challenge_type: 'password_set'
            });
        case 'password_verify':
            return Object.assign({}, (0, $7f786948a266bffc$export$10d1c2ecf0d72392)(json, true), {
                challenge_type: 'password_verify'
            });
        case 'totp_register':
            return Object.assign({}, (0, $d51ae7cbbc51c603$export$b44518c38b369723)(json, true), {
                challenge_type: 'totp_register'
            });
        case 'totp_verify':
            return Object.assign({}, (0, $b43d0362e5d79393$export$afdbafa9ab0915af)(json, true), {
                challenge_type: 'totp_verify'
            });
        case 'webauthn_create':
            return Object.assign({}, (0, $2df56662f473ee2e$export$dbc4437c51d4130d)(json, true), {
                challenge_type: 'webauthn_create'
            });
        case 'webauthn_get':
            return Object.assign({}, (0, $a02165fac8ac2cd9$export$d4d9b4c10592863c)(json, true), {
                challenge_type: 'webauthn_get'
            });
        default:
            return json;
    }
}
function $00af686f6122a4d2$export$d7f719716c0ef239(json) {
    return $00af686f6122a4d2$export$4b613734e072cbf1(json, false);
}
function $00af686f6122a4d2$export$4b613734e072cbf1(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    switch(value['challenge_type']){
        case 'nonce':
            return Object.assign({}, (0, $724855765ee7b294$export$2ddc20e282619fc3)(value), {
                challenge_type: 'nonce'
            });
        case 'otp':
            return Object.assign({}, (0, $af49bef5227abaac$export$9e8a349f91c23ca8)(value), {
                challenge_type: 'otp'
            });
        case 'password_reset':
            return Object.assign({}, (0, $d4fbb53a71eaa6ed$export$7b6f5d07bfad78e9)(value), {
                challenge_type: 'password_reset'
            });
        case 'password_set':
            return Object.assign({}, (0, $9d784bf62f605cb4$export$751a8f178b8690f0)(value), {
                challenge_type: 'password_set'
            });
        case 'password_verify':
            return Object.assign({}, (0, $7f786948a266bffc$export$b7b281ec8692f580)(value), {
                challenge_type: 'password_verify'
            });
        case 'totp_register':
            return Object.assign({}, (0, $d51ae7cbbc51c603$export$167110d9a40e7fcd)(value), {
                challenge_type: 'totp_register'
            });
        case 'totp_verify':
            return Object.assign({}, (0, $b43d0362e5d79393$export$1be77b6cf29772e6)(value), {
                challenge_type: 'totp_verify'
            });
        case 'webauthn_create':
            return Object.assign({}, (0, $2df56662f473ee2e$export$2704f2dae5463d10)(value), {
                challenge_type: 'webauthn_create'
            });
        case 'webauthn_get':
            return Object.assign({}, (0, $a02165fac8ac2cd9$export$1181dc7f727e9334)(value), {
                challenge_type: 'webauthn_get'
            });
        default:
            return value;
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $954fc7ad481674dd$export$a6108f85fb1ad7d5(value) {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}
function $954fc7ad481674dd$export$fe3ecd8452352d22(json) {
    return $954fc7ad481674dd$export$8979123924a795b5(json, false);
}
function $954fc7ad481674dd$export$8979123924a795b5(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'password': json['password']
    };
}
function $954fc7ad481674dd$export$1fea968ae44584ab(json) {
    return $954fc7ad481674dd$export$d0bf16db3e04ea2a(json, false);
}
function $954fc7ad481674dd$export$d0bf16db3e04ea2a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'password': value['password']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $afd83da85d848823$export$bb6ed6ccec47107b(value) {
    return true;
}
function $afd83da85d848823$export$fc7f4a9925d556ff(json) {
    return $afd83da85d848823$export$95db559018dc2213(json, false);
}
function $afd83da85d848823$export$95db559018dc2213(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : json['result']
    };
}
function $afd83da85d848823$export$b016b87aa3f94563(json) {
    return $afd83da85d848823$export$cdceac1950aa03e7(json, false);
}
function $afd83da85d848823$export$cdceac1950aa03e7(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $2d4ecca59a9c27db$export$2374e01db22e717d(value) {
    return true;
}
function $2d4ecca59a9c27db$export$859624b73bf55232(json) {
    return $2d4ecca59a9c27db$export$ebb02bfda1ac3737(json, false);
}
function $2d4ecca59a9c27db$export$ebb02bfda1ac3737(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : json['result']
    };
}
function $2d4ecca59a9c27db$export$5b37eff911dd0edc(json) {
    return $2d4ecca59a9c27db$export$8993b9b4ef89f858(json, false);
}
function $2d4ecca59a9c27db$export$8993b9b4ef89f858(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * The type of the credential
 * @export
 */ const $59e949b392b8d9ae$export$eca2dc7e6e608a68 = {
    PublicKey: 'public-key',
    Password: 'password',
    Totp: 'totp'
};
function $59e949b392b8d9ae$export$7f0badc4713c1a8(value) {
    for(const key in $59e949b392b8d9ae$export$eca2dc7e6e608a68)if (Object.prototype.hasOwnProperty.call($59e949b392b8d9ae$export$eca2dc7e6e608a68, key)) {
        if ($59e949b392b8d9ae$export$eca2dc7e6e608a68[key] === value) return true;
    }
    return false;
}
function $59e949b392b8d9ae$export$7bbec83240b0eeeb(json) {
    return $59e949b392b8d9ae$export$4abdb906a4385f20(json, false);
}
function $59e949b392b8d9ae$export$4abdb906a4385f20(json, ignoreDiscriminator) {
    return json;
}
function $59e949b392b8d9ae$export$ee7a066c014b3dac(value) {
    return value;
}
function $59e949b392b8d9ae$export$8d6694e29a569acf(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $e3b6faf8c875a3e5$export$6a88ca8fd731b808(value) {
    if (!('password_hash' in value) || value['password_hash'] === undefined) return false;
    return true;
}
function $e3b6faf8c875a3e5$export$928a6f09136df146(json) {
    return $e3b6faf8c875a3e5$export$b1b8ca533ff69fce(json, false);
}
function $e3b6faf8c875a3e5$export$b1b8ca533ff69fce(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'password_hash': json['password_hash']
    };
}
function $e3b6faf8c875a3e5$export$f9ebf1cd3c73df35(json) {
    return $e3b6faf8c875a3e5$export$a7f904b4648a7780(json, false);
}
function $e3b6faf8c875a3e5$export$a7f904b4648a7780(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'password_hash': value['password_hash']
    };
}


function $952c88990da1f478$export$9062a3291ff14da0(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}
function $952c88990da1f478$export$903fce13c2af8cb3(json) {
    return $952c88990da1f478$export$15f2d4eabe16d54e(json, false);
}
function $952c88990da1f478$export$15f2d4eabe16d54e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : new Date(json['last_used']),
        'type': (0, $59e949b392b8d9ae$export$7bbec83240b0eeeb)(json['type']),
        'params': (0, $e3b6faf8c875a3e5$export$928a6f09136df146)(json['params']),
        'label': json['label'] == null ? undefined : json['label']
    };
}
function $952c88990da1f478$export$950a6b723fe0c8d1(json) {
    return $952c88990da1f478$export$18743b8538bbbb8f(json, false);
}
function $952c88990da1f478$export$18743b8538bbbb8f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
        'type': (0, $59e949b392b8d9ae$export$ee7a066c014b3dac)(value['type']),
        'params': (0, $e3b6faf8c875a3e5$export$f9ebf1cd3c73df35)(value['params']),
        'label': value['label']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $9fa6ac2ebfc2a6d3$export$a087f084ee0668fc(value) {
    if (!('aaguid' in value) || value['aaguid'] === undefined) return false;
    return true;
}
function $9fa6ac2ebfc2a6d3$export$193230f03b4e2b5e(json) {
    return $9fa6ac2ebfc2a6d3$export$55d348d93c04571c(json, false);
}
function $9fa6ac2ebfc2a6d3$export$55d348d93c04571c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'aaguid': json['aaguid'],
        'sign_count': json['sign_count'] == null ? undefined : json['sign_count'],
        'clone_warning': json['clone_warning'] == null ? undefined : json['clone_warning']
    };
}
function $9fa6ac2ebfc2a6d3$export$870360f2c096bfed(json) {
    return $9fa6ac2ebfc2a6d3$export$e3eb4aabe6eedaf2(json, false);
}
function $9fa6ac2ebfc2a6d3$export$e3eb4aabe6eedaf2(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'aaguid': value['aaguid'],
        'sign_count': value['sign_count'],
        'clone_warning': value['clone_warning']
    };
}


function $c68db1e5a957affb$export$6b8c6447a91d8ac2(value) {
    if (!('webauthn_credential_id' in value) || value['webauthn_credential_id'] === undefined) return false;
    if (!('public_key' in value) || value['public_key'] === undefined) return false;
    if (!('attestation_type' in value) || value['attestation_type'] === undefined) return false;
    if (!('authenticator' in value) || value['authenticator'] === undefined) return false;
    return true;
}
function $c68db1e5a957affb$export$cb838a8294c45d7f(json) {
    return $c68db1e5a957affb$export$95fe40beb2acb37e(json, false);
}
function $c68db1e5a957affb$export$95fe40beb2acb37e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'webauthn_credential_id': json['webauthn_credential_id'],
        'public_key': json['public_key'],
        'attestation_type': json['attestation_type'],
        'authenticator': (0, $9fa6ac2ebfc2a6d3$export$193230f03b4e2b5e)(json['authenticator'])
    };
}
function $c68db1e5a957affb$export$37444c8007920ed9(json) {
    return $c68db1e5a957affb$export$f9131170c6ce4bbf(json, false);
}
function $c68db1e5a957affb$export$f9131170c6ce4bbf(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'webauthn_credential_id': value['webauthn_credential_id'],
        'public_key': value['public_key'],
        'attestation_type': value['attestation_type'],
        'authenticator': (0, $9fa6ac2ebfc2a6d3$export$870360f2c096bfed)(value['authenticator'])
    };
}



function $735552acd4af7c28$export$f26a9e2b3d2f2072(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}
function $735552acd4af7c28$export$c9a598d53e893d16(json) {
    return $735552acd4af7c28$export$5d6142ad79969801(json, false);
}
function $735552acd4af7c28$export$5d6142ad79969801(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : new Date(json['last_used']),
        'type': (0, $59e949b392b8d9ae$export$7bbec83240b0eeeb)(json['type']),
        'params': (0, $c68db1e5a957affb$export$cb838a8294c45d7f)(json['params']),
        'label': json['label'] == null ? undefined : json['label']
    };
}
function $735552acd4af7c28$export$decc37720e3eadc2(json) {
    return $735552acd4af7c28$export$f821672394c31fd2(json, false);
}
function $735552acd4af7c28$export$f821672394c31fd2(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
        'type': (0, $59e949b392b8d9ae$export$ee7a066c014b3dac)(value['type']),
        'params': (0, $c68db1e5a957affb$export$37444c8007920ed9)(value['params']),
        'label': value['label']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $9512c11b4c198097$export$f1738de301e3f9a2(value) {
    if (!('recovery_codes_total' in value) || value['recovery_codes_total'] === undefined) return false;
    if (!('recovery_codes_unused' in value) || value['recovery_codes_unused'] === undefined) return false;
    return true;
}
function $9512c11b4c198097$export$d2d4f1400f80c95b(json) {
    return $9512c11b4c198097$export$bb2c141edaac59b1(json, false);
}
function $9512c11b4c198097$export$bb2c141edaac59b1(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'recovery_codes_total': json['recovery_codes_total'],
        'recovery_codes_unused': json['recovery_codes_unused']
    };
}
function $9512c11b4c198097$export$da68635ae58103ed(json) {
    return $9512c11b4c198097$export$39cb84dc13512678(json, false);
}
function $9512c11b4c198097$export$39cb84dc13512678(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'recovery_codes_total': value['recovery_codes_total'],
        'recovery_codes_unused': value['recovery_codes_unused']
    };
}



function $d27f09d8d26cb280$export$24f4b3307e2ab25b(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}
function $d27f09d8d26cb280$export$ff6258564bd26741(json) {
    return $d27f09d8d26cb280$export$7b628c1266e614e0(json, false);
}
function $d27f09d8d26cb280$export$7b628c1266e614e0(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : new Date(json['last_used']),
        'type': (0, $59e949b392b8d9ae$export$7bbec83240b0eeeb)(json['type']),
        'params': (0, $9512c11b4c198097$export$d2d4f1400f80c95b)(json['params']),
        'label': json['label'] == null ? undefined : json['label']
    };
}
function $d27f09d8d26cb280$export$b7b351f4dd4a219c(json) {
    return $d27f09d8d26cb280$export$aeaed92d0c42792(json, false);
}
function $d27f09d8d26cb280$export$aeaed92d0c42792(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
        'type': (0, $59e949b392b8d9ae$export$ee7a066c014b3dac)(value['type']),
        'params': (0, $9512c11b4c198097$export$da68635ae58103ed)(value['params']),
        'label': value['label']
    };
}


function $05cb816b97d06baf$export$3724b7510e24ce33(json) {
    return $05cb816b97d06baf$export$7c9a38e4a1e85b4b(json, false);
}
function $05cb816b97d06baf$export$7c9a38e4a1e85b4b(json, ignoreDiscriminator) {
    if (json == null) return json;
    switch(json['type']){
        case 'password':
            return Object.assign({}, (0, $952c88990da1f478$export$15f2d4eabe16d54e)(json, true), {
                type: 'password'
            });
        case 'public-key':
            return Object.assign({}, (0, $735552acd4af7c28$export$5d6142ad79969801)(json, true), {
                type: 'public-key'
            });
        case 'totp':
            return Object.assign({}, (0, $d27f09d8d26cb280$export$7b628c1266e614e0)(json, true), {
                type: 'totp'
            });
        default:
            return json;
    }
}
function $05cb816b97d06baf$export$79e5093d45899443(json) {
    return $05cb816b97d06baf$export$49ab9b200bc34424(json, false);
}
function $05cb816b97d06baf$export$49ab9b200bc34424(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    switch(value['type']){
        case 'password':
            return Object.assign({}, (0, $952c88990da1f478$export$950a6b723fe0c8d1)(value), {
                type: 'password'
            });
        case 'public-key':
            return Object.assign({}, (0, $735552acd4af7c28$export$decc37720e3eadc2)(value), {
                type: 'public-key'
            });
        case 'totp':
            return Object.assign({}, (0, $d27f09d8d26cb280$export$b7b351f4dd4a219c)(value), {
                type: 'totp'
            });
        default:
            return value;
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $06d8b53811848e68$export$b1f97c3099fc6872 = {
    UsIowa: 'us-iowa',
    EuropeBelgium: 'europe-belgium',
    AsiaJapan: 'asia-japan',
    EuropeEngland: 'europe-england',
    AustraliaSydney: 'australia-sydney'
};
function $06d8b53811848e68$export$f0335584b9915855(value) {
    for(const key in $06d8b53811848e68$export$b1f97c3099fc6872)if (Object.prototype.hasOwnProperty.call($06d8b53811848e68$export$b1f97c3099fc6872, key)) {
        if ($06d8b53811848e68$export$b1f97c3099fc6872[key] === value) return true;
    }
    return false;
}
function $06d8b53811848e68$export$4599c92435bbba6e(json) {
    return $06d8b53811848e68$export$9f38cecf57c7d495(json, false);
}
function $06d8b53811848e68$export$9f38cecf57c7d495(json, ignoreDiscriminator) {
    return json;
}
function $06d8b53811848e68$export$2ac40160f30291ff(value) {
    return value;
}
function $06d8b53811848e68$export$592fc463f49b806a(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $eb92675354d724ac$export$885886f088cd0586 = {
    EmailAddress: 'email_address',
    PhoneNumber: 'phone_number',
    Username: 'username'
};
function $eb92675354d724ac$export$ac694eef92b7ad67(value) {
    for(const key in $eb92675354d724ac$export$885886f088cd0586)if (Object.prototype.hasOwnProperty.call($eb92675354d724ac$export$885886f088cd0586, key)) {
        if ($eb92675354d724ac$export$885886f088cd0586[key] === value) return true;
    }
    return false;
}
function $eb92675354d724ac$export$4298639bc743d812(json) {
    return $eb92675354d724ac$export$a40e0eed0469a814(json, false);
}
function $eb92675354d724ac$export$a40e0eed0469a814(json, ignoreDiscriminator) {
    return json;
}
function $eb92675354d724ac$export$501f062f75ed6632(value) {
    return value;
}
function $eb92675354d724ac$export$74c26ffdfbea8dcd(value, ignoreDiscriminator) {
    return value;
}


function $0465af89d7cf9aa3$export$fe8bf34cf162832e(value) {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}
function $0465af89d7cf9aa3$export$11c41aa448e0ad82(json) {
    return $0465af89d7cf9aa3$export$68e40d7b475f3dd1(json, false);
}
function $0465af89d7cf9aa3$export$68e40d7b475f3dd1(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'type': (0, $eb92675354d724ac$export$4298639bc743d812)(json['type']),
        'value': json['value']
    };
}
function $0465af89d7cf9aa3$export$82ff335443c9930(json) {
    return $0465af89d7cf9aa3$export$49805c62be8724df(json, false);
}
function $0465af89d7cf9aa3$export$49805c62be8724df(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'type': (0, $eb92675354d724ac$export$501f062f75ed6632)(value['type']),
        'value': value['value']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $7fdfe1d233bd281f$export$8a4bc00e165db472 = {
    Regular: 'regular',
    Anonymous: 'anonymous'
};
function $7fdfe1d233bd281f$export$476e3b4e57073f53(value) {
    for(const key in $7fdfe1d233bd281f$export$8a4bc00e165db472)if (Object.prototype.hasOwnProperty.call($7fdfe1d233bd281f$export$8a4bc00e165db472, key)) {
        if ($7fdfe1d233bd281f$export$8a4bc00e165db472[key] === value) return true;
    }
    return false;
}
function $7fdfe1d233bd281f$export$851ad6a45f8bc66(json) {
    return $7fdfe1d233bd281f$export$27c7bcdfbe0df6dc(json, false);
}
function $7fdfe1d233bd281f$export$27c7bcdfbe0df6dc(json, ignoreDiscriminator) {
    return json;
}
function $7fdfe1d233bd281f$export$5bebd3993c7ac4e8(value) {
    return value;
}
function $7fdfe1d233bd281f$export$d4d1e2bbf5f3364b(value, ignoreDiscriminator) {
    return value;
}


function $9f19915761c92516$export$ccf05bcd0a2c5126(value) {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('person_type' in value) || value['person_type'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    return true;
}
function $9f19915761c92516$export$7a11cc6365c7aa2d(json) {
    return $9f19915761c92516$export$43fdfaf085711574(json, false);
}
function $9f19915761c92516$export$43fdfaf085711574(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'active': json['active'],
        'person_id': json['person_id'],
        'person_type': (0, $7fdfe1d233bd281f$export$851ad6a45f8bc66)(json['person_type']),
        'region': (0, $06d8b53811848e68$export$4599c92435bbba6e)(json['region']),
        'handles': json['handles'] == null ? undefined : json['handles'].map((0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)),
        'groups': json['groups'] == null ? undefined : json['groups'],
        'attributes': json['attributes'] == null ? undefined : json['attributes']
    };
}
function $9f19915761c92516$export$44957b028259275f(json) {
    return $9f19915761c92516$export$72456cc4893540f(json, false);
}
function $9f19915761c92516$export$72456cc4893540f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'active': value['active'],
        'person_id': value['person_id'],
        'person_type': (0, $7fdfe1d233bd281f$export$5bebd3993c7ac4e8)(value['person_type']),
        'region': (0, $06d8b53811848e68$export$2ac40160f30291ff)(value['region']),
        'handles': value['handles'] == null ? undefined : value['handles'].map((0, $0465af89d7cf9aa3$export$82ff335443c9930)),
        'groups': value['groups'],
        'attributes': value['attributes']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $f5527863b82344a2$export$ae4845536494fe7b(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('org_name' in value) || value['org_name'] === undefined) return false;
    if (!('tenant_name' in value) || value['tenant_name'] === undefined) return false;
    return true;
}
function $f5527863b82344a2$export$3638d863f491f1bd(json) {
    return $f5527863b82344a2$export$796c1adabeaa853a(json, false);
}
function $f5527863b82344a2$export$796c1adabeaa853a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'org_name': json['org_name'],
        'tenant_name': json['tenant_name']
    };
}
function $f5527863b82344a2$export$4148c267d26f471c(json) {
    return $f5527863b82344a2$export$e4492db26e2b1738(json, false);
}
function $f5527863b82344a2$export$e4492db26e2b1738(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'parent_id': value['parent_id'],
        'org_name': value['org_name'],
        'tenant_name': value['tenant_name']
    };
}


function $43de6fbde2994a71$export$380d898eedd33f73(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('org_name' in value) || value['org_name'] === undefined) return false;
    if (!('tenant_name' in value) || value['tenant_name'] === undefined) return false;
    return true;
}
function $43de6fbde2994a71$export$e3c48c2a714dee12(json) {
    return $43de6fbde2994a71$export$18255b16eead3caf(json, false);
}
function $43de6fbde2994a71$export$18255b16eead3caf(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'org_name': json['org_name'],
        'tenant_name': json['tenant_name'],
        'managed_organizations': json['managed_organizations'] == null ? undefined : json['managed_organizations'].map((0, $f5527863b82344a2$export$3638d863f491f1bd))
    };
}
function $43de6fbde2994a71$export$7173796126a26aa2(json) {
    return $43de6fbde2994a71$export$3b2823076a85867(json, false);
}
function $43de6fbde2994a71$export$3b2823076a85867(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'parent_id': value['parent_id'],
        'org_name': value['org_name'],
        'tenant_name': value['tenant_name'],
        'managed_organizations': value['managed_organizations'] == null ? undefined : value['managed_organizations'].map((0, $f5527863b82344a2$export$4148c267d26f471c))
    };
}



function $0a8d2f5852208ef0$export$e1acc152de27b1c1(value) {
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('organizations' in value) || value['organizations'] === undefined) return false;
    if (!('handles' in value) || value['handles'] === undefined) return false;
    if (!('credentials' in value) || value['credentials'] === undefined) return false;
    return true;
}
function $0a8d2f5852208ef0$export$4acec490369f0cc7(json) {
    return $0a8d2f5852208ef0$export$7f6a248c6f964d4a(json, false);
}
function $0a8d2f5852208ef0$export$7f6a248c6f964d4a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'person': (0, $9f19915761c92516$export$7a11cc6365c7aa2d)(json['person']),
        'organizations': json['organizations'].map((0, $43de6fbde2994a71$export$e3c48c2a714dee12)),
        'handles': json['handles'].map((0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)),
        'credentials': json['credentials'].map((0, $05cb816b97d06baf$export$3724b7510e24ce33))
    };
}
function $0a8d2f5852208ef0$export$70aee247e356fb65(json) {
    return $0a8d2f5852208ef0$export$a4baeb0d53b3f630(json, false);
}
function $0a8d2f5852208ef0$export$a4baeb0d53b3f630(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'person': (0, $9f19915761c92516$export$44957b028259275f)(value['person']),
        'organizations': value['organizations'].map((0, $43de6fbde2994a71$export$7173796126a26aa2)),
        'handles': value['handles'].map((0, $0465af89d7cf9aa3$export$82ff335443c9930)),
        'credentials': value['credentials'].map((0, $05cb816b97d06baf$export$79e5093d45899443))
    };
}




function $ed9d956b3734a4a3$export$c01002c6bb4b91f7(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $ed9d956b3734a4a3$export$bfd68bd3621b7ea1(json) {
    return $ed9d956b3734a4a3$export$9f278e8bd0ab65d2(json, false);
}
function $ed9d956b3734a4a3$export$9f278e8bd0ab65d2(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $0a8d2f5852208ef0$export$4acec490369f0cc7)(json['result'])
    };
}
function $ed9d956b3734a4a3$export$56dc6bc5985d68ce(json) {
    return $ed9d956b3734a4a3$export$2cee35956d4b5fdb(json, false);
}
function $ed9d956b3734a4a3$export$2cee35956d4b5fdb(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $0a8d2f5852208ef0$export$70aee247e356fb65)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $996a9597c455d35b$export$4c9244d88606dd5f(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('person_in_manager_org' in value) || value['person_in_manager_org'] === undefined) return false;
    if (!('inherits_rbac_pools' in value) || value['inherits_rbac_pools'] === undefined) return false;
    return true;
}
function $996a9597c455d35b$export$4032857d9d6cfa90(json) {
    return $996a9597c455d35b$export$feea96848bf6090d(json, false);
}
function $996a9597c455d35b$export$feea96848bf6090d(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'tenant_name': json['tenant_name'] == null ? undefined : json['tenant_name'],
        'children_ids': json['children_ids'] == null ? undefined : json['children_ids'],
        'person_pool_orgs_ids': json['person_pool_orgs_ids'] == null ? undefined : json['person_pool_orgs_ids'],
        'group_pool_orgs_ids': json['group_pool_orgs_ids'] == null ? undefined : json['group_pool_orgs_ids'],
        'manager_org_id': json['manager_org_id'] == null ? undefined : json['manager_org_id'],
        'person_in_manager_org': json['person_in_manager_org'],
        'inherits_rbac_pools': json['inherits_rbac_pools']
    };
}
function $996a9597c455d35b$export$fa8c48380a7e566d(json) {
    return $996a9597c455d35b$export$e0d2e52bc14c84e2(json, false);
}
function $996a9597c455d35b$export$e0d2e52bc14c84e2(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'parent_id': value['parent_id'],
        'name': value['name'],
        'tenant_name': value['tenant_name'],
        'children_ids': value['children_ids'],
        'person_pool_orgs_ids': value['person_pool_orgs_ids'],
        'group_pool_orgs_ids': value['group_pool_orgs_ids'],
        'manager_org_id': value['manager_org_id'],
        'person_in_manager_org': value['person_in_manager_org'],
        'inherits_rbac_pools': value['inherits_rbac_pools']
    };
}


function $68d1ee6398e88afc$export$4bcb03c429977631(value) {
    if (!('org_hierarchy' in value) || value['org_hierarchy'] === undefined) return false;
    return true;
}
function $68d1ee6398e88afc$export$303d3c6c1e2974a0(json) {
    return $68d1ee6398e88afc$export$5206ec56be0af3f8(json, false);
}
function $68d1ee6398e88afc$export$5206ec56be0af3f8(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'org_hierarchy': json['org_hierarchy'].map((0, $996a9597c455d35b$export$4032857d9d6cfa90))
    };
}
function $68d1ee6398e88afc$export$378ea2f47d6ece9a(json) {
    return $68d1ee6398e88afc$export$eedddcdda77ee9f5(json, false);
}
function $68d1ee6398e88afc$export$eedddcdda77ee9f5(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'org_hierarchy': value['org_hierarchy'].map((0, $996a9597c455d35b$export$fa8c48380a7e566d))
    };
}



function $181b533581b4dbbd$export$fb32339ab4ad0eb0(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $181b533581b4dbbd$export$8a5bc1b2ff07b739(json) {
    return $181b533581b4dbbd$export$65732506bc8ed250(json, false);
}
function $181b533581b4dbbd$export$65732506bc8ed250(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $68d1ee6398e88afc$export$303d3c6c1e2974a0)(json['result'])
    };
}
function $181b533581b4dbbd$export$135bb7361b756151(json) {
    return $181b533581b4dbbd$export$b685336c9078196d(json, false);
}
function $181b533581b4dbbd$export$b685336c9078196d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $68d1ee6398e88afc$export$378ea2f47d6ece9a)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $44461f186c6840c6$export$37c977f9cc434ffa = {
    Token: 'token',
    ChallengeList: 'challenge_list'
};
function $44461f186c6840c6$export$71e347c2df96cf17(value) {
    for(const key in $44461f186c6840c6$export$37c977f9cc434ffa)if (Object.prototype.hasOwnProperty.call($44461f186c6840c6$export$37c977f9cc434ffa, key)) {
        if ($44461f186c6840c6$export$37c977f9cc434ffa[key] === value) return true;
    }
    return false;
}
function $44461f186c6840c6$export$4506231523ce8e94(json) {
    return $44461f186c6840c6$export$67f03d17a7e009c(json, false);
}
function $44461f186c6840c6$export$67f03d17a7e009c(json, ignoreDiscriminator) {
    return json;
}
function $44461f186c6840c6$export$e72937a457473649(value) {
    return value;
}
function $44461f186c6840c6$export$8bea604e1b996813(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Allowed login factor.
 * 
 * `hook` is a placeholder rather than a real factor: the organization's `identify_user`
 * synchronous webhook decides the actual factor (and possibly the organization). When no
 * webhook resolves a factor for the identifier, `POST /id/v2` answers 401 and the caller
 * should fall back to offering regular factors. `hook` takes no options and is only
 * meaningful on `POST /id/v2`.
 * @export
 */ const $6b68392b32751678$export$8279f5e63c6521d8 = {
    Webauthn: 'webauthn',
    EmailLink: 'email_link',
    SmsLink: 'sms_link',
    OtpViaSms: 'otp_via_sms',
    OtpViaEmail: 'otp_via_email',
    Totp: 'totp',
    Oidc: 'oidc',
    Saml: 'saml',
    Api: 'api',
    DirectId: 'direct_id',
    Password: 'password',
    Impersonate: 'impersonate',
    Anonymous: 'anonymous',
    Hook: 'hook'
};
function $6b68392b32751678$export$8ae48b66a4ccdcc0(value) {
    for(const key in $6b68392b32751678$export$8279f5e63c6521d8)if (Object.prototype.hasOwnProperty.call($6b68392b32751678$export$8279f5e63c6521d8, key)) {
        if ($6b68392b32751678$export$8279f5e63c6521d8[key] === value) return true;
    }
    return false;
}
function $6b68392b32751678$export$67789e1d0e9f3dc1(json) {
    return $6b68392b32751678$export$db3563c2b590c7be(json, false);
}
function $6b68392b32751678$export$db3563c2b590c7be(json, ignoreDiscriminator) {
    return json;
}
function $6b68392b32751678$export$6eefe3f1006b48e7(value) {
    return value;
}
function $6b68392b32751678$export$66b97b9774071895(value, ignoreDiscriminator) {
    return value;
}


function $5c75d744a4c703e5$export$970f02a6ce675a69(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $5c75d744a4c703e5$export$3f9239ada79a5958(json) {
    return $5c75d744a4c703e5$export$86c6648ad39ee43e(json, false);
}
function $5c75d744a4c703e5$export$86c6648ad39ee43e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target']
    };
}
function $5c75d744a4c703e5$export$39b54d7983c93bbb(json) {
    return $5c75d744a4c703e5$export$4f136112bae9197d(json, false);
}
function $5c75d744a4c703e5$export$4f136112bae9197d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method']),
        'redirect_target': value['redirect_target']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $2599bef0214e7f21$export$172b5d8a8e029451(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $2599bef0214e7f21$export$632658e08c8f0241(json) {
    return $2599bef0214e7f21$export$7a10806d64236c45(json, false);
}
function $2599bef0214e7f21$export$7a10806d64236c45(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method'])
    };
}
function $2599bef0214e7f21$export$c1e2da39acf3cb65(json) {
    return $2599bef0214e7f21$export$1a18de7e88a398a5(json, false);
}
function $2599bef0214e7f21$export$1a18de7e88a398a5(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Determines how the OIDC login page is presented to the user; defaults to popup.
 * @export
 */ const $24233137c2c49c70$export$947f28fa7e24f5f5 = {
    Popup: 'popup',
    Redirect: 'redirect'
};
function $24233137c2c49c70$export$a4f46bd7620472d6(value) {
    for(const key in $24233137c2c49c70$export$947f28fa7e24f5f5)if (Object.prototype.hasOwnProperty.call($24233137c2c49c70$export$947f28fa7e24f5f5, key)) {
        if ($24233137c2c49c70$export$947f28fa7e24f5f5[key] === value) return true;
    }
    return false;
}
function $24233137c2c49c70$export$1565a9e6f4df9f73(json) {
    return $24233137c2c49c70$export$24cd40860efc684b(json, false);
}
function $24233137c2c49c70$export$24cd40860efc684b(json, ignoreDiscriminator) {
    return json;
}
function $24233137c2c49c70$export$970d15fc8587f099(value) {
    return value;
}
function $24233137c2c49c70$export$96f989911cafebb(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $e7f514e9ec7972cd$export$96d4e4cf27d59030 = {
    Google: 'google',
    Github: 'github',
    Bitbucket: 'bitbucket',
    Gitlab: 'gitlab',
    Facebook: 'facebook',
    Line: 'line',
    Azuread: 'azuread',
    Okta: 'okta',
    Apple: 'apple'
};
function $e7f514e9ec7972cd$export$48acce43b1ffffee(value) {
    for(const key in $e7f514e9ec7972cd$export$96d4e4cf27d59030)if (Object.prototype.hasOwnProperty.call($e7f514e9ec7972cd$export$96d4e4cf27d59030, key)) {
        if ($e7f514e9ec7972cd$export$96d4e4cf27d59030[key] === value) return true;
    }
    return false;
}
function $e7f514e9ec7972cd$export$272e68d050da029c(json) {
    return $e7f514e9ec7972cd$export$2ec5a77196a86283(json, false);
}
function $e7f514e9ec7972cd$export$2ec5a77196a86283(json, ignoreDiscriminator) {
    return json;
}
function $e7f514e9ec7972cd$export$a580c37c81d39e5c(value) {
    return value;
}
function $e7f514e9ec7972cd$export$dded3a6ba48ec9a4(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Determines whether the OIDC call should fetch groups data.
 * @export
 */ const $0c62e5dff62cd06e$export$940d1b18414d4add = {
    True: 'true',
    False: 'false'
};
function $0c62e5dff62cd06e$export$e4565c1cef2ae090(value) {
    for(const key in $0c62e5dff62cd06e$export$940d1b18414d4add)if (Object.prototype.hasOwnProperty.call($0c62e5dff62cd06e$export$940d1b18414d4add, key)) {
        if ($0c62e5dff62cd06e$export$940d1b18414d4add[key] === value) return true;
    }
    return false;
}
function $0c62e5dff62cd06e$export$ae2357be849f0edb(json) {
    return $0c62e5dff62cd06e$export$c74e2e8e7051ac34(json, false);
}
function $0c62e5dff62cd06e$export$c74e2e8e7051ac34(json, ignoreDiscriminator) {
    return json;
}
function $0c62e5dff62cd06e$export$b42e5b86fe0f6b7a(value) {
    return value;
}
function $0c62e5dff62cd06e$export$23e8a3649f69e00a(value, ignoreDiscriminator) {
    return value;
}


function $6d55aae495918ebc$export$4f622a4d4faaed73(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    return true;
}
function $6d55aae495918ebc$export$55789d35f259e162(json) {
    return $6d55aae495918ebc$export$9a6f82502338cf90(json, false);
}
function $6d55aae495918ebc$export$9a6f82502338cf90(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method']),
        'client_id': json['client_id'],
        'provider': (0, $e7f514e9ec7972cd$export$272e68d050da029c)(json['provider']),
        'ux_mode': json['ux_mode'] == null ? undefined : (0, $24233137c2c49c70$export$1565a9e6f4df9f73)(json['ux_mode']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target'],
        'requires_groups': json['requires_groups'] == null ? undefined : (0, $0c62e5dff62cd06e$export$ae2357be849f0edb)(json['requires_groups']),
        'pkce_code_challenge': json['pkce_code_challenge'] == null ? undefined : json['pkce_code_challenge'],
        'csrf_token': json['csrf_token'] == null ? undefined : json['csrf_token']
    };
}
function $6d55aae495918ebc$export$c452db75c4efa107(json) {
    return $6d55aae495918ebc$export$2e74158629c3418d(json, false);
}
function $6d55aae495918ebc$export$2e74158629c3418d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method']),
        'client_id': value['client_id'],
        'provider': (0, $e7f514e9ec7972cd$export$a580c37c81d39e5c)(value['provider']),
        'ux_mode': (0, $24233137c2c49c70$export$970d15fc8587f099)(value['ux_mode']),
        'redirect_target': value['redirect_target'],
        'requires_groups': (0, $0c62e5dff62cd06e$export$b42e5b86fe0f6b7a)(value['requires_groups']),
        'pkce_code_challenge': value['pkce_code_challenge'],
        'csrf_token': value['csrf_token']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $13b1c70ddfbd9f16$export$8c25ea31c0257dee(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $13b1c70ddfbd9f16$export$344e23d4f22c0c7b(json) {
    return $13b1c70ddfbd9f16$export$8d57634ad9c9264(json, false);
}
function $13b1c70ddfbd9f16$export$8d57634ad9c9264(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method'])
    };
}
function $13b1c70ddfbd9f16$export$37d30c38263c9a87(json) {
    return $13b1c70ddfbd9f16$export$605d09dc8510a755(json, false);
}
function $13b1c70ddfbd9f16$export$605d09dc8510a755(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $81743bb5af56220b$export$bab6ab7a5bd0d76a(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $81743bb5af56220b$export$2c8e130c1f24a472(json) {
    return $81743bb5af56220b$export$a568fb9d80f2262f(json, false);
}
function $81743bb5af56220b$export$a568fb9d80f2262f(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method'])
    };
}
function $81743bb5af56220b$export$f9288874575eda39(json) {
    return $81743bb5af56220b$export$b9358923bde40055(json, false);
}
function $81743bb5af56220b$export$b9358923bde40055(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $256e0cfab1cb46eb$export$ce64efd41c88f0cd(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $256e0cfab1cb46eb$export$39720b9a738a1119(json) {
    return $256e0cfab1cb46eb$export$5286999a970dc62c(json, false);
}
function $256e0cfab1cb46eb$export$5286999a970dc62c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method'])
    };
}
function $256e0cfab1cb46eb$export$26f4d7f6c522321c(json) {
    return $256e0cfab1cb46eb$export$b9a9bb7bd4094097(json, false);
}
function $256e0cfab1cb46eb$export$b9a9bb7bd4094097(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Determines how the SSO login page is presented to the user; defaults to popup.
 * @export
 */ const $f60351fa401f4ee9$export$6dc0f627c99c13a9 = {
    Popup: 'popup',
    Redirect: 'redirect'
};
function $f60351fa401f4ee9$export$a5c193f240fe2b8b(value) {
    for(const key in $f60351fa401f4ee9$export$6dc0f627c99c13a9)if (Object.prototype.hasOwnProperty.call($f60351fa401f4ee9$export$6dc0f627c99c13a9, key)) {
        if ($f60351fa401f4ee9$export$6dc0f627c99c13a9[key] === value) return true;
    }
    return false;
}
function $f60351fa401f4ee9$export$9f582d126e097dfd(json) {
    return $f60351fa401f4ee9$export$be52b3ff0e8c895d(json, false);
}
function $f60351fa401f4ee9$export$be52b3ff0e8c895d(json, ignoreDiscriminator) {
    return json;
}
function $f60351fa401f4ee9$export$bac7eaac8cc3a2f6(value) {
    return value;
}
function $f60351fa401f4ee9$export$e2d86a070381c50e(value, ignoreDiscriminator) {
    return value;
}



function $c873d75fad9a12b2$export$a75b0e545407f1d9(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('provider_credentials_id' in value) || value['provider_credentials_id'] === undefined) return false;
    return true;
}
function $c873d75fad9a12b2$export$f5a4bb1f0d9842b5(json) {
    return $c873d75fad9a12b2$export$29382291ad0763af(json, false);
}
function $c873d75fad9a12b2$export$29382291ad0763af(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method']),
        'provider_credentials_id': json['provider_credentials_id'],
        'ux_mode': json['ux_mode'] == null ? undefined : (0, $f60351fa401f4ee9$export$9f582d126e097dfd)(json['ux_mode']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target'],
        'pkce_code_challenge': json['pkce_code_challenge'] == null ? undefined : json['pkce_code_challenge'],
        'csrf_token': json['csrf_token'] == null ? undefined : json['csrf_token']
    };
}
function $c873d75fad9a12b2$export$a811b2d26736ed97(json) {
    return $c873d75fad9a12b2$export$37db4fbaf9d79873(json, false);
}
function $c873d75fad9a12b2$export$37db4fbaf9d79873(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method']),
        'provider_credentials_id': value['provider_credentials_id'],
        'ux_mode': (0, $f60351fa401f4ee9$export$bac7eaac8cc3a2f6)(value['ux_mode']),
        'redirect_target': value['redirect_target'],
        'pkce_code_challenge': value['pkce_code_challenge'],
        'csrf_token': value['csrf_token']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $abdc748ed4fe1662$export$d320fa6a297c990e(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $abdc748ed4fe1662$export$3b0c6c72db8bb60e(json) {
    return $abdc748ed4fe1662$export$d9e33269b3ce3ef5(json, false);
}
function $abdc748ed4fe1662$export$d9e33269b3ce3ef5(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target']
    };
}
function $abdc748ed4fe1662$export$1a7803bb6cb3450b(json) {
    return $abdc748ed4fe1662$export$e55e2cd36865fa83(json, false);
}
function $abdc748ed4fe1662$export$e55e2cd36865fa83(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method']),
        'redirect_target': value['redirect_target']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $8f8771acf3845f88$export$ec638b545a706bf7(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $8f8771acf3845f88$export$268eac4d8ebc266f(json) {
    return $8f8771acf3845f88$export$f72eeb70c589fe28(json, false);
}
function $8f8771acf3845f88$export$f72eeb70c589fe28(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method'])
    };
}
function $8f8771acf3845f88$export$7414add94b20f6f6(json) {
    return $8f8771acf3845f88$export$fc7c3e0dae6474e7(json, false);
}
function $8f8771acf3845f88$export$fc7c3e0dae6474e7(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $2f59d893d3ed77d4$export$df3e12f65ba023ba = {
    Discouraged: 'discouraged',
    Preferred: 'preferred',
    Required: 'required'
};
function $2f59d893d3ed77d4$export$ffb49d6851d2e1e0(value) {
    for(const key in $2f59d893d3ed77d4$export$df3e12f65ba023ba)if (Object.prototype.hasOwnProperty.call($2f59d893d3ed77d4$export$df3e12f65ba023ba, key)) {
        if ($2f59d893d3ed77d4$export$df3e12f65ba023ba[key] === value) return true;
    }
    return false;
}
function $2f59d893d3ed77d4$export$48180f46ce0fdeef(json) {
    return $2f59d893d3ed77d4$export$a2a5e890ec53e8c(json, false);
}
function $2f59d893d3ed77d4$export$a2a5e890ec53e8c(json, ignoreDiscriminator) {
    return json;
}
function $2f59d893d3ed77d4$export$ab058d07d3f47953(value) {
    return value;
}
function $2f59d893d3ed77d4$export$15b3ae9098527b8a(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $df7f3daf49d23371$export$51952aaa367c79db = {
    Any: 'any',
    Platform: 'platform',
    CrossPlatform: 'cross_platform'
};
function $df7f3daf49d23371$export$40dd2ee2deb814f1(value) {
    for(const key in $df7f3daf49d23371$export$51952aaa367c79db)if (Object.prototype.hasOwnProperty.call($df7f3daf49d23371$export$51952aaa367c79db, key)) {
        if ($df7f3daf49d23371$export$51952aaa367c79db[key] === value) return true;
    }
    return false;
}
function $df7f3daf49d23371$export$c466d5bdc96128fd(json) {
    return $df7f3daf49d23371$export$29d83669df3c633c(json, false);
}
function $df7f3daf49d23371$export$29d83669df3c633c(json, ignoreDiscriminator) {
    return json;
}
function $df7f3daf49d23371$export$4eab872925fbdd55(value) {
    return value;
}
function $df7f3daf49d23371$export$56d12e9e786354d3(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $9bab85da82296f1a$export$c1ff3c79d2429507 = {
    None: 'none',
    Indirect: 'indirect',
    Direct: 'direct'
};
function $9bab85da82296f1a$export$764aa7751da28903(value) {
    for(const key in $9bab85da82296f1a$export$c1ff3c79d2429507)if (Object.prototype.hasOwnProperty.call($9bab85da82296f1a$export$c1ff3c79d2429507, key)) {
        if ($9bab85da82296f1a$export$c1ff3c79d2429507[key] === value) return true;
    }
    return false;
}
function $9bab85da82296f1a$export$5a312d017eee0d3e(json) {
    return $9bab85da82296f1a$export$e734f3544dd52101(json, false);
}
function $9bab85da82296f1a$export$e734f3544dd52101(json, ignoreDiscriminator) {
    return json;
}
function $9bab85da82296f1a$export$1b6988785f1528c4(value) {
    return value;
}
function $9bab85da82296f1a$export$b2f68476045e0d96(value, ignoreDiscriminator) {
    return value;
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $42e936753c078d49$export$1bc598454e9d0dfc = {
    Discouraged: 'discouraged',
    Preferred: 'preferred',
    Required: 'required'
};
function $42e936753c078d49$export$e0c1a404e5e6dd7f(value) {
    for(const key in $42e936753c078d49$export$1bc598454e9d0dfc)if (Object.prototype.hasOwnProperty.call($42e936753c078d49$export$1bc598454e9d0dfc, key)) {
        if ($42e936753c078d49$export$1bc598454e9d0dfc[key] === value) return true;
    }
    return false;
}
function $42e936753c078d49$export$2f6b567f7a129d2(json) {
    return $42e936753c078d49$export$bf309234c5a66b70(json, false);
}
function $42e936753c078d49$export$bf309234c5a66b70(json, ignoreDiscriminator) {
    return json;
}
function $42e936753c078d49$export$191e871d68094046(value) {
    return value;
}
function $42e936753c078d49$export$48f0b7bf292b90d3(value, ignoreDiscriminator) {
    return value;
}


function $15a11262fa2656a7$export$be6248ff0e0e157f(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $15a11262fa2656a7$export$b6dfeaa8eedeb41b(json) {
    return $15a11262fa2656a7$export$fee9c51fd9d40010(json, false);
}
function $15a11262fa2656a7$export$fee9c51fd9d40010(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method']),
        'scope': json['scope'] == null ? undefined : json['scope'],
        'available_credential_ids': json['available_credential_ids'] == null ? undefined : json['available_credential_ids'],
        'attachment': json['attachment'] == null ? undefined : (0, $df7f3daf49d23371$export$c466d5bdc96128fd)(json['attachment']),
        'user_verification': json['user_verification'] == null ? undefined : (0, $42e936753c078d49$export$2f6b567f7a129d2)(json['user_verification']),
        'resident_key': json['resident_key'] == null ? undefined : (0, $2f59d893d3ed77d4$export$48180f46ce0fdeef)(json['resident_key']),
        'attestation': json['attestation'] == null ? undefined : (0, $9bab85da82296f1a$export$5a312d017eee0d3e)(json['attestation'])
    };
}
function $15a11262fa2656a7$export$143dc34f19152636(json) {
    return $15a11262fa2656a7$export$11478828f29eceb6(json, false);
}
function $15a11262fa2656a7$export$11478828f29eceb6(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method']),
        'scope': value['scope'],
        'available_credential_ids': value['available_credential_ids'],
        'attachment': (0, $df7f3daf49d23371$export$4eab872925fbdd55)(value['attachment']),
        'user_verification': (0, $42e936753c078d49$export$191e871d68094046)(value['user_verification']),
        'resident_key': (0, $2f59d893d3ed77d4$export$ab058d07d3f47953)(value['resident_key']),
        'attestation': (0, $9bab85da82296f1a$export$1b6988785f1528c4)(value['attestation'])
    };
}


function $bc738d3a96727711$export$d0c68b16e37ea6b7(json) {
    return $bc738d3a96727711$export$35996414b62a8dd5(json, false);
}
function $bc738d3a96727711$export$35996414b62a8dd5(json, ignoreDiscriminator) {
    if (json == null) return json;
    switch(json['method']){
        case 'email_link':
            return Object.assign({}, (0, $5c75d744a4c703e5$export$86c6648ad39ee43e)(json, true), {
                method: 'email_link'
            });
        case 'hook':
            return Object.assign({}, (0, $2599bef0214e7f21$export$7a10806d64236c45)(json, true), {
                method: 'hook'
            });
        case 'oidc':
            return Object.assign({}, (0, $6d55aae495918ebc$export$9a6f82502338cf90)(json, true), {
                method: 'oidc'
            });
        case 'otp_via_email':
            return Object.assign({}, (0, $13b1c70ddfbd9f16$export$8d57634ad9c9264)(json, true), {
                method: 'otp_via_email'
            });
        case 'otp_via_sms':
            return Object.assign({}, (0, $81743bb5af56220b$export$a568fb9d80f2262f)(json, true), {
                method: 'otp_via_sms'
            });
        case 'password':
            return Object.assign({}, (0, $256e0cfab1cb46eb$export$5286999a970dc62c)(json, true), {
                method: 'password'
            });
        case 'saml':
            return Object.assign({}, (0, $c873d75fad9a12b2$export$29382291ad0763af)(json, true), {
                method: 'saml'
            });
        case 'sms_link':
            return Object.assign({}, (0, $abdc748ed4fe1662$export$d9e33269b3ce3ef5)(json, true), {
                method: 'sms_link'
            });
        case 'totp':
            return Object.assign({}, (0, $8f8771acf3845f88$export$f72eeb70c589fe28)(json, true), {
                method: 'totp'
            });
        case 'webauthn':
            return Object.assign({}, (0, $15a11262fa2656a7$export$fee9c51fd9d40010)(json, true), {
                method: 'webauthn'
            });
        default:
            return json;
    }
}
function $bc738d3a96727711$export$ba0c7e27b8aa00e(json) {
    return $bc738d3a96727711$export$fff16f26e72aeafd(json, false);
}
function $bc738d3a96727711$export$fff16f26e72aeafd(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    switch(value['method']){
        case 'email_link':
            return Object.assign({}, (0, $5c75d744a4c703e5$export$39b54d7983c93bbb)(value), {
                method: 'email_link'
            });
        case 'hook':
            return Object.assign({}, (0, $2599bef0214e7f21$export$c1e2da39acf3cb65)(value), {
                method: 'hook'
            });
        case 'oidc':
            return Object.assign({}, (0, $6d55aae495918ebc$export$c452db75c4efa107)(value), {
                method: 'oidc'
            });
        case 'otp_via_email':
            return Object.assign({}, (0, $13b1c70ddfbd9f16$export$37d30c38263c9a87)(value), {
                method: 'otp_via_email'
            });
        case 'otp_via_sms':
            return Object.assign({}, (0, $81743bb5af56220b$export$f9288874575eda39)(value), {
                method: 'otp_via_sms'
            });
        case 'password':
            return Object.assign({}, (0, $256e0cfab1cb46eb$export$26f4d7f6c522321c)(value), {
                method: 'password'
            });
        case 'saml':
            return Object.assign({}, (0, $c873d75fad9a12b2$export$a811b2d26736ed97)(value), {
                method: 'saml'
            });
        case 'sms_link':
            return Object.assign({}, (0, $abdc748ed4fe1662$export$1a7803bb6cb3450b)(value), {
                method: 'sms_link'
            });
        case 'totp':
            return Object.assign({}, (0, $8f8771acf3845f88$export$7414add94b20f6f6)(value), {
                method: 'totp'
            });
        case 'webauthn':
            return Object.assign({}, (0, $15a11262fa2656a7$export$143dc34f19152636)(value), {
                method: 'webauthn'
            });
        default:
            return value;
    }
}



function $7b9a0cb8e9dc2f71$export$e5c50aee111b9e06(value) {
    return true;
}
function $7b9a0cb8e9dc2f71$export$f532260b06e67d79(json) {
    return $7b9a0cb8e9dc2f71$export$46af48a00ab1f3b5(json, false);
}
function $7b9a0cb8e9dc2f71$export$46af48a00ab1f3b5(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': json['method'] == null ? undefined : (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method']),
        'options': json['options'] == null ? undefined : (0, $bc738d3a96727711$export$d0c68b16e37ea6b7)(json['options'])
    };
}
function $7b9a0cb8e9dc2f71$export$288f5f309e052c1d(json) {
    return $7b9a0cb8e9dc2f71$export$57172ba47627fae3(json, false);
}
function $7b9a0cb8e9dc2f71$export$57172ba47627fae3(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method']),
        'options': (0, $bc738d3a96727711$export$ba0c7e27b8aa00e)(value['options'])
    };
}


function $38c6a96b820cbc38$export$3867aea3709e6d5c(value) {
    if (!('target_org_id' in value) || value['target_org_id'] === undefined) return false;
    return true;
}
function $38c6a96b820cbc38$export$c5e83b69854f0282(json) {
    return $38c6a96b820cbc38$export$e876b8b22e45a012(json, false);
}
function $38c6a96b820cbc38$export$e876b8b22e45a012(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'target_org_id': json['target_org_id'],
        'factor': json['factor'] == null ? undefined : (0, $7b9a0cb8e9dc2f71$export$f532260b06e67d79)(json['factor'])
    };
}
function $38c6a96b820cbc38$export$7ea90c6e05c22e43(json) {
    return $38c6a96b820cbc38$export$2215b7c03c8d376(json, false);
}
function $38c6a96b820cbc38$export$2215b7c03c8d376(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'target_org_id': value['target_org_id'],
        'factor': (0, $7b9a0cb8e9dc2f71$export$288f5f309e052c1d)(value['factor'])
    };
}




function $9e2b90df161804ab$export$8c528054ac1973bd(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}
function $9e2b90df161804ab$export$8d335ca8241b9f4e(json) {
    return $9e2b90df161804ab$export$c7b869a25b419e6(json, false);
}
function $9e2b90df161804ab$export$c7b869a25b419e6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': (0, $38c6a96b820cbc38$export$c5e83b69854f0282)(json['options'])
    };
}
function $9e2b90df161804ab$export$1bba6c46c28de3a(json) {
    return $9e2b90df161804ab$export$53f2a1e4c71a9a38(json, false);
}
function $9e2b90df161804ab$export$53f2a1e4c71a9a38(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $38c6a96b820cbc38$export$7ea90c6e05c22e43)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $4d9152dcb1c7f889$export$962ec99ccb777e5d(value) {
    return true;
}
function $4d9152dcb1c7f889$export$fccc5f59fb10fb43(json) {
    return $4d9152dcb1c7f889$export$6ae5a046f2854d1f(json, false);
}
function $4d9152dcb1c7f889$export$6ae5a046f2854d1f(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge': json['challenge'] == null ? undefined : json['challenge']
    };
}
function $4d9152dcb1c7f889$export$5a6bb73c099af14b(json) {
    return $4d9152dcb1c7f889$export$3b2353b87ecab102(json, false);
}
function $4d9152dcb1c7f889$export$3b2353b87ecab102(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge': value['challenge']
    };
}


function $20b7317581980167$export$381060df3b43f694(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $20b7317581980167$export$12bce9f63d0d1b43(json) {
    return $20b7317581980167$export$c89b7013df12088e(json, false);
}
function $20b7317581980167$export$c89b7013df12088e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': json['options'] == null ? undefined : (0, $4d9152dcb1c7f889$export$fccc5f59fb10fb43)(json['options'])
    };
}
function $20b7317581980167$export$e8c577ab91ee698f(json) {
    return $20b7317581980167$export$90f369107e5f8da8(json, false);
}
function $20b7317581980167$export$90f369107e5f8da8(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $4d9152dcb1c7f889$export$5a6bb73c099af14b)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $94e229f37efe2b80$export$eda7d4da6f3d214f(value) {
    if (!('auth_code_url' in value) || value['auth_code_url'] === undefined) return false;
    return true;
}
function $94e229f37efe2b80$export$c53683eed796cca6(json) {
    return $94e229f37efe2b80$export$3bee7ccd7ffe9afb(json, false);
}
function $94e229f37efe2b80$export$3bee7ccd7ffe9afb(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'auth_code_url': json['auth_code_url']
    };
}
function $94e229f37efe2b80$export$b34b72165a81ac38(json) {
    return $94e229f37efe2b80$export$7629ed5ab1675b42(json, false);
}
function $94e229f37efe2b80$export$7629ed5ab1675b42(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'auth_code_url': value['auth_code_url']
    };
}




function $46ff52f5297fe85d$export$c2d3203f268f2103(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}
function $46ff52f5297fe85d$export$12547b38dcf4ab61(json) {
    return $46ff52f5297fe85d$export$52281bb8e2d4eb8a(json, false);
}
function $46ff52f5297fe85d$export$52281bb8e2d4eb8a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': (0, $94e229f37efe2b80$export$c53683eed796cca6)(json['options'])
    };
}
function $46ff52f5297fe85d$export$b237322a72e22d30(json) {
    return $46ff52f5297fe85d$export$67598224400a31b1(json, false);
}
function $46ff52f5297fe85d$export$67598224400a31b1(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $94e229f37efe2b80$export$b34b72165a81ac38)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $91970af08a1e53e9$export$1d66095413b818dc(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $91970af08a1e53e9$export$ba2757049816016b(json) {
    return $91970af08a1e53e9$export$11c938a12b9e7a4e(json, false);
}
function $91970af08a1e53e9$export$11c938a12b9e7a4e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method'])
    };
}
function $91970af08a1e53e9$export$39ee8e97c506a89d(json) {
    return $91970af08a1e53e9$export$4a726dea904a7f34(json, false);
}
function $91970af08a1e53e9$export$4a726dea904a7f34(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $73a3e5155c67d120$export$1bf91e9b22ea6e9c = {
    MustMatch: 'must_match',
    MustNotMatch: 'must_not_match'
};
function $73a3e5155c67d120$export$9d638c5b5e4d58e6(value) {
    for(const key in $73a3e5155c67d120$export$1bf91e9b22ea6e9c)if (Object.prototype.hasOwnProperty.call($73a3e5155c67d120$export$1bf91e9b22ea6e9c, key)) {
        if ($73a3e5155c67d120$export$1bf91e9b22ea6e9c[key] === value) return true;
    }
    return false;
}
function $73a3e5155c67d120$export$211fa31f693d0fc5(json) {
    return $73a3e5155c67d120$export$b53c74a1fbea099b(json, false);
}
function $73a3e5155c67d120$export$b53c74a1fbea099b(json, ignoreDiscriminator) {
    return json;
}
function $73a3e5155c67d120$export$65d68d5d70683e8c(value) {
    return value;
}
function $73a3e5155c67d120$export$3f24c78b59908cb8(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $4765eb42481daa21$export$92654280fa341a19 = {
    Length: 'length',
    PasswordVariants: 'password_variants',
    AdminVariants: 'admin_variants',
    UserVariants: 'user_variants',
    AlphanumericSequences1: 'alphanumeric_sequences_1',
    AlphanumericSequences2: 'alphanumeric_sequences_2',
    NumericSequencesAscending: 'numeric_sequences_ascending',
    NumericSequencesDescending: 'numeric_sequences_descending',
    NumericSubsequencesAscending: 'numeric_subsequences_ascending',
    NumericSubsequencesDescending: 'numeric_subsequences_descending',
    CommonPasswordXkcd: 'common_password_xkcd'
};
function $4765eb42481daa21$export$234c1855055c6b43(value) {
    for(const key in $4765eb42481daa21$export$92654280fa341a19)if (Object.prototype.hasOwnProperty.call($4765eb42481daa21$export$92654280fa341a19, key)) {
        if ($4765eb42481daa21$export$92654280fa341a19[key] === value) return true;
    }
    return false;
}
function $4765eb42481daa21$export$292cf3eb24b36615(json) {
    return $4765eb42481daa21$export$139fad42c8f6d603(json, false);
}
function $4765eb42481daa21$export$139fad42c8f6d603(json, ignoreDiscriminator) {
    return json;
}
function $4765eb42481daa21$export$f789e2ae354140f9(value) {
    return value;
}
function $4765eb42481daa21$export$6ce315cf79f8f120(value, ignoreDiscriminator) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $eb6d83a2d3a4c9f7$export$db87cce2ebf1e21b = {
    CaseInsensitive: 'case_insensitive'
};
function $eb6d83a2d3a4c9f7$export$9281274a758bfb00(value) {
    for(const key in $eb6d83a2d3a4c9f7$export$db87cce2ebf1e21b)if (Object.prototype.hasOwnProperty.call($eb6d83a2d3a4c9f7$export$db87cce2ebf1e21b, key)) {
        if ($eb6d83a2d3a4c9f7$export$db87cce2ebf1e21b[key] === value) return true;
    }
    return false;
}
function $eb6d83a2d3a4c9f7$export$1a54fab7686d0d4d(json) {
    return $eb6d83a2d3a4c9f7$export$1b5003399216bcb9(json, false);
}
function $eb6d83a2d3a4c9f7$export$1b5003399216bcb9(json, ignoreDiscriminator) {
    return json;
}
function $eb6d83a2d3a4c9f7$export$c013f8bf67b81bfd(value) {
    return value;
}
function $eb6d83a2d3a4c9f7$export$2a0dbdb7041fbb82(value, ignoreDiscriminator) {
    return value;
}


function $f2f7f159c1a09eed$export$b52ff546cf6e791e(value) {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('pattern' in value) || value['pattern'] === undefined) return false;
    if (!('match_type' in value) || value['match_type'] === undefined) return false;
    return true;
}
function $f2f7f159c1a09eed$export$60a9211431b11430(json) {
    return $f2f7f159c1a09eed$export$525b06245bd19793(json, false);
}
function $f2f7f159c1a09eed$export$525b06245bd19793(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'name': (0, $4765eb42481daa21$export$292cf3eb24b36615)(json['name']),
        'pattern': json['pattern'],
        'match_type': (0, $73a3e5155c67d120$export$211fa31f693d0fc5)(json['match_type']),
        'pattern_qualifiers': json['pattern_qualifiers'] == null ? undefined : json['pattern_qualifiers'].map((0, $eb6d83a2d3a4c9f7$export$1a54fab7686d0d4d))
    };
}
function $f2f7f159c1a09eed$export$202895c6317b46b(json) {
    return $f2f7f159c1a09eed$export$b1853ffd545665da(json, false);
}
function $f2f7f159c1a09eed$export$b1853ffd545665da(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'name': (0, $4765eb42481daa21$export$f789e2ae354140f9)(value['name']),
        'pattern': value['pattern'],
        'match_type': (0, $73a3e5155c67d120$export$65d68d5d70683e8c)(value['match_type']),
        'pattern_qualifiers': value['pattern_qualifiers'] == null ? undefined : value['pattern_qualifiers'].map((0, $eb6d83a2d3a4c9f7$export$c013f8bf67b81bfd))
    };
}


function $d91550d22670bce3$export$1c758cbe8a736efe(value) {
    return true;
}
function $d91550d22670bce3$export$7fa65e60d0ba4afc(json) {
    return $d91550d22670bce3$export$415672afe02a8c95(json, false);
}
function $d91550d22670bce3$export$415672afe02a8c95(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'regular_expressions': json['regular_expressions'] == null ? undefined : json['regular_expressions'].map((0, $f2f7f159c1a09eed$export$60a9211431b11430))
    };
}
function $d91550d22670bce3$export$6aadfbfa6597f211(json) {
    return $d91550d22670bce3$export$3b8b788b4c46f332(json, false);
}
function $d91550d22670bce3$export$3b8b788b4c46f332(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'regular_expressions': value['regular_expressions'] == null ? undefined : value['regular_expressions'].map((0, $f2f7f159c1a09eed$export$202895c6317b46b))
    };
}


function $f19ad07d16452f15$export$f58e34146dd3c886(value) {
    if (!('validation_rules' in value) || value['validation_rules'] === undefined) return false;
    return true;
}
function $f19ad07d16452f15$export$9e3e7e437375c546(json) {
    return $f19ad07d16452f15$export$a7fcc83d003f1d88(json, false);
}
function $f19ad07d16452f15$export$a7fcc83d003f1d88(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'validation_rules': (0, $d91550d22670bce3$export$7fa65e60d0ba4afc)(json['validation_rules'])
    };
}
function $f19ad07d16452f15$export$6274b0e68c67e72a(json) {
    return $f19ad07d16452f15$export$7b7213604221df7a(json, false);
}
function $f19ad07d16452f15$export$7b7213604221df7a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'validation_rules': (0, $d91550d22670bce3$export$6aadfbfa6597f211)(value['validation_rules'])
    };
}




function $b2f20ce9d2188a1e$export$93aa968ce48fce07(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}
function $b2f20ce9d2188a1e$export$dbcbef80979fd2e8(json) {
    return $b2f20ce9d2188a1e$export$e5fe87714f320c28(json, false);
}
function $b2f20ce9d2188a1e$export$e5fe87714f320c28(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': (0, $f19ad07d16452f15$export$9e3e7e437375c546)(json['options'])
    };
}
function $b2f20ce9d2188a1e$export$ee2fef0e2b3251ae(json) {
    return $b2f20ce9d2188a1e$export$9964aa3b700576d0(json, false);
}
function $b2f20ce9d2188a1e$export$9964aa3b700576d0(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $f19ad07d16452f15$export$6274b0e68c67e72a)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $563d9e3675f74f13$export$cd7f0c3fc9794977(value) {
    if (!('validation_rules' in value) || value['validation_rules'] === undefined) return false;
    return true;
}
function $563d9e3675f74f13$export$f4038b507713b142(json) {
    return $563d9e3675f74f13$export$a17d017c59274ff8(json, false);
}
function $563d9e3675f74f13$export$a17d017c59274ff8(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'validation_rules': (0, $d91550d22670bce3$export$7fa65e60d0ba4afc)(json['validation_rules'])
    };
}
function $563d9e3675f74f13$export$7e6df8572e78556b(json) {
    return $563d9e3675f74f13$export$66a94c8451a98e97(json, false);
}
function $563d9e3675f74f13$export$66a94c8451a98e97(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'validation_rules': (0, $d91550d22670bce3$export$6aadfbfa6597f211)(value['validation_rules'])
    };
}




function $5f71f11392f465b6$export$9a062f703f34347a(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}
function $5f71f11392f465b6$export$5477c9fab2d7bd3a(json) {
    return $5f71f11392f465b6$export$e4f7639cf60c1778(json, false);
}
function $5f71f11392f465b6$export$e4f7639cf60c1778(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': (0, $563d9e3675f74f13$export$f4038b507713b142)(json['options'])
    };
}
function $5f71f11392f465b6$export$8dba8265a6f7070c(json) {
    return $5f71f11392f465b6$export$418e4e18138ba22f(json, false);
}
function $5f71f11392f465b6$export$418e4e18138ba22f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $563d9e3675f74f13$export$7e6df8572e78556b)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $db9330dcbfbc1cd8$export$15329ecd0bdefeaa(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $db9330dcbfbc1cd8$export$7a5b20871392ef1a(json) {
    return $db9330dcbfbc1cd8$export$b8669a208e58c77c(json, false);
}
function $db9330dcbfbc1cd8$export$b8669a208e58c77c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method'])
    };
}
function $db9330dcbfbc1cd8$export$3b2df7bcf8c9a0ac(json) {
    return $db9330dcbfbc1cd8$export$859b958c8a30c393(json, false);
}
function $db9330dcbfbc1cd8$export$859b958c8a30c393(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $fb142271fe180837$export$2aa312c401d27633(value) {
    return true;
}
function $fb142271fe180837$export$f1b0b8bf9576e182(json) {
    return $fb142271fe180837$export$c12821ff4657af79(json, false);
}
function $fb142271fe180837$export$c12821ff4657af79(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'] == null ? undefined : json['challenge_id']
    };
}
function $fb142271fe180837$export$f9c2a4907f4de151(json) {
    return $fb142271fe180837$export$79295164215abdfd(json, false);
}
function $fb142271fe180837$export$79295164215abdfd(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id']
    };
}


function $bc5f066114e32366$export$e4a96b1ac70d6952(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $bc5f066114e32366$export$a8e5d6ad8457d255(json) {
    return $bc5f066114e32366$export$2886b0dfa544935e(json, false);
}
function $bc5f066114e32366$export$2886b0dfa544935e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': json['options'] == null ? undefined : (0, $fb142271fe180837$export$f1b0b8bf9576e182)(json['options'])
    };
}
function $bc5f066114e32366$export$149d00a24fa85ed5(json) {
    return $bc5f066114e32366$export$ce22d10e0d265c4(json, false);
}
function $bc5f066114e32366$export$ce22d10e0d265c4(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $fb142271fe180837$export$f9c2a4907f4de151)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $08f9a27bb3eae5ea$export$651a7485e3024dfa(value) {
    if (!('start_authentication_url' in value) || value['start_authentication_url'] === undefined) return false;
    return true;
}
function $08f9a27bb3eae5ea$export$69d72f503d5a95ba(json) {
    return $08f9a27bb3eae5ea$export$31dc24e629860ee2(json, false);
}
function $08f9a27bb3eae5ea$export$31dc24e629860ee2(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'start_authentication_url': json['start_authentication_url']
    };
}
function $08f9a27bb3eae5ea$export$9cee4e2f30c94128(json) {
    return $08f9a27bb3eae5ea$export$d0c7342fede4c47b(json, false);
}
function $08f9a27bb3eae5ea$export$d0c7342fede4c47b(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'start_authentication_url': value['start_authentication_url']
    };
}


function $c7c5fe4cd4fc3b1d$export$bfba04cf17e59ab8(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}
function $c7c5fe4cd4fc3b1d$export$872d304ec9d9766(json) {
    return $c7c5fe4cd4fc3b1d$export$19245043fc4758a9(json, false);
}
function $c7c5fe4cd4fc3b1d$export$19245043fc4758a9(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': (0, $08f9a27bb3eae5ea$export$69d72f503d5a95ba)(json['options'])
    };
}
function $c7c5fe4cd4fc3b1d$export$73be0b9f120503f8(json) {
    return $c7c5fe4cd4fc3b1d$export$b595f7819d35a0a6(json, false);
}
function $c7c5fe4cd4fc3b1d$export$b595f7819d35a0a6(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $08f9a27bb3eae5ea$export$9cee4e2f30c94128)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $1c5c521d9e59fce8$export$d21e8fc2bb12c7ca(value) {
    if (!('key_uri' in value) || value['key_uri'] === undefined) return false;
    if (!('qr_code_data_b64' in value) || value['qr_code_data_b64'] === undefined) return false;
    if (!('recovery_codes' in value) || value['recovery_codes'] === undefined) return false;
    return true;
}
function $1c5c521d9e59fce8$export$f66b99a7ee22c7be(json) {
    return $1c5c521d9e59fce8$export$a30c0f82bae007a7(json, false);
}
function $1c5c521d9e59fce8$export$a30c0f82bae007a7(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'key_uri': json['key_uri'],
        'qr_code_data_b64': json['qr_code_data_b64'],
        'recovery_codes': json['recovery_codes']
    };
}
function $1c5c521d9e59fce8$export$acdf6a8f9dfbfedb(json) {
    return $1c5c521d9e59fce8$export$d98164581c1a5925(json, false);
}
function $1c5c521d9e59fce8$export$d98164581c1a5925(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'key_uri': value['key_uri'],
        'qr_code_data_b64': value['qr_code_data_b64'],
        'recovery_codes': value['recovery_codes']
    };
}



function $cc670f9c201ec0e3$export$6dee3609dee6bc4c(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $cc670f9c201ec0e3$export$144c08ba7abb6f17(json) {
    return $cc670f9c201ec0e3$export$5e35a68aca6442a8(json, false);
}
function $cc670f9c201ec0e3$export$5e35a68aca6442a8(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': json['options'] == null ? undefined : (0, $1c5c521d9e59fce8$export$f66b99a7ee22c7be)(json['options'])
    };
}
function $cc670f9c201ec0e3$export$abe3671e10ab522b(json) {
    return $cc670f9c201ec0e3$export$b96e8b9ad905e287(json, false);
}
function $cc670f9c201ec0e3$export$b96e8b9ad905e287(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $1c5c521d9e59fce8$export$acdf6a8f9dfbfedb)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $557735ddb22ccc91$export$53c74f53dd3d420b(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $557735ddb22ccc91$export$3c0444006eabbf01(json) {
    return $557735ddb22ccc91$export$b389d0c8295c56f6(json, false);
}
function $557735ddb22ccc91$export$b389d0c8295c56f6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method'])
    };
}
function $557735ddb22ccc91$export$cceadf6b335284aa(json) {
    return $557735ddb22ccc91$export$2682c3cc3d6207b8(json, false);
}
function $557735ddb22ccc91$export$2682c3cc3d6207b8(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $2aedd3952216bafa$export$6b62ce698944fdc6(value) {
    return true;
}
function $2aedd3952216bafa$export$dcd5b8b66f15246b(json) {
    return $2aedd3952216bafa$export$b5f9d8088544176f(json, false);
}
function $2aedd3952216bafa$export$b5f9d8088544176f(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'authn_redirect_page_ui_config': json['authn_redirect_page_ui_config'] == null ? undefined : json['authn_redirect_page_ui_config']
    };
}
function $2aedd3952216bafa$export$2f17748153b0485a(json) {
    return $2aedd3952216bafa$export$3ff4af85cd46f829(json, false);
}
function $2aedd3952216bafa$export$3ff4af85cd46f829(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'authn_redirect_page_ui_config': value['authn_redirect_page_ui_config']
    };
}




function $20184932899ca15f$export$19475da50fcc2e61(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $20184932899ca15f$export$efad740b9c9f084e(json) {
    return $20184932899ca15f$export$60d1f2ae02a0447b(json, false);
}
function $20184932899ca15f$export$60d1f2ae02a0447b(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': json['options'] == null ? undefined : (0, $2aedd3952216bafa$export$dcd5b8b66f15246b)(json['options'])
    };
}
function $20184932899ca15f$export$9587cea8d8b99873(json) {
    return $20184932899ca15f$export$e66b753830975555(json, false);
}
function $20184932899ca15f$export$e66b753830975555(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': (0, $2aedd3952216bafa$export$2f17748153b0485a)(value['options'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $fde5b83b93ef77cc$export$9bc0b18b61797527(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $fde5b83b93ef77cc$export$b7a0e49579dce760(json) {
    return $fde5b83b93ef77cc$export$13d6aef7f9d716af(json, false);
}
function $fde5b83b93ef77cc$export$13d6aef7f9d716af(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': json['options'] == null ? undefined : json['options']
    };
}
function $fde5b83b93ef77cc$export$8189205342ed27d2(json) {
    return $fde5b83b93ef77cc$export$cdf86bd58562bda1(json, false);
}
function $fde5b83b93ef77cc$export$cdf86bd58562bda1(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': value['options']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $f1f5d8fb6c1bb90f$export$9c42d132abe91501(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $f1f5d8fb6c1bb90f$export$5b300f7354c5b32(json) {
    return $f1f5d8fb6c1bb90f$export$90f387175041abdf(json, false);
}
function $f1f5d8fb6c1bb90f$export$90f387175041abdf(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method']),
        'options': json['options'] == null ? undefined : json['options']
    };
}
function $f1f5d8fb6c1bb90f$export$9a8e42c9faeafe3(json) {
    return $f1f5d8fb6c1bb90f$export$a948c2a904cdaef6(json, false);
}
function $f1f5d8fb6c1bb90f$export$a948c2a904cdaef6(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method']),
        'options': value['options']
    };
}


function $0cf7b7434aaffba7$export$2b369be06dcbfccd(json) {
    return $0cf7b7434aaffba7$export$c8d0f078679e0082(json, false);
}
function $0cf7b7434aaffba7$export$c8d0f078679e0082(json, ignoreDiscriminator) {
    if (json == null) return json;
    switch(json['type']){
        case 'authn_context_update':
            return Object.assign({}, (0, $9e2b90df161804ab$export$c7b869a25b419e6)(json, true), {
                type: 'authn_context_update'
            });
        case 'nonce':
            return Object.assign({}, (0, $20b7317581980167$export$c89b7013df12088e)(json, true), {
                type: 'nonce'
            });
        case 'oidc':
            return Object.assign({}, (0, $46ff52f5297fe85d$export$52281bb8e2d4eb8a)(json, true), {
                type: 'oidc'
            });
        case 'otp':
            return Object.assign({}, (0, $91970af08a1e53e9$export$11c938a12b9e7a4e)(json, true), {
                type: 'otp'
            });
        case 'password_reset':
            return Object.assign({}, (0, $b2f20ce9d2188a1e$export$e5fe87714f320c28)(json, true), {
                type: 'password_reset'
            });
        case 'password_set':
            return Object.assign({}, (0, $5f71f11392f465b6$export$e4f7639cf60c1778)(json, true), {
                type: 'password_set'
            });
        case 'password_verify':
            return Object.assign({}, (0, $db9330dcbfbc1cd8$export$b8669a208e58c77c)(json, true), {
                type: 'password_verify'
            });
        case 'proxy':
            return Object.assign({}, (0, $bc5f066114e32366$export$2886b0dfa544935e)(json, true), {
                type: 'proxy'
            });
        case 'saml':
            return Object.assign({}, (0, $c7c5fe4cd4fc3b1d$export$19245043fc4758a9)(json, true), {
                type: 'saml'
            });
        case 'totp_register':
            return Object.assign({}, (0, $cc670f9c201ec0e3$export$5e35a68aca6442a8)(json, true), {
                type: 'totp_register'
            });
        case 'totp_verify':
            return Object.assign({}, (0, $557735ddb22ccc91$export$b389d0c8295c56f6)(json, true), {
                type: 'totp_verify'
            });
        case 'ui_customization':
            return Object.assign({}, (0, $20184932899ca15f$export$60d1f2ae02a0447b)(json, true), {
                type: 'ui_customization'
            });
        case 'webauthn_create':
            return Object.assign({}, (0, $fde5b83b93ef77cc$export$13d6aef7f9d716af)(json, true), {
                type: 'webauthn_create'
            });
        case 'webauthn_get':
            return Object.assign({}, (0, $f1f5d8fb6c1bb90f$export$90f387175041abdf)(json, true), {
                type: 'webauthn_get'
            });
        default:
            return json;
    }
}
function $0cf7b7434aaffba7$export$6177497a9ebb14ed(json) {
    return $0cf7b7434aaffba7$export$416b4204ca4ca08f(json, false);
}
function $0cf7b7434aaffba7$export$416b4204ca4ca08f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    switch(value['type']){
        case 'authn_context_update':
            return Object.assign({}, (0, $9e2b90df161804ab$export$1bba6c46c28de3a)(value), {
                type: 'authn_context_update'
            });
        case 'nonce':
            return Object.assign({}, (0, $20b7317581980167$export$e8c577ab91ee698f)(value), {
                type: 'nonce'
            });
        case 'oidc':
            return Object.assign({}, (0, $46ff52f5297fe85d$export$b237322a72e22d30)(value), {
                type: 'oidc'
            });
        case 'otp':
            return Object.assign({}, (0, $91970af08a1e53e9$export$39ee8e97c506a89d)(value), {
                type: 'otp'
            });
        case 'password_reset':
            return Object.assign({}, (0, $b2f20ce9d2188a1e$export$ee2fef0e2b3251ae)(value), {
                type: 'password_reset'
            });
        case 'password_set':
            return Object.assign({}, (0, $5f71f11392f465b6$export$8dba8265a6f7070c)(value), {
                type: 'password_set'
            });
        case 'password_verify':
            return Object.assign({}, (0, $db9330dcbfbc1cd8$export$3b2df7bcf8c9a0ac)(value), {
                type: 'password_verify'
            });
        case 'proxy':
            return Object.assign({}, (0, $bc5f066114e32366$export$149d00a24fa85ed5)(value), {
                type: 'proxy'
            });
        case 'saml':
            return Object.assign({}, (0, $c7c5fe4cd4fc3b1d$export$73be0b9f120503f8)(value), {
                type: 'saml'
            });
        case 'totp_register':
            return Object.assign({}, (0, $cc670f9c201ec0e3$export$abe3671e10ab522b)(value), {
                type: 'totp_register'
            });
        case 'totp_verify':
            return Object.assign({}, (0, $557735ddb22ccc91$export$cceadf6b335284aa)(value), {
                type: 'totp_verify'
            });
        case 'ui_customization':
            return Object.assign({}, (0, $20184932899ca15f$export$9587cea8d8b99873)(value), {
                type: 'ui_customization'
            });
        case 'webauthn_create':
            return Object.assign({}, (0, $fde5b83b93ef77cc$export$8189205342ed27d2)(value), {
                type: 'webauthn_create'
            });
        case 'webauthn_get':
            return Object.assign({}, (0, $f1f5d8fb6c1bb90f$export$9a8e42c9faeafe3)(value), {
                type: 'webauthn_get'
            });
        default:
            return value;
    }
}


function $90b79fa8082f48c4$export$60226c2b1c831fc8(value) {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('challenges' in value) || value['challenges'] === undefined) return false;
    return true;
}
function $90b79fa8082f48c4$export$26de6b3040249dba(json) {
    return $90b79fa8082f48c4$export$39f37221feeb0552(json, false);
}
function $90b79fa8082f48c4$export$39f37221feeb0552(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'type': (0, $44461f186c6840c6$export$4506231523ce8e94)(json['type']),
        'challenges': json['challenges'].map((0, $0cf7b7434aaffba7$export$2b369be06dcbfccd))
    };
}
function $90b79fa8082f48c4$export$5d45b3537090562c(json) {
    return $90b79fa8082f48c4$export$d60d19db0513443(json, false);
}
function $90b79fa8082f48c4$export$d60d19db0513443(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'type': (0, $44461f186c6840c6$export$e72937a457473649)(value['type']),
        'challenges': value['challenges'].map((0, $0cf7b7434aaffba7$export$6177497a9ebb14ed))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $75a5eeb0d49392a4$export$e5fa814e0c71f9a9(value) {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}
function $75a5eeb0d49392a4$export$226c87e8b15fc592(json) {
    return $75a5eeb0d49392a4$export$1e92e9ba06de6d6c(json, false);
}
function $75a5eeb0d49392a4$export$1e92e9ba06de6d6c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'type': (0, $44461f186c6840c6$export$4506231523ce8e94)(json['type']),
        'token': json['token']
    };
}
function $75a5eeb0d49392a4$export$e38699d69ae00763(json) {
    return $75a5eeb0d49392a4$export$e224040428651104(json, false);
}
function $75a5eeb0d49392a4$export$e224040428651104(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'type': (0, $44461f186c6840c6$export$e72937a457473649)(value['type']),
        'token': value['token']
    };
}


function $480213b2eee01814$export$797a36cdc96d2f1e(json) {
    return $480213b2eee01814$export$7ff170cb0fb2290d(json, false);
}
function $480213b2eee01814$export$7ff170cb0fb2290d(json, ignoreDiscriminator) {
    if (json == null) return json;
    switch(json['type']){
        case 'challenge_list':
            return Object.assign({}, (0, $90b79fa8082f48c4$export$39f37221feeb0552)(json, true), {
                type: 'challenge_list'
            });
        case 'token':
            return Object.assign({}, (0, $75a5eeb0d49392a4$export$1e92e9ba06de6d6c)(json, true), {
                type: 'token'
            });
        default:
            return json;
    }
}
function $480213b2eee01814$export$c076ae764491b36c(json) {
    return $480213b2eee01814$export$2d6f86db7a6deddd(json, false);
}
function $480213b2eee01814$export$2d6f86db7a6deddd(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    switch(value['type']){
        case 'challenge_list':
            return Object.assign({}, (0, $90b79fa8082f48c4$export$5d45b3537090562c)(value), {
                type: 'challenge_list'
            });
        case 'token':
            return Object.assign({}, (0, $75a5eeb0d49392a4$export$e38699d69ae00763)(value), {
                type: 'token'
            });
        default:
            return value;
    }
}




function $2a1d9738cd315562$export$4c2b3b5f5528aed7(value) {
    return true;
}
function $2a1d9738cd315562$export$3766d28771da8bfb(json) {
    return $2a1d9738cd315562$export$9f50fdf020c68cfd(json, false);
}
function $2a1d9738cd315562$export$9f50fdf020c68cfd(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : (0, $480213b2eee01814$export$797a36cdc96d2f1e)(json['result'])
    };
}
function $2a1d9738cd315562$export$e6ce20848a179bcc(json) {
    return $2a1d9738cd315562$export$a95919090dc27f9a(json, false);
}
function $2a1d9738cd315562$export$a95919090dc27f9a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $480213b2eee01814$export$c076ae764491b36c)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $ebdf4c1944a67a53$export$fa01e4739dcca2cf(value) {
    return true;
}
function $ebdf4c1944a67a53$export$38478e6caf9c9de9(json) {
    return $ebdf4c1944a67a53$export$c2bd0afcb86bf051(json, false);
}
function $ebdf4c1944a67a53$export$c2bd0afcb86bf051(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'handle': json['handle'] == null ? undefined : (0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)(json['handle']),
        'factor': json['factor'] == null ? undefined : (0, $7b9a0cb8e9dc2f71$export$f532260b06e67d79)(json['factor'])
    };
}
function $ebdf4c1944a67a53$export$7eb26765f35a90a8(json) {
    return $ebdf4c1944a67a53$export$d2c5291a9bdc75f(json, false);
}
function $ebdf4c1944a67a53$export$d2c5291a9bdc75f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'handle': (0, $0465af89d7cf9aa3$export$82ff335443c9930)(value['handle']),
        'factor': (0, $7b9a0cb8e9dc2f71$export$288f5f309e052c1d)(value['factor'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $49835282e40b86b6$export$343a7cbbb2623b4(value) {
    return true;
}
function $49835282e40b86b6$export$d4e7f1e09f58bdfe(json) {
    return $49835282e40b86b6$export$229a73da8cf1adb0(json, false);
}
function $49835282e40b86b6$export$229a73da8cf1adb0(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'pkce_code_challenge': json['pkce_code_challenge'] == null ? undefined : json['pkce_code_challenge'],
        'csrf_token': json['csrf_token'] == null ? undefined : json['csrf_token']
    };
}
function $49835282e40b86b6$export$8851c826c823c733(json) {
    return $49835282e40b86b6$export$922cb0245cfb1604(json, false);
}
function $49835282e40b86b6$export$922cb0245cfb1604(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'pkce_code_challenge': value['pkce_code_challenge'],
        'csrf_token': value['csrf_token']
    };
}




function $352b70c51b3dceae$export$b616668d1f2274ba(value) {
    return true;
}
function $352b70c51b3dceae$export$efac01586d65d94f(json) {
    return $352b70c51b3dceae$export$2f66ee609ab5958d(json, false);
}
function $352b70c51b3dceae$export$2f66ee609ab5958d(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'handle': json['handle'] == null ? undefined : (0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)(json['handle']),
        'factor': json['factor'] == null ? undefined : (0, $7b9a0cb8e9dc2f71$export$f532260b06e67d79)(json['factor']),
        'metadata': json['metadata'] == null ? undefined : (0, $49835282e40b86b6$export$d4e7f1e09f58bdfe)(json['metadata'])
    };
}
function $352b70c51b3dceae$export$511cb15a8242b8a0(json) {
    return $352b70c51b3dceae$export$dcf7c59b713e23bb(json, false);
}
function $352b70c51b3dceae$export$dcf7c59b713e23bb(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'handle': (0, $0465af89d7cf9aa3$export$82ff335443c9930)(value['handle']),
        'factor': (0, $7b9a0cb8e9dc2f71$export$288f5f309e052c1d)(value['factor']),
        'metadata': (0, $49835282e40b86b6$export$8851c826c823c733)(value['metadata'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $1d03d583982a32f6$export$89cf3f8c1b1c7a44(value) {
    return true;
}
function $1d03d583982a32f6$export$2438463015ae288a(json) {
    return $1d03d583982a32f6$export$322c43924fe8a316(json, false);
}
function $1d03d583982a32f6$export$322c43924fe8a316(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'token': json['token'] == null ? undefined : json['token']
    };
}
function $1d03d583982a32f6$export$c47763383831190d(json) {
    return $1d03d583982a32f6$export$b67edb0c7f205481(json, false);
}
function $1d03d583982a32f6$export$b67edb0c7f205481(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'token': value['token']
    };
}



function $0115318cb07558e8$export$c5fff690dcda49e2(value) {
    return true;
}
function $0115318cb07558e8$export$bfdb8eb6be454b15(json) {
    return $0115318cb07558e8$export$b3bc95898c127982(json, false);
}
function $0115318cb07558e8$export$b3bc95898c127982(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : (0, $1d03d583982a32f6$export$2438463015ae288a)(json['result'])
    };
}
function $0115318cb07558e8$export$57916bf01f85117c(json) {
    return $0115318cb07558e8$export$4d9a6656b04fc8f7(json, false);
}
function $0115318cb07558e8$export$4d9a6656b04fc8f7(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $1d03d583982a32f6$export$c47763383831190d)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $a2f53e530d4570cd$export$2564becf3d7df8bf(value) {
    return true;
}
function $a2f53e530d4570cd$export$c5ad9a62b0e0f9c1(json) {
    return $a2f53e530d4570cd$export$92265434404f74f(json, false);
}
function $a2f53e530d4570cd$export$92265434404f74f(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : json['result']
    };
}
function $a2f53e530d4570cd$export$43e020afdf5de077(json) {
    return $a2f53e530d4570cd$export$a064fb9ccb1ccd92(json, false);
}
function $a2f53e530d4570cd$export$a064fb9ccb1ccd92(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $54bbf8e6fc21c74a$export$8e4dc0011f92ce98(value) {
    return true;
}
function $54bbf8e6fc21c74a$export$af4b4231cf2b0254(json) {
    return $54bbf8e6fc21c74a$export$2e7094b7545fa908(json, false);
}
function $54bbf8e6fc21c74a$export$2e7094b7545fa908(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : json['result'].map((0, $0cf7b7434aaffba7$export$2b369be06dcbfccd))
    };
}
function $54bbf8e6fc21c74a$export$343f21e1ccb9a347(json) {
    return $54bbf8e6fc21c74a$export$3d102a4e02e010a6(json, false);
}
function $54bbf8e6fc21c74a$export$3d102a4e02e010a6(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result'] == null ? undefined : value['result'].map((0, $0cf7b7434aaffba7$export$6177497a9ebb14ed))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $2d7be6a714136ad3$export$44cb6a10a172bc79(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $2d7be6a714136ad3$export$6cc59d6581215347(json) {
    return $2d7be6a714136ad3$export$dd5582c4cefe8245(json, false);
}
function $2d7be6a714136ad3$export$dd5582c4cefe8245(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result']
    };
}
function $2d7be6a714136ad3$export$2738242983cb35a0(json) {
    return $2d7be6a714136ad3$export$4ef69beba2b4fb94(json, false);
}
function $2d7be6a714136ad3$export$4ef69beba2b4fb94(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $fa8994fd8c2c84c7$export$82e781fc0d7e16a1(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('pkce_code_verifier' in value) || value['pkce_code_verifier'] === undefined) return false;
    return true;
}
function $fa8994fd8c2c84c7$export$c81fe3455ca9f9b6(json) {
    return $fa8994fd8c2c84c7$export$8d1ff6a39953655(json, false);
}
function $fa8994fd8c2c84c7$export$8d1ff6a39953655(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'code': json['code'],
        'pkce_code_verifier': json['pkce_code_verifier']
    };
}
function $fa8994fd8c2c84c7$export$7fdfe928bc2b4877(json) {
    return $fa8994fd8c2c84c7$export$592f422517f11d85(json, false);
}
function $fa8994fd8c2c84c7$export$592f422517f11d85(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'code': value['code'],
        'pkce_code_verifier': value['pkce_code_verifier']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $7faf4ce1ff690e28$export$a24c9894f8f53255(value) {
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}
function $7faf4ce1ff690e28$export$93f8ee1209fb798(json) {
    return $7faf4ce1ff690e28$export$c523d60dd0f466f5(json, false);
}
function $7faf4ce1ff690e28$export$c523d60dd0f466f5(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'metadata': (0, $49835282e40b86b6$export$d4e7f1e09f58bdfe)(json['metadata'])
    };
}
function $7faf4ce1ff690e28$export$3f92864adde58228(json) {
    return $7faf4ce1ff690e28$export$88faa699e4d619fb(json, false);
}
function $7faf4ce1ff690e28$export$88faa699e4d619fb(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'metadata': (0, $49835282e40b86b6$export$8851c826c823c733)(value['metadata'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Authentication factor that can be recovered
 * @export
 */ const $b5d83bcbd9b73e65$export$bb5e6ee25b0fc7c3 = {
    Password: 'password'
};
function $b5d83bcbd9b73e65$export$aeca2359531d818f(value) {
    for(const key in $b5d83bcbd9b73e65$export$bb5e6ee25b0fc7c3)if (Object.prototype.hasOwnProperty.call($b5d83bcbd9b73e65$export$bb5e6ee25b0fc7c3, key)) {
        if ($b5d83bcbd9b73e65$export$bb5e6ee25b0fc7c3[key] === value) return true;
    }
    return false;
}
function $b5d83bcbd9b73e65$export$398fba7e85f1db2c(json) {
    return $b5d83bcbd9b73e65$export$f62e5af70cc4ea0(json, false);
}
function $b5d83bcbd9b73e65$export$f62e5af70cc4ea0(json, ignoreDiscriminator) {
    return json;
}
function $b5d83bcbd9b73e65$export$423270bccf3787e0(value) {
    return value;
}
function $b5d83bcbd9b73e65$export$6192798ed1fbbfb7(value, ignoreDiscriminator) {
    return value;
}


function $7a2abdc122d6e523$export$d49ddc28a4137c80(value) {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $7a2abdc122d6e523$export$dfa0f361ed82900(json) {
    return $7a2abdc122d6e523$export$8db160ece1e2bbd6(json, false);
}
function $7a2abdc122d6e523$export$8db160ece1e2bbd6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'method': (0, $b5d83bcbd9b73e65$export$398fba7e85f1db2c)(json['method'])
    };
}
function $7a2abdc122d6e523$export$8b7251cbcbbc3a83(json) {
    return $7a2abdc122d6e523$export$6e37056bd4edaece(json, false);
}
function $7a2abdc122d6e523$export$6e37056bd4edaece(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'method': (0, $b5d83bcbd9b73e65$export$423270bccf3787e0)(value['method'])
    };
}


function $60e3a8847fea73fc$export$837a073b52aa896c(value) {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('factor' in value) || value['factor'] === undefined) return false;
    return true;
}
function $60e3a8847fea73fc$export$40275694f4ecf42f(json) {
    return $60e3a8847fea73fc$export$5b2c6615cebf0a90(json, false);
}
function $60e3a8847fea73fc$export$5b2c6615cebf0a90(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'handle': (0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)(json['handle']),
        'factor': (0, $7a2abdc122d6e523$export$dfa0f361ed82900)(json['factor'])
    };
}
function $60e3a8847fea73fc$export$e61274da9e6eaaa0(json) {
    return $60e3a8847fea73fc$export$ad68d661270f3976(json, false);
}
function $60e3a8847fea73fc$export$ad68d661270f3976(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'handle': (0, $0465af89d7cf9aa3$export$82ff335443c9930)(value['handle']),
        'factor': (0, $7a2abdc122d6e523$export$8b7251cbcbbc3a83)(value['factor'])
    };
}


class $125642d21ec07f66$export$872437fb2a17cd0e extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for getChallengeChallengeId without sending the request
     */ async getChallengeChallengeIdRequestOpts(requestParameters) {
        if (requestParameters['challengeId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('challengeId', 'Required parameter "challengeId" was null or undefined when calling getChallengeChallengeId().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/challenge/{challenge_id}`;
        urlPath = urlPath.replace('{challenge_id}', encodeURIComponent(String(requestParameters['challengeId'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     */ async getChallengeChallengeIdRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getChallengeChallengeIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $afd83da85d848823$export$fc7f4a9925d556ff)(jsonValue));
    }
    /**
     */ async getChallengeChallengeId(requestParameters, initOverrides) {
        const response = await this.getChallengeChallengeIdRaw(requestParameters, initOverrides);
        switch(response.raw.status){
            case 200:
                return await response.value();
            case 202:
                return null;
            default:
                return await response.value();
        }
    }
    /**
     * Creates request options for getChallengeChallengeIdV2 without sending the request
     */ async getChallengeChallengeIdV2RequestOpts(requestParameters) {
        if (requestParameters['challengeId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('challengeId', 'Required parameter "challengeId" was null or undefined when calling getChallengeChallengeIdV2().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/challenge/{challenge_id}/v2`;
        urlPath = urlPath.replace('{challenge_id}', encodeURIComponent(String(requestParameters['challengeId'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     */ async getChallengeChallengeIdV2Raw(requestParameters, initOverrides) {
        const requestOptions = await this.getChallengeChallengeIdV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d4ecca59a9c27db$export$859624b73bf55232)(jsonValue));
    }
    /**
     */ async getChallengeChallengeIdV2(requestParameters, initOverrides) {
        const response = await this.getChallengeChallengeIdV2Raw(requestParameters, initOverrides);
        switch(response.raw.status){
            case 200:
                return await response.value();
            case 202:
                return null;
            default:
                return await response.value();
        }
    }
    /**
     * Creates request options for getChallengePackChallengePackId without sending the request
     */ async getChallengePackChallengePackIdRequestOpts(requestParameters) {
        if (requestParameters['challengePackId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('challengePackId', 'Required parameter "challengePackId" was null or undefined when calling getChallengePackChallengePackId().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/challenge_pack/{challenge_pack_id}`;
        urlPath = urlPath.replace('{challenge_pack_id}', encodeURIComponent(String(requestParameters['challengePackId'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     */ async getChallengePackChallengePackIdRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getChallengePackChallengePackIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $54bbf8e6fc21c74a$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async getChallengePackChallengePackId(requestParameters, initOverrides) {
        const response = await this.getChallengePackChallengePackIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getMe without sending the request
     */ async getMeRequestOpts() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/me`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */ async getMeRaw(initOverrides) {
        const requestOptions = await this.getMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $ed9d956b3734a4a3$export$bfd68bd3621b7ea1)(jsonValue));
    }
    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */ async getMe(initOverrides) {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getMeOrgs without sending the request
     */ async getMeOrgsRequestOpts() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/me/orgs`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */ async getMeOrgsRaw(initOverrides) {
        const requestOptions = await this.getMeOrgsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $181b533581b4dbbd$export$8a5bc1b2ff07b739)(jsonValue));
    }
    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */ async getMeOrgs(initOverrides) {
        const response = await this.getMeOrgsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getToken without sending the request
     */ async getTokenRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getToken().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/token`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async getTokenRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d4ecca59a9c27db$export$859624b73bf55232)(jsonValue));
    }
    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async getToken(requestParameters, initOverrides) {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getTokenV2 without sending the request
     */ async getTokenV2RequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getTokenV2().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/token/v2`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async getTokenV2Raw(requestParameters, initOverrides) {
        const requestOptions = await this.getTokenV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2a1d9738cd315562$export$3766d28771da8bfb)(jsonValue));
    }
    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async getTokenV2(requestParameters, initOverrides) {
        const response = await this.getTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postAttestation without sending the request
     */ async postAttestationRequestOpts(requestParameters) {
        if (requestParameters['attestation'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('attestation', 'Required parameter "attestation" was null or undefined when calling postAttestation().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attestation`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $00af686f6122a4d2$export$d7f719716c0ef239)(requestParameters['attestation'])
        };
    }
    /**
     */ async postAttestationRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postAttestationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $afd83da85d848823$export$fc7f4a9925d556ff)(jsonValue));
    }
    /**
     */ async postAttestation(requestParameters, initOverrides) {
        const response = await this.postAttestationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postAttestationV2 without sending the request
     */ async postAttestationV2RequestOpts(requestParameters) {
        if (requestParameters['attestation'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('attestation', 'Required parameter "attestation" was null or undefined when calling postAttestationV2().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attestation/v2`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $00af686f6122a4d2$export$d7f719716c0ef239)(requestParameters['attestation'])
        };
    }
    /**
     */ async postAttestationV2Raw(requestParameters, initOverrides) {
        const requestOptions = await this.postAttestationV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d4ecca59a9c27db$export$859624b73bf55232)(jsonValue));
    }
    /**
     */ async postAttestationV2(requestParameters, initOverrides) {
        const response = await this.postAttestationV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postAttestationV3 without sending the request
     */ async postAttestationV3RequestOpts(requestParameters) {
        if (requestParameters['attestation'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('attestation', 'Required parameter "attestation" was null or undefined when calling postAttestationV3().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/attestation/v3`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $00af686f6122a4d2$export$d7f719716c0ef239)(requestParameters['attestation'])
        };
    }
    /**
     */ async postAttestationV3Raw(requestParameters, initOverrides) {
        const requestOptions = await this.postAttestationV3RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $0115318cb07558e8$export$bfdb8eb6be454b15)(jsonValue));
    }
    /**
     */ async postAttestationV3(requestParameters, initOverrides) {
        const response = await this.postAttestationV3Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postDirectId without sending the request
     */ async postDirectIdRequestOpts(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/direct-id`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     */ async postDirectIdRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postDirectIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a2f53e530d4570cd$export$c5ad9a62b0e0f9c1)(jsonValue));
    }
    /**
     */ async postDirectId(requestParameters = {}, initOverrides) {
        const response = await this.postDirectIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postId without sending the request
     */ async postIdRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postId().');
        if (requestParameters['iDRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('iDRequest', 'Required parameter "iDRequest" was null or undefined when calling postId().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/id`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $ebdf4c1944a67a53$export$7eb26765f35a90a8)(requestParameters['iDRequest'])
        };
    }
    /**
     */ async postIdRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $54bbf8e6fc21c74a$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async postId(requestParameters, initOverrides) {
        const response = await this.postIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postIdV2 without sending the request
     */ async postIdV2RequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postIdV2().');
        if (requestParameters['iDRequestV2'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('iDRequestV2', 'Required parameter "iDRequestV2" was null or undefined when calling postIdV2().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/id/v2`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $352b70c51b3dceae$export$511cb15a8242b8a0)(requestParameters['iDRequestV2'])
        };
    }
    /**
     */ async postIdV2Raw(requestParameters, initOverrides) {
        const requestOptions = await this.postIdV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $54bbf8e6fc21c74a$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async postIdV2(requestParameters, initOverrides) {
        const response = await this.postIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postRecover without sending the request
     */ async postRecoverRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postRecover().');
        if (requestParameters['recoverRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('recoverRequest', 'Required parameter "recoverRequest" was null or undefined when calling postRecover().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/recover`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $60e3a8847fea73fc$export$e61274da9e6eaaa0)(requestParameters['recoverRequest'])
        };
    }
    /**
     */ async postRecoverRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postRecoverRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $54bbf8e6fc21c74a$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async postRecover(requestParameters, initOverrides) {
        const response = await this.postRecoverRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postSsoResolve without sending the request
     */ async postSsoResolveRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postSsoResolve().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/sso/resolve`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $fa8994fd8c2c84c7$export$7fdfe928bc2b4877)(requestParameters['postSsoResolveRequest'])
        };
    }
    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */ async postSsoResolveRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postSsoResolveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */ async postSsoResolve(requestParameters, initOverrides) {
        await this.postSsoResolveRaw(requestParameters, initOverrides);
    }
    /**
     * Creates request options for postTokenV2 without sending the request
     */ async postTokenV2RequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postTokenV2().');
        if (requestParameters['postTokenRequestV2'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('postTokenRequestV2', 'Required parameter "postTokenRequestV2" was null or undefined when calling postTokenV2().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/token/v2`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7faf4ce1ff690e28$export$3f92864adde58228)(requestParameters['postTokenRequestV2'])
        };
    }
    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async postTokenV2Raw(requestParameters, initOverrides) {
        const requestOptions = await this.postTokenV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2a1d9738cd315562$export$3766d28771da8bfb)(jsonValue));
    }
    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async postTokenV2(requestParameters, initOverrides) {
        const response = await this.postTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for putMeCredentialsPassword without sending the request
     */ async putMeCredentialsPasswordRequestOpts(requestParameters) {
        if (requestParameters['changePasswordRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('changePasswordRequest', 'Required parameter "changePasswordRequest" was null or undefined when calling putMeCredentialsPassword().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/me/credentials/password`;
        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $954fc7ad481674dd$export$1fea968ae44584ab)(requestParameters['changePasswordRequest'])
        };
    }
    /**
     * Creates or overwrites the password credential linked to the person identified by the token. This credential will then be available for use in future authentication challenges. 
     * Create or overwrite a password credential for the person identified by the token.
     */ async putMeCredentialsPasswordRaw(requestParameters, initOverrides) {
        const requestOptions = await this.putMeCredentialsPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d7be6a714136ad3$export$6cc59d6581215347)(jsonValue));
    }
    /**
     * Creates or overwrites the password credential linked to the person identified by the token. This credential will then be available for use in future authentication challenges. 
     * Create or overwrite a password credential for the person identified by the token.
     */ async putMeCredentialsPassword(requestParameters, initOverrides) {
        const response = await this.putMeCredentialsPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $55eca41019d00c09$export$8e49444f78fbbdb8 = {
    AuthenticationSucceededV1: 'AuthenticationSucceeded_v1',
    AuthenticationFailedV1: 'AuthenticationFailed_v1',
    PersonCreatedV1: 'PersonCreated_v1',
    AnonymousPersonCreatedV1: 'AnonymousPersonCreated_v1',
    PersonDeletedV1: 'PersonDeleted_v1',
    VirtualPageLoadedV1: 'VirtualPageLoaded_v1',
    SlashIdsdkLoadedV1: 'SlashIDSDKLoaded_v1',
    PersonIdentifiedV1: 'PersonIdentified_v1',
    PersonLoggedOutV1: 'PersonLoggedOut_v1',
    TokenMintedV1: 'TokenMinted_v1',
    AnonymousTokenMintedV1: 'AnonymousTokenMinted_v1',
    PasswordChangedV1: 'PasswordChanged_v1',
    GdprConsentsChangedV1: 'GdprConsentsChanged_v1',
    GateServerStartedV1: 'GateServerStarted_v1',
    GateRequestHandledV1: 'GateRequestHandled_v1',
    GateHeartbeatV1: 'GateHeartbeat_v1',
    PermissionCreatedInRegionV1: 'PermissionCreated_InRegion_v1',
    PermissionCreatedV1: 'PermissionCreated_v1',
    PermissionDeletedInRegionV1: 'PermissionDeleted_InRegion_v1',
    PermissionDeletedV1: 'PermissionDeleted_v1',
    RoleCreatedInRegionV1: 'RoleCreated_InRegion_v1',
    RoleCreatedV1: 'RoleCreated_v1',
    RoleDeletedInRegionV1: 'RoleDeleted_InRegion_v1',
    RoleDeletedV1: 'RoleDeleted_v1',
    RoleUpdatedInRegionV1: 'RoleUpdated_InRegion_v1',
    RoleUpdatedV1: 'RoleUpdated_v1',
    RolesSetToPersonInRegionV1: 'RolesSetToPerson_InRegion_v1',
    RolesSetToPersonV1: 'RolesSetToPerson_v1',
    PermissionsSetToPersonInRegionV1: 'PermissionsSetToPerson_InRegion_v1',
    PermissionsSetToPersonV1: 'PermissionsSetToPerson_v1',
    MitmAttackDetectedV1: 'MitmAttackDetected_v1',
    PermissionUpdatedInRegionV1: 'PermissionUpdated_InRegion_v1',
    PermissionUpdatedV1: 'PermissionUpdated_v1',
    SuborganizationCreatedInRegionV1: 'SuborganizationCreated_InRegion_v1',
    SuborganizationCreatedV1: 'SuborganizationCreated_v1',
    OAuth2ClientCreatedInRegionV1: 'OAuth2ClientCreated_InRegion_v1',
    OAuth2ClientCreatedV1: 'OAuth2ClientCreated_v1',
    AwsiamUserCreatedV1: 'AWSIAMUserCreated_v1',
    AwsiamRoleCreatedV1: 'AWSIAMRoleCreated_v1',
    AwsiamRoleInlinePoliciesUpdatedV1: 'AWSIAMRoleInlinePoliciesUpdated_v1',
    AwsiamRoleManagedPoliciesUpdatedV1: 'AWSIAMRoleManagedPoliciesUpdated_v1',
    AwsiamRoleAssumeRolePolicyUpdatedV1: 'AWSIAMRoleAssumeRolePolicyUpdated_v1',
    AwsiamRolePermissionsBoundaryUpdatedV1: 'AWSIAMRolePermissionsBoundaryUpdated_v1',
    AwsiamRoleDeletedV1: 'AWSIAMRoleDeleted_v1',
    GcpServiceAccountCreatedV1: 'GCPServiceAccountCreated_v1',
    GcpRoleCreatedV1: 'GCPRoleCreated_v1',
    GcpiamPolicyBindingUpdatedV1: 'GCPIAMPolicyBindingUpdated_v1',
    GcpServiceAccountDeletedV1: 'GCPServiceAccountDeleted_v1',
    ActiveDirectorySpnCreatedV1: 'ActiveDirectorySPNCreated_v1',
    ActiveDirectorySpnRoleUpdatedV1: 'ActiveDirectorySPNRoleUpdated_v1',
    ActiveDirectorySpnDeletedV1: 'ActiveDirectorySPNDeleted_v1',
    ActiveDirectoryUserCreatedV1: 'ActiveDirectoryUserCreated_v1'
};
function $55eca41019d00c09$export$eb1b41d78abb539b(value) {
    for(const key in $55eca41019d00c09$export$8e49444f78fbbdb8)if (Object.prototype.hasOwnProperty.call($55eca41019d00c09$export$8e49444f78fbbdb8, key)) {
        if ($55eca41019d00c09$export$8e49444f78fbbdb8[key] === value) return true;
    }
    return false;
}
function $55eca41019d00c09$export$9b4cd0a6cee9140c(json) {
    return $55eca41019d00c09$export$97ba4f6074fb0666(json, false);
}
function $55eca41019d00c09$export$97ba4f6074fb0666(json, ignoreDiscriminator) {
    return json;
}
function $55eca41019d00c09$export$ca1aceefe82885b(value) {
    return value;
}
function $55eca41019d00c09$export$7dbb8453fca7b695(value, ignoreDiscriminator) {
    return value;
}


function $e5968a869b98cec4$export$d77fc2e077575409(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('failed_authn_method' in value) || value['failed_authn_method'] === undefined) return false;
    if (!('failure_reason' in value) || value['failure_reason'] === undefined) return false;
    return true;
}
function $e5968a869b98cec4$export$2cd8fd49b27feed9(json) {
    return $e5968a869b98cec4$export$8c07b43d35ce3886(json, false);
}
function $e5968a869b98cec4$export$8c07b43d35ce3886(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name']),
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'authenticated_methods': json['authenticated_methods'] == null ? undefined : json['authenticated_methods'].map((0, $6b68392b32751678$export$67789e1d0e9f3dc1)),
        'failed_authn_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['failed_authn_method']),
        'failure_reason': json['failure_reason'],
        'failure_detail': json['failure_detail'] == null ? undefined : json['failure_detail'],
        'handle': json['handle'] == null ? undefined : (0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)(json['handle']),
        'challenge_id': json['challenge_id'] == null ? undefined : json['challenge_id']
    };
}
function $e5968a869b98cec4$export$a72f46cfd2ab2833(json) {
    return $e5968a869b98cec4$export$45928f96841ff8f8(json, false);
}
function $e5968a869b98cec4$export$45928f96841ff8f8(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name']),
        'person_id': value['person_id'],
        'authenticated_methods': value['authenticated_methods'] == null ? undefined : value['authenticated_methods'].map((0, $6b68392b32751678$export$6eefe3f1006b48e7)),
        'failed_authn_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['failed_authn_method']),
        'failure_reason': value['failure_reason'],
        'failure_detail': value['failure_detail'],
        'handle': (0, $0465af89d7cf9aa3$export$82ff335443c9930)(value['handle']),
        'challenge_id': value['challenge_id']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $80509b491e77bd34$export$fa4ead11c5330b8d(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('success_authn_method' in value) || value['success_authn_method'] === undefined) return false;
    if (!('authenticated_methods' in value) || value['authenticated_methods'] === undefined) return false;
    return true;
}
function $80509b491e77bd34$export$4642b1d23b6be353(json) {
    return $80509b491e77bd34$export$d696d44164fdec7a(json, false);
}
function $80509b491e77bd34$export$d696d44164fdec7a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name']),
        'person_id': json['person_id'],
        'success_authn_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['success_authn_method']),
        'authenticated_methods': json['authenticated_methods'].map((0, $6b68392b32751678$export$67789e1d0e9f3dc1)),
        'handle': json['handle'] == null ? undefined : (0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)(json['handle'])
    };
}
function $80509b491e77bd34$export$5209219e6db8ba4(json) {
    return $80509b491e77bd34$export$80ae2423df7e5b2a(json, false);
}
function $80509b491e77bd34$export$80ae2423df7e5b2a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name']),
        'person_id': value['person_id'],
        'success_authn_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['success_authn_method']),
        'authenticated_methods': value['authenticated_methods'].map((0, $6b68392b32751678$export$6eefe3f1006b48e7)),
        'handle': (0, $0465af89d7cf9aa3$export$82ff335443c9930)(value['handle'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c2f2bf80e5e8bfba$export$ec6d262ccd90fe6f(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    return true;
}
function $c2f2bf80e5e8bfba$export$2f267e9b92087f95(json) {
    return $c2f2bf80e5e8bfba$export$8d03546989de3ff9(json, false);
}
function $c2f2bf80e5e8bfba$export$8d03546989de3ff9(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name']),
        'person_id': json['person_id']
    };
}
function $c2f2bf80e5e8bfba$export$cb23567fd98fa46d(json) {
    return $c2f2bf80e5e8bfba$export$51243792150f5393(json, false);
}
function $c2f2bf80e5e8bfba$export$51243792150f5393(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name']),
        'person_id': value['person_id']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $9337ed7377044145$export$204f5264bda28033(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    return true;
}
function $9337ed7377044145$export$16a16565bf100b(json) {
    return $9337ed7377044145$export$a7e31c5db69cadbe(json, false);
}
function $9337ed7377044145$export$a7e31c5db69cadbe(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name']),
        'person_id': json['person_id']
    };
}
function $9337ed7377044145$export$a76e314527c05f59(json) {
    return $9337ed7377044145$export$ada251fe9188f3c9(json, false);
}
function $9337ed7377044145$export$ada251fe9188f3c9(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name']),
        'person_id': value['person_id']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $e2bb11f68c051f22$export$6a02cd736d48817f(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    return true;
}
function $e2bb11f68c051f22$export$191664532e9f2da8(json) {
    return $e2bb11f68c051f22$export$7b634e670fe42f2(json, false);
}
function $e2bb11f68c051f22$export$7b634e670fe42f2(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name'])
    };
}
function $e2bb11f68c051f22$export$2da1f0d71339461d(json) {
    return $e2bb11f68c051f22$export$c5dd61bac0ed8d31(json, false);
}
function $e2bb11f68c051f22$export$c5dd61bac0ed8d31(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $7f07b6f0cc45bfa5$export$7b2e88c7a989e0f8(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    return true;
}
function $7f07b6f0cc45bfa5$export$414cfaf175ea12ce(json) {
    return $7f07b6f0cc45bfa5$export$a607e0ecea8fe77d(json, false);
}
function $7f07b6f0cc45bfa5$export$a607e0ecea8fe77d(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name']),
        'person_id': json['person_id'] == null ? undefined : json['person_id']
    };
}
function $7f07b6f0cc45bfa5$export$1fc7ada93ab359fd(json) {
    return $7f07b6f0cc45bfa5$export$e2671aa572987481(json, false);
}
function $7f07b6f0cc45bfa5$export$e2671aa572987481(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name']),
        'person_id': value['person_id']
    };
}


function $8895e251d97f30ab$export$28fb86dbbcde5730(json) {
    return $8895e251d97f30ab$export$d7da6a32c8ada00c(json, false);
}
function $8895e251d97f30ab$export$d7da6a32c8ada00c(json, ignoreDiscriminator) {
    if (json == null) return json;
    switch(json['event_name']){
        case 'AuthenticationFailed_v1':
            return Object.assign({}, (0, $e5968a869b98cec4$export$8c07b43d35ce3886)(json, true), {
                event_name: 'AuthenticationFailed_v1'
            });
        case 'AuthenticationSucceeded_v1':
            return Object.assign({}, (0, $80509b491e77bd34$export$d696d44164fdec7a)(json, true), {
                event_name: 'AuthenticationSucceeded_v1'
            });
        case 'PersonIdentified_v1':
            return Object.assign({}, (0, $c2f2bf80e5e8bfba$export$8d03546989de3ff9)(json, true), {
                event_name: 'PersonIdentified_v1'
            });
        case 'PersonLoggedOut_v1':
            return Object.assign({}, (0, $9337ed7377044145$export$a7e31c5db69cadbe)(json, true), {
                event_name: 'PersonLoggedOut_v1'
            });
        case 'SlashIDSDKLoaded_v1':
            return Object.assign({}, (0, $e2bb11f68c051f22$export$7b634e670fe42f2)(json, true), {
                event_name: 'SlashIDSDKLoaded_v1'
            });
        case 'VirtualPageLoaded_v1':
            return Object.assign({}, (0, $7f07b6f0cc45bfa5$export$a607e0ecea8fe77d)(json, true), {
                event_name: 'VirtualPageLoaded_v1'
            });
        default:
            return json;
    }
}
function $8895e251d97f30ab$export$55abdab594c922a4(json) {
    return $8895e251d97f30ab$export$224cde99f988348d(json, false);
}
function $8895e251d97f30ab$export$224cde99f988348d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    switch(value['event_name']){
        case 'AuthenticationFailed_v1':
            return Object.assign({}, (0, $e5968a869b98cec4$export$a72f46cfd2ab2833)(value), {
                event_name: 'AuthenticationFailed_v1'
            });
        case 'AuthenticationSucceeded_v1':
            return Object.assign({}, (0, $80509b491e77bd34$export$5209219e6db8ba4)(value), {
                event_name: 'AuthenticationSucceeded_v1'
            });
        case 'PersonIdentified_v1':
            return Object.assign({}, (0, $c2f2bf80e5e8bfba$export$cb23567fd98fa46d)(value), {
                event_name: 'PersonIdentified_v1'
            });
        case 'PersonLoggedOut_v1':
            return Object.assign({}, (0, $9337ed7377044145$export$a76e314527c05f59)(value), {
                event_name: 'PersonLoggedOut_v1'
            });
        case 'SlashIDSDKLoaded_v1':
            return Object.assign({}, (0, $e2bb11f68c051f22$export$2da1f0d71339461d)(value), {
                event_name: 'SlashIDSDKLoaded_v1'
            });
        case 'VirtualPageLoaded_v1':
            return Object.assign({}, (0, $7f07b6f0cc45bfa5$export$1fc7ada93ab359fd)(value), {
                event_name: 'VirtualPageLoaded_v1'
            });
        default:
            return value;
    }
}


function $905c70c78c26fa77$export$896a897404de84ee(value) {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('analytics_correlation_id' in value) || value['analytics_correlation_id'] === undefined) return false;
    if (!('window_location' in value) || value['window_location'] === undefined) return false;
    if (!('user_agent' in value) || value['user_agent'] === undefined) return false;
    if (!('event_data' in value) || value['event_data'] === undefined) return false;
    return true;
}
function $905c70c78c26fa77$export$81b8afe50a73d799(json) {
    return $905c70c78c26fa77$export$538e9b4cae762a1f(json, false);
}
function $905c70c78c26fa77$export$538e9b4cae762a1f(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'organization_id': json['organization_id'],
        'analytics_correlation_id': json['analytics_correlation_id'],
        'window_location': json['window_location'],
        'user_agent': json['user_agent'],
        'event_data': (0, $8895e251d97f30ab$export$28fb86dbbcde5730)(json['event_data'])
    };
}
function $905c70c78c26fa77$export$66614e5f3c5485b5(json) {
    return $905c70c78c26fa77$export$f1e80c93ae4adb12(json, false);
}
function $905c70c78c26fa77$export$f1e80c93ae4adb12(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'organization_id': value['organization_id'],
        'analytics_correlation_id': value['analytics_correlation_id'],
        'window_location': value['window_location'],
        'user_agent': value['user_agent'],
        'event_data': (0, $8895e251d97f30ab$export$55abdab594c922a4)(value['event_data'])
    };
}


class $4c625453fa2fc885$export$9d7eae2d04d44e94 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for postActionsSdk without sending the request
     */ async postActionsSdkRequestOpts(requestParameters) {
        if (requestParameters['eventPostRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('eventPostRequest', 'Required parameter "eventPostRequest" was null or undefined when calling postActionsSdk().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/actions/sdk`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $905c70c78c26fa77$export$66614e5f3c5485b5)(requestParameters['eventPostRequest'])
        };
    }
    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */ async postActionsSdkRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postActionsSdkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */ async postActionsSdk(requestParameters, initOverrides) {
        await this.postActionsSdkRaw(requestParameters, initOverrides);
    }
    /**
     * Creates request options for postEvents without sending the request
     * @deprecated
     */ async postEventsRequestOpts(requestParameters) {
        if (requestParameters['eventPostRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('eventPostRequest', 'Required parameter "eventPostRequest" was null or undefined when calling postEvents().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/events`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $905c70c78c26fa77$export$66614e5f3c5485b5)(requestParameters['eventPostRequest'])
        };
    }
    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     * @deprecated
     */ async postEventsRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     * @deprecated
     */ async postEvents(requestParameters, initOverrides) {
        await this.postEventsRaw(requestParameters, initOverrides);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $78e8c31e67dc7105$export$82c043fe1b5e5059(value) {
    if (!('app_external_connection_id' in value) || value['app_external_connection_id'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    return true;
}
function $78e8c31e67dc7105$export$94e78b3c479e3125(json) {
    return $78e8c31e67dc7105$export$b999ce9b779710bf(json, false);
}
function $78e8c31e67dc7105$export$b999ce9b779710bf(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'app_external_connection_id': json['app_external_connection_id'],
        'identifier_from_source': json['identifier_from_source'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'action': json['action'] == null ? undefined : json['action'],
        'target': json['target'] == null ? undefined : json['target'],
        'valid_until': json['valid_until'] == null ? undefined : new Date(json['valid_until'])
    };
}
function $78e8c31e67dc7105$export$ab781605b7817e64(json) {
    return $78e8c31e67dc7105$export$2bba49d73294e3e9(json, false);
}
function $78e8c31e67dc7105$export$2bba49d73294e3e9(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'app_external_connection_id': value['app_external_connection_id'],
        'identifier_from_source': value['identifier_from_source'],
        'person_id': value['person_id'],
        'action': value['action'],
        'target': value['target'],
        'valid_until': value['valid_until'] == null ? value['valid_until'] : value['valid_until'].toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $8ec327bce67e963f$export$2b33f63a6a4553f3(value) {
    return true;
}
function $8ec327bce67e963f$export$eaef232e23385a70(json) {
    return $8ec327bce67e963f$export$637803582d27cb90(json, false);
}
function $8ec327bce67e963f$export$637803582d27cb90(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'description': json['description'] == null ? undefined : json['description'],
        'app_url': json['app_url'] == null ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'] == null ? undefined : json['identifier_from_source']
    };
}
function $8ec327bce67e963f$export$bcf97fbc35a59661(json) {
    return $8ec327bce67e963f$export$ceae9daf2099a4fa(json, false);
}
function $8ec327bce67e963f$export$ceae9daf2099a4fa(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'description': value['description'],
        'app_url': value['app_url'],
        'identifier_from_source': value['identifier_from_source']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $9c3346a00c5451c0$export$9c2d1510e8dfb302(value) {
    if (!('app_external_connection_id' in value) || value['app_external_connection_id'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    return true;
}
function $9c3346a00c5451c0$export$c74a933f53f7637b(json) {
    return $9c3346a00c5451c0$export$541c4a014f7a8150(json, false);
}
function $9c3346a00c5451c0$export$541c4a014f7a8150(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'app_external_connection_id': json['app_external_connection_id'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'app_url': json['app_url'] == null ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source']
    };
}
function $9c3346a00c5451c0$export$713e910df504db2f(json) {
    return $9c3346a00c5451c0$export$e94fc29575a26cf6(json, false);
}
function $9c3346a00c5451c0$export$e94fc29575a26cf6(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'app_external_connection_id': value['app_external_connection_id'],
        'person_id': value['person_id'],
        'description': value['description'],
        'app_url': value['app_url'],
        'identifier_from_source': value['identifier_from_source']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $3850644c10e1545f$export$bb30f99621eec4fd = {
    AzureTenant: 'azure_tenant',
    EntraTenant: 'entra_tenant',
    MicrosoftTenant: 'microsoft_tenant',
    AwsAccount: 'aws_account',
    AwsOrganization: 'aws_organization',
    GcpProject: 'gcp_project',
    GcpOrganization: 'gcp_organization',
    SnowflakeAccount: 'snowflake_account',
    DatabricksAccount: 'databricks_account',
    OktaOrg: 'okta_org',
    GoogleWorkspaceInstance: 'google_workspace_instance',
    SalesforceOrg: 'salesforce_org',
    ActiveDirectory: 'active_directory',
    PostgresInstance: 'postgres_instance',
    Auth0Domain: 'auth0_domain',
    KeeperAccount: 'keeper_account',
    OneloginOrganization: 'onelogin_organization',
    ServicenowInstance: 'servicenow_instance',
    Cyberark: 'cyberark',
    Anthropic: 'anthropic',
    Openai: 'openai',
    Slack: 'slack',
    Jira: 'jira',
    MongodbAtlas: 'mongodb_atlas',
    Indykite: 'indykite',
    MergeDevAccount: 'merge_dev_account',
    _7shiftsAccount: '7shifts_account',
    AdpDecidiumAccount: 'adp_decidium_account',
    AdpRunAccount: 'adp_run_account',
    AdpWorkforceNowAccount: 'adp_workforce_now_account',
    AlliancehcmAccount: 'alliancehcm_account',
    AlteraPayrollAccount: 'altera_payroll_account',
    BamboohrAccount: 'bamboohr_account',
    BreathehrAccount: 'breathehr_account',
    CezanneHrAccount: 'cezanne_hr_account',
    CharlieAccount: 'charlie_account',
    CharthopAccount: 'charthop_account',
    ClayhrAccount: 'clayhr_account',
    CoolcareAccount: 'coolcare_account',
    CyberarkTenant: 'cyberark_tenant',
    DarwinboxInstance: 'darwinbox_instance',
    DayforceInstance: 'dayforce_instance',
    DeelAccount: 'deel_account',
    EmploymentHeroAccount: 'employment_hero_account',
    FactorialAccount: 'factorial_account',
    FolksHrAccount: 'folks_hr_account',
    FreshteamAccount: 'freshteam_account',
    GustoAccount: 'gusto_account',
    HaileyHrAccount: 'hailey_hr_account',
    HibobAccount: 'hibob_account',
    HrCloudAccount: 'hr_cloud_account',
    HrPartnerAccount: 'hr_partner_account',
    HrworksAccount: 'hrworks_account',
    HumaansAccount: 'humaans_account',
    HumiAccount: 'humi_account',
    InsperityPremierAccount: 'insperity_premier_account',
    IntellihrTenant: 'intellihr_tenant',
    IrisCascadeAccount: 'iris_cascade_account',
    IsolvedInstance: 'isolved_instance',
    JumpcloudTenant: 'jumpcloud_tenant',
    JustworksAccount: 'justworks_account',
    KallidusTenant: 'kallidus_tenant',
    KekaAccount: 'keka_account',
    KenjoAccount: 'kenjo_account',
    LanoAccount: 'lano_account',
    LatticeHrisAccount: 'lattice_hris_account',
    LeapsomeAccount: 'leapsome_account',
    LuccaInstance: 'lucca_instance',
    MicrosoftEntraIdTenant: 'microsoft_entra_id_tenant',
    NamelyInstance: 'namely_instance',
    NmbrsAccount: 'nmbrs_account',
    OfficientAccount: 'officient_account',
    OracleCloudHumanCapitalManagementHcmInstance: 'oracle_cloud_human_capital_management_hcm_instance',
    OysterhrAccount: 'oysterhr_account',
    PaycaptainAccount: 'paycaptain_account',
    PaychexAccount: 'paychex_account',
    PaycomAccount: 'paycom_account',
    PaycorAccount: 'paycor_account',
    PayfitAccount: 'payfit_account',
    PaylocityInstance: 'paylocity_instance',
    PeoplehrAccount: 'peoplehr_account',
    PersonioAccount: 'personio_account',
    PingoneTenant: 'pingone_tenant',
    PlandayAccount: 'planday_account',
    ProliantAccount: 'proliant_account',
    RemoteAccount: 'remote_account',
    RevolutPeopleAccount: 'revolut_people_account',
    RipplingAccount: 'rippling_account',
    SageHrAccount: 'sage_hr_account',
    SagePeopleInstance: 'sage_people_instance',
    SapSuccessfactorsInstance: 'sap_successfactors_instance',
    SesameAccount: 'sesame_account',
    SimployerAccount: 'simployer_account',
    SquarePayrollAccount: 'square_payroll_account',
    TrinetAccount: 'trinet_account',
    TrinetHrPlatformAccount: 'trinet_hr_platform_account',
    UkgProInstance: 'ukg_pro_instance',
    UkgProWorkforceManagementInstance: 'ukg_pro_workforce_management_instance',
    UkgReadyInstance: 'ukg_ready_instance',
    WorkdayTenant: 'workday_tenant',
    ZeltAccount: 'zelt_account',
    ZohoPeopleAccount: 'zoho_people_account',
    SlashidIpBrowserExtension: 'slashid_ip_browser_extension',
    Slashid: 'slashid',
    GateInstance: 'gate_instance',
    Github: 'github',
    Scim: 'scim',
    BatonConnector: 'baton_connector',
    TestingDummy: 'testing_dummy',
    StaticFile: 'static_file',
    Failure: 'failure',
    ManualImport: 'manual_import'
};
function $3850644c10e1545f$export$bc81d83a36226076(value) {
    for(const key in $3850644c10e1545f$export$bb30f99621eec4fd)if (Object.prototype.hasOwnProperty.call($3850644c10e1545f$export$bb30f99621eec4fd, key)) {
        if ($3850644c10e1545f$export$bb30f99621eec4fd[key] === value) return true;
    }
    return false;
}
function $3850644c10e1545f$export$c90756f0bdba423a(json) {
    return $3850644c10e1545f$export$edce08ef50dc3a0c(json, false);
}
function $3850644c10e1545f$export$edce08ef50dc3a0c(json, ignoreDiscriminator) {
    return json;
}
function $3850644c10e1545f$export$f47b422e3f4b9b3e(value) {
    return value;
}
function $3850644c10e1545f$export$95cd7e2bf4a8f780(value, ignoreDiscriminator) {
    return value;
}


function $3630661202b5c3d0$export$9c24dacb8ec047ba(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}
function $3630661202b5c3d0$export$a496a8e3e8eff53(json) {
    return $3630661202b5c3d0$export$c4178a8104b3fef(json, false);
}
function $3630661202b5c3d0$export$c4178a8104b3fef(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'source': (0, $3850644c10e1545f$export$c90756f0bdba423a)(json['source'])
    };
}
function $3630661202b5c3d0$export$cbbaf171df3f7f4b(json) {
    return $3630661202b5c3d0$export$8dec23780ba59edc(json, false);
}
function $3630661202b5c3d0$export$8dec23780ba59edc(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'name': value['name'],
        'source': (0, $3850644c10e1545f$export$f47b422e3f4b9b3e)(value['source'])
    };
}


function $cd978a0224e46d71$export$295748d69f46be2e(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('app_external_connection' in value) || value['app_external_connection'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    return true;
}
function $cd978a0224e46d71$export$cdcddf470e8f985e(json) {
    return $cd978a0224e46d71$export$cdb50f870efe7dcb(json, false);
}
function $cd978a0224e46d71$export$cdb50f870efe7dcb(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'organization_id': json['organization_id'],
        'person_id': json['person_id'],
        'app_external_connection': (0, $3630661202b5c3d0$export$a496a8e3e8eff53)(json['app_external_connection']),
        'description': json['description'] == null ? undefined : json['description'],
        'app_url': json['app_url'] == null ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'],
        'created_at': json['created_at'] == null ? undefined : new Date(json['created_at']),
        'last_updated_at': json['last_updated_at'] == null ? undefined : new Date(json['last_updated_at'])
    };
}
function $cd978a0224e46d71$export$a3c2010a015bfa63(json) {
    return $cd978a0224e46d71$export$8378863e733bae76(json, false);
}
function $cd978a0224e46d71$export$8378863e733bae76(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'organization_id': value['organization_id'],
        'person_id': value['person_id'],
        'app_external_connection': (0, $3630661202b5c3d0$export$cbbaf171df3f7f4b)(value['app_external_connection']),
        'description': value['description'],
        'app_url': value['app_url'],
        'identifier_from_source': value['identifier_from_source'],
        'created_at': value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
        'last_updated_at': value['last_updated_at'] == null ? value['last_updated_at'] : value['last_updated_at'].toISOString()
    };
}



function $5e348c6dafe82753$export$e2a5b188a7a3984e(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $5e348c6dafe82753$export$9311c675ce875841(json) {
    return $5e348c6dafe82753$export$5ebc75657a58dbd9(json, false);
}
function $5e348c6dafe82753$export$5ebc75657a58dbd9(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'].map((0, $cd978a0224e46d71$export$cdcddf470e8f985e))
    };
}
function $5e348c6dafe82753$export$6cc3b89074183c54(json) {
    return $5e348c6dafe82753$export$4ebea1dfcca1d631(json, false);
}
function $5e348c6dafe82753$export$4ebea1dfcca1d631(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result'].map((0, $cd978a0224e46d71$export$a3c2010a015bfa63))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $2c7308dc3bac5d24$export$e8aeeb6b229f0e49(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('app_external_connection_id' in value) || value['app_external_connection_id'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    if (!('external_identity_id' in value) || value['external_identity_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}
function $2c7308dc3bac5d24$export$c86d3d6e3d30cc42(json) {
    return $2c7308dc3bac5d24$export$1e3a1ec579e97cb3(json, false);
}
function $2c7308dc3bac5d24$export$1e3a1ec579e97cb3(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'organization_id': json['organization_id'],
        'app_external_connection_id': json['app_external_connection_id'],
        'identifier_from_source': json['identifier_from_source'],
        'external_identity_id': json['external_identity_id'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'status': json['status'],
        'action': json['action'],
        'target': json['target'],
        'requested_at': json['requested_at'] == null ? undefined : new Date(json['requested_at']),
        'expires_at': json['expires_at'] == null ? undefined : new Date(json['expires_at']),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'revert_action': json['revert_action'] == null ? undefined : json['revert_action'],
        'revert_action_target': json['revert_action_target'] == null ? undefined : json['revert_action_target'],
        'reverted': json['reverted'] == null ? undefined : json['reverted']
    };
}
function $2c7308dc3bac5d24$export$cabce697ca3f5ba0(json) {
    return $2c7308dc3bac5d24$export$31326b8ba0b0a67f(json, false);
}
function $2c7308dc3bac5d24$export$31326b8ba0b0a67f(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'organization_id': value['organization_id'],
        'app_external_connection_id': value['app_external_connection_id'],
        'identifier_from_source': value['identifier_from_source'],
        'external_identity_id': value['external_identity_id'],
        'person_id': value['person_id'],
        'status': value['status'],
        'action': value['action'],
        'target': value['target'],
        'requested_at': value['requested_at'] == null ? value['requested_at'] : value['requested_at'].toISOString(),
        'expires_at': value['expires_at'] == null ? value['expires_at'] : value['expires_at'].toISOString(),
        'reason': value['reason'],
        'revert_action': value['revert_action'],
        'revert_action_target': value['revert_action_target'],
        'reverted': value['reverted']
    };
}



function $4af5d43b21c29cc3$export$cbe44bb5a42960f5(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $4af5d43b21c29cc3$export$161623e0e2804f3d(json) {
    return $4af5d43b21c29cc3$export$d7dab2d9a314bdcd(json, false);
}
function $4af5d43b21c29cc3$export$d7dab2d9a314bdcd(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'].map((0, $2c7308dc3bac5d24$export$c86d3d6e3d30cc42))
    };
}
function $4af5d43b21c29cc3$export$f2afc04e7c8c58d9(json) {
    return $4af5d43b21c29cc3$export$63d5dfd21ea6b219(json, false);
}
function $4af5d43b21c29cc3$export$63d5dfd21ea6b219(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result'].map((0, $2c7308dc3bac5d24$export$cabce697ca3f5ba0))
    };
}


class $f4f6b7e9aa0d015f$export$3d5605800d7a85c9 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for deleteAccessRequestsAppRulesRuleID without sending the request
     */ async deleteAccessRequestsAppRulesRuleIDRequestOpts(requestParameters) {
        if (requestParameters['accessRuleId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('accessRuleId', 'Required parameter "accessRuleId" was null or undefined when calling deleteAccessRequestsAppRulesRuleID().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling deleteAccessRequestsAppRulesRuleID().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/app-rules/{access_rule_id}`;
        urlPath = urlPath.replace('{access_rule_id}', encodeURIComponent(String(requestParameters['accessRuleId'])));
        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Delete access rule for the given access rule ID 
     * Delete access rule for the given access rule ID
     */ async deleteAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides) {
        const requestOptions = await this.deleteAccessRequestsAppRulesRuleIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Delete access rule for the given access rule ID 
     * Delete access rule for the given access rule ID
     */ async deleteAccessRequestsAppRulesRuleID(requestParameters, initOverrides) {
        await this.deleteAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides);
    }
    /**
     * Creates request options for getAccessRequestsAppRulesMe without sending the request
     */ async getAccessRequestsAppRulesMeRequestOpts() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/app-rules/me`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve all access rules of the person identified by the token 
     * Get all access rules of the person identified by the token
     */ async getAccessRequestsAppRulesMeRaw(initOverrides) {
        const requestOptions = await this.getAccessRequestsAppRulesMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e348c6dafe82753$export$9311c675ce875841)(jsonValue));
    }
    /**
     * Retrieve all access rules of the person identified by the token 
     * Get all access rules of the person identified by the token
     */ async getAccessRequestsAppRulesMe(initOverrides) {
        const response = await this.getAccessRequestsAppRulesMeRaw(initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getAccessRequestsAppRulesPersonsPersonID without sending the request
     */ async getAccessRequestsAppRulesPersonsPersonIDRequestOpts(requestParameters) {
        if (requestParameters['personId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('personId', 'Required parameter "personId" was null or undefined when calling getAccessRequestsAppRulesPersonsPersonID().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getAccessRequestsAppRulesPersonsPersonID().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/app-rules/persons/{person_id}`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve all app access rules of the given person 
     * Get all app access rules of the given person
     */ async getAccessRequestsAppRulesPersonsPersonIDRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getAccessRequestsAppRulesPersonsPersonIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e348c6dafe82753$export$9311c675ce875841)(jsonValue));
    }
    /**
     * Retrieve all app access rules of the given person 
     * Get all app access rules of the given person
     */ async getAccessRequestsAppRulesPersonsPersonID(requestParameters, initOverrides) {
        const response = await this.getAccessRequestsAppRulesPersonsPersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getAccessRequestsMe without sending the request
     */ async getAccessRequestsMeRequestOpts() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/me`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve all access requests of the person identified by the token 
     * Get all access requests of the person identified by the token
     */ async getAccessRequestsMeRaw(initOverrides) {
        const requestOptions = await this.getAccessRequestsMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4af5d43b21c29cc3$export$161623e0e2804f3d)(jsonValue));
    }
    /**
     * Retrieve all access requests of the person identified by the token 
     * Get all access requests of the person identified by the token
     */ async getAccessRequestsMe(initOverrides) {
        const response = await this.getAccessRequestsMeRaw(initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getAccessRequestsPersonsPersonID without sending the request
     */ async getAccessRequestsPersonsPersonIDRequestOpts(requestParameters) {
        if (requestParameters['personId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('personId', 'Required parameter "personId" was null or undefined when calling getAccessRequestsPersonsPersonID().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getAccessRequestsPersonsPersonID().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/persons/{person_id}`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve all access requests of the given person 
     * Get all access requests of the given person
     */ async getAccessRequestsPersonsPersonIDRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getAccessRequestsPersonsPersonIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4af5d43b21c29cc3$export$161623e0e2804f3d)(jsonValue));
    }
    /**
     * Retrieve all access requests of the given person 
     * Get all access requests of the given person
     */ async getAccessRequestsPersonsPersonID(requestParameters, initOverrides) {
        const response = await this.getAccessRequestsPersonsPersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for patchAccessRequestsAppRulesRuleID without sending the request
     */ async patchAccessRequestsAppRulesRuleIDRequestOpts(requestParameters) {
        if (requestParameters['accessRuleId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('accessRuleId', 'Required parameter "accessRuleId" was null or undefined when calling patchAccessRequestsAppRulesRuleID().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling patchAccessRequestsAppRulesRuleID().');
        if (requestParameters['accessRequestsAppAccessRulePatchRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('accessRequestsAppAccessRulePatchRequest', 'Required parameter "accessRequestsAppAccessRulePatchRequest" was null or undefined when calling patchAccessRequestsAppRulesRuleID().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/app-rules/{access_rule_id}`;
        urlPath = urlPath.replace('{access_rule_id}', encodeURIComponent(String(requestParameters['accessRuleId'])));
        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8ec327bce67e963f$export$bcf97fbc35a59661)(requestParameters['accessRequestsAppAccessRulePatchRequest'])
        };
    }
    /**
     * Update access levels for the given app and external person ID 
     * Update access levels for the given access level ID
     */ async patchAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides) {
        const requestOptions = await this.patchAccessRequestsAppRulesRuleIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Update access levels for the given app and external person ID 
     * Update access levels for the given access level ID
     */ async patchAccessRequestsAppRulesRuleID(requestParameters, initOverrides) {
        await this.patchAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides);
    }
    /**
     * Creates request options for postAccessRequestsAppRulePersonID without sending the request
     */ async postAccessRequestsAppRulePersonIDRequestOpts(requestParameters) {
        if (requestParameters['personId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('personId', 'Required parameter "personId" was null or undefined when calling postAccessRequestsAppRulePersonID().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postAccessRequestsAppRulePersonID().');
        if (requestParameters['accessRequestsAppAccessRulePostRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('accessRequestsAppAccessRulePostRequest', 'Required parameter "accessRequestsAppAccessRulePostRequest" was null or undefined when calling postAccessRequestsAppRulePersonID().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/app-rules/persons/{person_id}`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9c3346a00c5451c0$export$713e910df504db2f)(requestParameters['accessRequestsAppAccessRulePostRequest'])
        };
    }
    /**
     * Create a new access rule for the given app and external person ID 
     * Create the access rule for the given app and person
     */ async postAccessRequestsAppRulePersonIDRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postAccessRequestsAppRulePersonIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create a new access rule for the given app and external person ID 
     * Create the access rule for the given app and person
     */ async postAccessRequestsAppRulePersonID(requestParameters, initOverrides) {
        const response = await this.postAccessRequestsAppRulePersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postAccessRequestsMeAccessRuleID without sending the request
     */ async postAccessRequestsMeAccessRuleIDRequestOpts(requestParameters) {
        if (requestParameters['accessRuleId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('accessRuleId', 'Required parameter "accessRuleId" was null or undefined when calling postAccessRequestsMeAccessRuleID().');
        if (requestParameters['accessRequestPostRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('accessRequestPostRequest', 'Required parameter "accessRequestPostRequest" was null or undefined when calling postAccessRequestsMeAccessRuleID().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/ip/access-requests/me/{access_rule_id}`;
        urlPath = urlPath.replace('{access_rule_id}', encodeURIComponent(String(requestParameters['accessRuleId'])));
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $78e8c31e67dc7105$export$ab781605b7817e64)(requestParameters['accessRequestPostRequest'])
        };
    }
    /**
     * Create a new access request as the authenticated person for the given access rule 
     * Request access
     */ async postAccessRequestsMeAccessRuleIDRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postAccessRequestsMeAccessRuleIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $14533c91dcba43d9$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create a new access request as the authenticated person for the given access rule 
     * Request access
     */ async postAccessRequestsMeAccessRuleID(requestParameters, initOverrides) {
        const response = await this.postAccessRequestsMeAccessRuleIDRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $6b40c56f1381da45$export$eef10d01a2c1f1fd(value) {
    return true;
}
function $6b40c56f1381da45$export$eb7192996dd32ff1(json) {
    return $6b40c56f1381da45$export$a1206befefec411c(json, false);
}
function $6b40c56f1381da45$export$a1206befefec411c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        ...json,
        'dynamicFlowConfig': json['dynamicFlowConfig'] == null ? undefined : json['dynamicFlowConfig'],
        'dynamicFlowEnabled': json['dynamicFlowEnabled'] == null ? undefined : json['dynamicFlowEnabled'],
        'handleTypes': json['handleTypes'] == null ? undefined : json['handleTypes'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'pageBackgroundColor': json['pageBackgroundColor'] == null ? undefined : json['pageBackgroundColor'],
        'showBadge': json['showBadge'] == null ? undefined : json['showBadge'],
        'storeLastFactor': json['storeLastFactor'] == null ? undefined : json['storeLastFactor'],
        'supportURL': json['supportURL'] == null ? undefined : json['supportURL'],
        'alternativeAuthURL': json['alternativeAuthURL'] == null ? undefined : json['alternativeAuthURL'],
        'faviconUrl': json['faviconUrl'] == null ? undefined : json['faviconUrl'],
        'pageTitle': json['pageTitle'] == null ? undefined : json['pageTitle'],
        'themeVars': json['themeVars'] == null ? undefined : json['themeVars'],
        'textOverrides': json['textOverrides'] == null ? undefined : json['textOverrides']
    };
}
function $6b40c56f1381da45$export$342cad717a3ff356(json) {
    return $6b40c56f1381da45$export$2049292f9c8b953(json, false);
}
function $6b40c56f1381da45$export$2049292f9c8b953(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        ...value,
        'dynamicFlowConfig': value['dynamicFlowConfig'],
        'dynamicFlowEnabled': value['dynamicFlowEnabled'],
        'handleTypes': value['handleTypes'],
        'logoUrl': value['logoUrl'],
        'pageBackgroundColor': value['pageBackgroundColor'],
        'showBadge': value['showBadge'],
        'storeLastFactor': value['storeLastFactor'],
        'supportURL': value['supportURL'],
        'alternativeAuthURL': value['alternativeAuthURL'],
        'faviconUrl': value['faviconUrl'],
        'pageTitle': value['pageTitle'],
        'themeVars': value['themeVars'],
        'textOverrides': value['textOverrides']
    };
}



function $fb522647e9673dcc$export$249857882e2b6911(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $fb522647e9673dcc$export$d8841886796c20dc(json) {
    return $fb522647e9673dcc$export$50a0305299b21849(json, false);
}
function $fb522647e9673dcc$export$50a0305299b21849(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $6b40c56f1381da45$export$eb7192996dd32ff1)(json['result'])
    };
}
function $fb522647e9673dcc$export$38d8ca40da939ec5(json) {
    return $fb522647e9673dcc$export$cf8882afaa95e06b(json, false);
}
function $fb522647e9673dcc$export$cf8882afaa95e06b(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $6b40c56f1381da45$export$342cad717a3ff356)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $210c927519114190$export$87619f8d9400d5e(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $210c927519114190$export$2c0ca39127b0b0ee(json) {
    return $210c927519114190$export$bbdc79fff298ed2(json, false);
}
function $210c927519114190$export$bbdc79fff298ed2(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $6b40c56f1381da45$export$eb7192996dd32ff1)(json['result'])
    };
}
function $210c927519114190$export$4fa751dbc7b2fdcd(json) {
    return $210c927519114190$export$e5fe9fd4e1932aa4(json, false);
}
function $210c927519114190$export$e5fe9fd4e1932aa4(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $6b40c56f1381da45$export$342cad717a3ff356)(value['result'])
    };
}


class $b315d416539db874$export$1e24a9a035ad8fd4 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for getOauth2UiConfiguration without sending the request
     */ async getOauth2UiConfigurationRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getOauth2UiConfiguration().');
        if (requestParameters['oauthClientId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('oauthClientId', 'Required parameter "oauthClientId" was null or undefined when calling getOauth2UiConfiguration().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/oauth2/clients/{oauth_client_id}/ui-configuration`;
        urlPath = urlPath.replace('{oauth_client_id}', encodeURIComponent(String(requestParameters['oauthClientId'])));
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */ async getOauth2UiConfigurationRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getOauth2UiConfigurationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb522647e9673dcc$export$d8841886796c20dc)(jsonValue));
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */ async getOauth2UiConfiguration(requestParameters, initOverrides) {
        const response = await this.getOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for putOauth2UiConfiguration without sending the request
     */ async putOauth2UiConfigurationRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling putOauth2UiConfiguration().');
        if (requestParameters['oauthClientId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('oauthClientId', 'Required parameter "oauthClientId" was null or undefined when calling putOauth2UiConfiguration().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (requestParameters['slashIDRequiredConsistency'] != null) headerParameters['SlashID-Required-Consistency'] = String(requestParameters['slashIDRequiredConsistency']);
        if (requestParameters['slashIDRequiredConsistencyTimeout'] != null) headerParameters['SlashID-Required-Consistency-Timeout'] = String(requestParameters['slashIDRequiredConsistencyTimeout']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/oauth2/clients/{oauth_client_id}/ui-configuration`;
        urlPath = urlPath.replace('{oauth_client_id}', encodeURIComponent(String(requestParameters['oauthClientId'])));
        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body']
        };
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */ async putOauth2UiConfigurationRaw(requestParameters, initOverrides) {
        const requestOptions = await this.putOauth2UiConfigurationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $210c927519114190$export$2c0ca39127b0b0ee)(jsonValue));
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */ async putOauth2UiConfiguration(requestParameters, initOverrides) {
        const response = await this.putOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $b315d416539db874$export$1a24f15758dea0bf = {
    LocalRegion: 'local_region',
    AllRegions: 'all_regions'
};


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $0782d2a8c1382e3f$export$49c721d3b17e45a9(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $0782d2a8c1382e3f$export$e49e5c369c7975ca(json) {
    return $0782d2a8c1382e3f$export$42f0009a6a119705(json, false);
}
function $0782d2a8c1382e3f$export$42f0009a6a119705(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'].map((0, $9f19915761c92516$export$7a11cc6365c7aa2d))
    };
}
function $0782d2a8c1382e3f$export$63c3dea4ad48cd83(json) {
    return $0782d2a8c1382e3f$export$e8ef17781b5fa5d0(json, false);
}
function $0782d2a8c1382e3f$export$e8ef17781b5fa5d0(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result'].map((0, $9f19915761c92516$export$44957b028259275f))
    };
}


class $81679c154113c7c9$export$ea419959b1ecf403 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for getOrganizationsTeam without sending the request
     */ async getOrganizationsTeamRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getOrganizationsTeam().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/organizations/team`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */ async getOrganizationsTeamRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getOrganizationsTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $0782d2a8c1382e3f$export$e49e5c369c7975ca)(jsonValue));
    }
    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */ async getOrganizationsTeam(requestParameters, initOverrides) {
        const response = await this.getOrganizationsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $18a0deb50f01f214$export$93b980a799206137 = {
    None: 'none',
    Necessary: 'necessary',
    Analytics: 'analytics',
    Marketing: 'marketing',
    Retargeting: 'retargeting',
    Tracking: 'tracking'
};
function $18a0deb50f01f214$export$1cf834588d1f9d4d(value) {
    for(const key in $18a0deb50f01f214$export$93b980a799206137)if (Object.prototype.hasOwnProperty.call($18a0deb50f01f214$export$93b980a799206137, key)) {
        if ($18a0deb50f01f214$export$93b980a799206137[key] === value) return true;
    }
    return false;
}
function $18a0deb50f01f214$export$84b3f9c7224f9426(json) {
    return $18a0deb50f01f214$export$2b6529f2847f83f3(json, false);
}
function $18a0deb50f01f214$export$2b6529f2847f83f3(json, ignoreDiscriminator) {
    return json;
}
function $18a0deb50f01f214$export$44aa2b641bcf85ed(value) {
    return value;
}
function $18a0deb50f01f214$export$2d6309add0811bab(value, ignoreDiscriminator) {
    return value;
}


function $67680d58379a970f$export$3b26bc4ccb5a8638(value) {
    if (!('consent_levels' in value) || value['consent_levels'] === undefined) return false;
    return true;
}
function $67680d58379a970f$export$e6ed4604e88d95a3(json) {
    return $67680d58379a970f$export$f4394eac4a865068(json, false);
}
function $67680d58379a970f$export$f4394eac4a865068(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'consent_levels': json['consent_levels'].map((0, $18a0deb50f01f214$export$84b3f9c7224f9426))
    };
}
function $67680d58379a970f$export$13e148a83364b95(json) {
    return $67680d58379a970f$export$8512edb30c98a646(json, false);
}
function $67680d58379a970f$export$8512edb30c98a646(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'consent_levels': value['consent_levels'].map((0, $18a0deb50f01f214$export$44aa2b641bcf85ed))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $f54e65351dc1dc00$export$b97766b7c6c0cc46(value) {
    if (!('consent_level' in value) || value['consent_level'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}
function $f54e65351dc1dc00$export$40975273e0c4497a(json) {
    return $f54e65351dc1dc00$export$b727b488f0f7a4e4(json, false);
}
function $f54e65351dc1dc00$export$b727b488f0f7a4e4(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'consent_level': (0, $18a0deb50f01f214$export$84b3f9c7224f9426)(json['consent_level']),
        'created_at': new Date(json['created_at'])
    };
}
function $f54e65351dc1dc00$export$780e4ae93000f66b(json) {
    return $f54e65351dc1dc00$export$c0ec8afe82e1078(json, false);
}
function $f54e65351dc1dc00$export$c0ec8afe82e1078(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'consent_level': (0, $18a0deb50f01f214$export$44aa2b641bcf85ed)(value['consent_level']),
        'created_at': value['created_at'].toISOString()
    };
}


function $4b75b7282065ee63$export$d0fc3d616092a245(value) {
    if (!('consents' in value) || value['consents'] === undefined) return false;
    return true;
}
function $4b75b7282065ee63$export$b9e34caf47c08b2(json) {
    return $4b75b7282065ee63$export$afe857fd8914318a(json, false);
}
function $4b75b7282065ee63$export$afe857fd8914318a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'consents': json['consents'].map((0, $f54e65351dc1dc00$export$40975273e0c4497a))
    };
}
function $4b75b7282065ee63$export$2321b26b111a9baa(json) {
    return $4b75b7282065ee63$export$d708bb8724f2251d(json, false);
}
function $4b75b7282065ee63$export$d708bb8724f2251d(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'consents': value['consents'].map((0, $f54e65351dc1dc00$export$780e4ae93000f66b))
    };
}




function $fab34cdd8fefeb59$export$6b31ef8e968a4ecf(value) {
    return true;
}
function $fab34cdd8fefeb59$export$d8f7fb0a0d937eb3(json) {
    return $fab34cdd8fefeb59$export$357be021b1018458(json, false);
}
function $fab34cdd8fefeb59$export$357be021b1018458(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : (0, $4b75b7282065ee63$export$b9e34caf47c08b2)(json['result'])
    };
}
function $fab34cdd8fefeb59$export$2fd73e9f9376edfe(json) {
    return $fab34cdd8fefeb59$export$32df55b6545ba18e(json, false);
}
function $fab34cdd8fefeb59$export$32df55b6545ba18e(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $4b75b7282065ee63$export$2321b26b111a9baa)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $be723a6c64264a1c$export$fe0e3a34c423c852(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $be723a6c64264a1c$export$5cffeb8ce2443b10(json) {
    return $be723a6c64264a1c$export$2e5f50cb2cd6002e(json, false);
}
function $be723a6c64264a1c$export$2e5f50cb2cd6002e(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $4b75b7282065ee63$export$b9e34caf47c08b2)(json['result'])
    };
}
function $be723a6c64264a1c$export$c38eda6721591941(json) {
    return $be723a6c64264a1c$export$911da9ca9bfdd600(json, false);
}
function $be723a6c64264a1c$export$911da9ca9bfdd600(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $4b75b7282065ee63$export$2321b26b111a9baa)(value['result'])
    };
}


class $3be9d8c115e99746$export$f2ae3e6781ddb521 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for deleteConsentGdpr without sending the request
     */ async deleteConsentGdprRequestOpts(requestParameters) {
        const queryParameters = {};
        if (requestParameters['consentLevels'] != null) queryParameters['consent_levels'] = requestParameters['consentLevels'];
        if (requestParameters['deleteAll'] != null) queryParameters['deleteAll'] = requestParameters['deleteAll'];
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/consent/gdpr`;
        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */ async deleteConsentGdprRaw(requestParameters, initOverrides) {
        const requestOptions = await this.deleteConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */ async deleteConsentGdpr(requestParameters = {}, initOverrides) {
        await this.deleteConsentGdprRaw(requestParameters, initOverrides);
    }
    /**
     * Creates request options for getConsentGdpr without sending the request
     */ async getConsentGdprRequestOpts(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/consent/gdpr`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */ async getConsentGdprRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fab34cdd8fefeb59$export$d8f7fb0a0d937eb3)(jsonValue));
    }
    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */ async getConsentGdpr(requestParameters = {}, initOverrides) {
        const response = await this.getConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postConsentGdpr without sending the request
     */ async postConsentGdprRequestOpts(requestParameters) {
        if (requestParameters['gDPRConsentRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('gDPRConsentRequest', 'Required parameter "gDPRConsentRequest" was null or undefined when calling postConsentGdpr().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/consent/gdpr`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $67680d58379a970f$export$13e148a83364b95)(requestParameters['gDPRConsentRequest'])
        };
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */ async postConsentGdprRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $be723a6c64264a1c$export$5cffeb8ce2443b10)(jsonValue));
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */ async postConsentGdpr(requestParameters, initOverrides) {
        const response = await this.postConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for putConsentGdpr without sending the request
     */ async putConsentGdprRequestOpts(requestParameters) {
        if (requestParameters['gDPRConsentRequest'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('gDPRConsentRequest', 'Required parameter "gDPRConsentRequest" was null or undefined when calling putConsentGdpr().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/consent/gdpr`;
        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $67680d58379a970f$export$13e148a83364b95)(requestParameters['gDPRConsentRequest'])
        };
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */ async putConsentGdprRaw(requestParameters, initOverrides) {
        const requestOptions = await this.putConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $be723a6c64264a1c$export$5cffeb8ce2443b10)(jsonValue));
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */ async putConsentGdpr(requestParameters, initOverrides) {
        const response = await this.putConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $27728e3d4c36f1eb$export$35d1912a6e65a4d3(value) {
    return true;
}
function $27728e3d4c36f1eb$export$f24df1e4bf994e2e(json) {
    return $27728e3d4c36f1eb$export$77e0f518496a5152(json, false);
}
function $27728e3d4c36f1eb$export$77e0f518496a5152(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'region': json['region'] == null ? undefined : (0, $06d8b53811848e68$export$4599c92435bbba6e)(json['region'])
    };
}
function $27728e3d4c36f1eb$export$da1543be29a31e9e(json) {
    return $27728e3d4c36f1eb$export$6723087d6e906fbe(json, false);
}
function $27728e3d4c36f1eb$export$6723087d6e906fbe(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'region': (0, $06d8b53811848e68$export$2ac40160f30291ff)(value['region'])
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $f6acf15ef9b0c7a1$export$21d3a66e6f16843c(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $f6acf15ef9b0c7a1$export$fd10bc7066dcb68(json) {
    return $f6acf15ef9b0c7a1$export$f7f5a51deed9412a(json, false);
}
function $f6acf15ef9b0c7a1$export$f7f5a51deed9412a(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result']
    };
}
function $f6acf15ef9b0c7a1$export$e1bf2284efe0a85b(json) {
    return $f6acf15ef9b0c7a1$export$c9aa505a292d63e4(json, false);
}
function $f6acf15ef9b0c7a1$export$c9aa505a292d63e4(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $6ded8ecab210edb0$export$5bc3de0eceaddcf(value) {
    if (!('target_url' in value) || value['target_url'] === undefined) return false;
    return true;
}
function $6ded8ecab210edb0$export$17bd01fc1408c51a(json) {
    return $6ded8ecab210edb0$export$521f70f9625079b4(json, false);
}
function $6ded8ecab210edb0$export$521f70f9625079b4(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'target_url': json['target_url']
    };
}
function $6ded8ecab210edb0$export$6d86ef56b25a83c4(json) {
    return $6ded8ecab210edb0$export$a770154a971d69f1(json, false);
}
function $6ded8ecab210edb0$export$a770154a971d69f1(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'target_url': value['target_url']
    };
}


class $f0e0cb433712a97f$export$f5f4fdd1b1ffabb3 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for postPersonsAnonymous without sending the request
     */ async postPersonsAnonymousRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postPersonsAnonymous().');
        if (requestParameters['anonymousPersonCreateReq'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('anonymousPersonCreateReq', 'Required parameter "anonymousPersonCreateReq" was null or undefined when calling postPersonsAnonymous().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/persons/anonymous`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $27728e3d4c36f1eb$export$da1543be29a31e9e)(requestParameters['anonymousPersonCreateReq'])
        };
    }
    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */ async postPersonsAnonymousRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postPersonsAnonymousRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d7be6a714136ad3$export$6cc59d6581215347)(jsonValue));
    }
    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */ async postPersonsAnonymous(requestParameters, initOverrides) {
        const response = await this.postPersonsAnonymousRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postPersonsPersonIdImpersonate without sending the request
     */ async postPersonsPersonIdImpersonateRequestOpts(requestParameters) {
        if (requestParameters['personId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('personId', 'Required parameter "personId" was null or undefined when calling postPersonsPersonIdImpersonate().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postPersonsPersonIdImpersonate().');
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/persons/{person_id}/impersonate`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonateRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postPersonsPersonIdImpersonateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f6acf15ef9b0c7a1$export$fd10bc7066dcb68)(jsonValue));
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonate(requestParameters, initOverrides) {
        const response = await this.postPersonsPersonIdImpersonateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for postPersonsPersonIdImpersonateV2 without sending the request
     */ async postPersonsPersonIdImpersonateV2RequestOpts(requestParameters) {
        if (requestParameters['personId'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('personId', 'Required parameter "personId" was null or undefined when calling postPersonsPersonIdImpersonateV2().');
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling postPersonsPersonIdImpersonateV2().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/persons/{person_id}/impersonate/v2`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6ded8ecab210edb0$export$6d86ef56b25a83c4)(requestParameters['postPersonsPersonIdImpersonateV2Request'])
        };
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonateV2Raw(requestParameters, initOverrides) {
        const requestOptions = await this.postPersonsPersonIdImpersonateV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f6acf15ef9b0c7a1$export$fd10bc7066dcb68)(jsonValue));
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonateV2(requestParameters, initOverrides) {
        const response = await this.postPersonsPersonIdImpersonateV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ const $43d3de7c5f722f6f$export$74642ff6513c42f0 = {
    AccessToken: 'access_token',
    RefreshToken: 'refresh_token'
};
function $43d3de7c5f722f6f$export$3299428192128c4e(value) {
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('token_type' in value) || value['token_type'] === undefined) return false;
    return true;
}
function $43d3de7c5f722f6f$export$2b054aa42fb96c00(json) {
    return $43d3de7c5f722f6f$export$9e8b1a926c948613(json, false);
}
function $43d3de7c5f722f6f$export$9e8b1a926c948613(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'client_id': json['client_id'],
        'token': json['token'],
        'token_type': json['token_type']
    };
}
function $43d3de7c5f722f6f$export$5934f2de036cb99d(json) {
    return $43d3de7c5f722f6f$export$6280a2977aec5dfa(json, false);
}
function $43d3de7c5f722f6f$export$6280a2977aec5dfa(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'client_id': value['client_id'],
        'token': value['token'],
        'token_type': value['token_type']
    };
}


class $db137ea44eaea799$export$635f2ea50ea7a4cd extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for postSsoOidcTokensRevoke without sending the request
     * @deprecated
     */ async postSsoOidcTokensRevokeRequestOpts(requestParameters) {
        if (requestParameters['oAuthTokenRevokeReq'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('oAuthTokenRevokeReq', 'Required parameter "oAuthTokenRevokeReq" was null or undefined when calling postSsoOidcTokensRevoke().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/sso/oidc/tokens/revoke`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $43d3de7c5f722f6f$export$5934f2de036cb99d)(requestParameters['oAuthTokenRevokeReq'])
        };
    }
    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     * @deprecated
     */ async postSsoOidcTokensRevokeRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postSsoOidcTokensRevokeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     * @deprecated
     */ async postSsoOidcTokensRevoke(requestParameters, initOverrides) {
        await this.postSsoOidcTokensRevokeRaw(requestParameters, initOverrides);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $885bdc8cdaf7ea68$export$470028e44ead592d(value) {
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}
function $885bdc8cdaf7ea68$export$9ae946eeb7d2d068(json) {
    return $885bdc8cdaf7ea68$export$2b902a04e44db2c3(json, false);
}
function $885bdc8cdaf7ea68$export$2b902a04e44db2c3(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'datetime': new Date(json['datetime']),
        'count': json['count']
    };
}
function $885bdc8cdaf7ea68$export$5e2f6f2efef84b5(json) {
    return $885bdc8cdaf7ea68$export$801733060d54b8e5(json, false);
}
function $885bdc8cdaf7ea68$export$801733060d54b8e5(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'datetime': value['datetime'].toISOString(),
        'count': value['count']
    };
}


function $fc025732d0af21f2$export$ad23a0f83a316e8(value) {
    return true;
}
function $fc025732d0af21f2$export$d1a0267c9cd050b1(json) {
    return $fc025732d0af21f2$export$9ca7a1c71a73c7b6(json, false);
}
function $fc025732d0af21f2$export$9ca7a1c71a73c7b6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'created_persons': json['created_persons'] == null ? undefined : json['created_persons'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'deleted_persons': json['deleted_persons'] == null ? undefined : json['deleted_persons'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'active_persons': json['active_persons'] == null ? undefined : json['active_persons'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'active_persons_total': json['active_persons_total'] == null ? undefined : json['active_persons_total'],
        'persons_failed_authentication_total': json['persons_failed_authentication_total'] == null ? undefined : json['persons_failed_authentication_total'],
        'returning_persons': json['returning_persons'] == null ? undefined : json['returning_persons'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'returning_persons_total': json['returning_persons_total'] == null ? undefined : json['returning_persons_total'],
        'authentications': json['authentications'] == null ? undefined : json['authentications'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'successful_authentications': json['successful_authentications'] == null ? undefined : json['successful_authentications'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'successful_mfa': json['successful_mfa'] == null ? undefined : json['successful_mfa'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'failed_authentications': json['failed_authentications'] == null ? undefined : json['failed_authentications'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'failed_authentications_by_reason': json['failed_authentications_by_reason'] == null ? undefined : json['failed_authentications_by_reason'],
        'failed_authentications_by_handle_type': json['failed_authentications_by_handle_type'] == null ? undefined : json['failed_authentications_by_handle_type'],
        'failed_authentications_by_auth_method': json['failed_authentications_by_auth_method'] == null ? undefined : json['failed_authentications_by_auth_method'],
        'failed_mfa': json['failed_mfa'] == null ? undefined : json['failed_mfa'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'person_retention': json['person_retention'] == null ? undefined : json['person_retention'],
        'gate_server_starts': json['gate_server_starts'] == null ? undefined : json['gate_server_starts'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'gate_requests_handled': json['gate_requests_handled'] == null ? undefined : json['gate_requests_handled'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068))
    };
}
function $fc025732d0af21f2$export$11b5bdcaac9cbacf(json) {
    return $fc025732d0af21f2$export$c3a94a6483f051f3(json, false);
}
function $fc025732d0af21f2$export$c3a94a6483f051f3(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'created_persons': value['created_persons'] == null ? undefined : value['created_persons'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'deleted_persons': value['deleted_persons'] == null ? undefined : value['deleted_persons'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'active_persons': value['active_persons'] == null ? undefined : value['active_persons'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'active_persons_total': value['active_persons_total'],
        'persons_failed_authentication_total': value['persons_failed_authentication_total'],
        'returning_persons': value['returning_persons'] == null ? undefined : value['returning_persons'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'returning_persons_total': value['returning_persons_total'],
        'authentications': value['authentications'] == null ? undefined : value['authentications'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'successful_authentications': value['successful_authentications'] == null ? undefined : value['successful_authentications'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'successful_mfa': value['successful_mfa'] == null ? undefined : value['successful_mfa'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'failed_authentications': value['failed_authentications'] == null ? undefined : value['failed_authentications'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'failed_authentications_by_reason': value['failed_authentications_by_reason'],
        'failed_authentications_by_handle_type': value['failed_authentications_by_handle_type'],
        'failed_authentications_by_auth_method': value['failed_authentications_by_auth_method'],
        'failed_mfa': value['failed_mfa'] == null ? undefined : value['failed_mfa'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'person_retention': value['person_retention'],
        'gate_server_starts': value['gate_server_starts'] == null ? undefined : value['gate_server_starts'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'gate_requests_handled': value['gate_requests_handled'] == null ? undefined : value['gate_requests_handled'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5))
    };
}


function $138e0bfbdcf02633$export$971608348d0fb0f4(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $138e0bfbdcf02633$export$2fc6c9fe8c3c59d0(json) {
    return $138e0bfbdcf02633$export$ff9f6860e33bd2a0(json, false);
}
function $138e0bfbdcf02633$export$ff9f6860e33bd2a0(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $fc025732d0af21f2$export$d1a0267c9cd050b1)(json['result'])
    };
}
function $138e0bfbdcf02633$export$72146de9eb66981f(json) {
    return $138e0bfbdcf02633$export$e6d18130acf1c26c(json, false);
}
function $138e0bfbdcf02633$export$e6d18130acf1c26c(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $fc025732d0af21f2$export$11b5bdcaac9cbacf)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $ac6f4251001630e9$export$95d176615216f45b(value) {
    return true;
}
function $ac6f4251001630e9$export$98fd440fa1097925(json) {
    return $ac6f4251001630e9$export$4fbede7b8de492e6(json, false);
}
function $ac6f4251001630e9$export$4fbede7b8de492e6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'billable_persons': json['billable_persons'] == null ? undefined : json['billable_persons'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'billable_persons_total': json['billable_persons_total'] == null ? undefined : json['billable_persons_total'],
        'user_identities': json['user_identities'] == null ? undefined : json['user_identities'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'user_identities_total': json['user_identities_total'] == null ? undefined : json['user_identities_total'],
        'non_human_identities': json['non_human_identities'] == null ? undefined : json['non_human_identities'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'non_human_identities_total': json['non_human_identities_total'] == null ? undefined : json['non_human_identities_total'],
        'credentials': json['credentials'] == null ? undefined : json['credentials'].map((0, $885bdc8cdaf7ea68$export$9ae946eeb7d2d068)),
        'credentials_total': json['credentials_total'] == null ? undefined : json['credentials_total']
    };
}
function $ac6f4251001630e9$export$b4faaead8a04c01f(json) {
    return $ac6f4251001630e9$export$c25a7853f05c2e58(json, false);
}
function $ac6f4251001630e9$export$c25a7853f05c2e58(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'billable_persons': value['billable_persons'] == null ? undefined : value['billable_persons'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'billable_persons_total': value['billable_persons_total'],
        'user_identities': value['user_identities'] == null ? undefined : value['user_identities'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'user_identities_total': value['user_identities_total'],
        'non_human_identities': value['non_human_identities'] == null ? undefined : value['non_human_identities'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'non_human_identities_total': value['non_human_identities_total'],
        'credentials': value['credentials'] == null ? undefined : value['credentials'].map((0, $885bdc8cdaf7ea68$export$5e2f6f2efef84b5)),
        'credentials_total': value['credentials_total']
    };
}




function $f330536b9406725a$export$6bfb37099391ab90(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $f330536b9406725a$export$1da8bec36382d2b9(json) {
    return $f330536b9406725a$export$154c0ed8cf64fcd2(json, false);
}
function $f330536b9406725a$export$154c0ed8cf64fcd2(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': (0, $ac6f4251001630e9$export$98fd440fa1097925)(json['result'])
    };
}
function $f330536b9406725a$export$419a8db6c1c04d5(json) {
    return $f330536b9406725a$export$72aafd9cac6972fe(json, false);
}
function $f330536b9406725a$export$72aafd9cac6972fe(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $ac6f4251001630e9$export$b4faaead8a04c01f)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $b6b28a4cc4785441$export$aa21bd563cf3e2b5(value) {
    return true;
}
function $b6b28a4cc4785441$export$c90d5bed9005f12c(json) {
    return $b6b28a4cc4785441$export$c696c877d8f906a0(json, false);
}
function $b6b28a4cc4785441$export$c696c877d8f906a0(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'mitm_domain': json['mitm_domain'] == null ? undefined : json['mitm_domain'],
        'view_count': json['view_count'] == null ? undefined : json['view_count'],
        'unique_ip_count': json['unique_ip_count'] == null ? undefined : json['unique_ip_count'],
        'token_tag': json['token_tag'] == null ? undefined : json['token_tag'],
        'allowed_domains': json['allowed_domains'] == null ? undefined : json['allowed_domains']
    };
}
function $b6b28a4cc4785441$export$b14998057ceceb27(json) {
    return $b6b28a4cc4785441$export$62ad827f9000d010(json, false);
}
function $b6b28a4cc4785441$export$62ad827f9000d010(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'mitm_domain': value['mitm_domain'],
        'view_count': value['view_count'],
        'unique_ip_count': value['unique_ip_count'],
        'token_tag': value['token_tag'],
        'allowed_domains': value['allowed_domains']
    };
}




function $3603cd93c948c062$export$363ad3809eff686d(value) {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}
function $3603cd93c948c062$export$4ec9178c24341b15(json) {
    return $3603cd93c948c062$export$83db56a06b04aec6(json, false);
}
function $3603cd93c948c062$export$83db56a06b04aec6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'].map((0, $b6b28a4cc4785441$export$c90d5bed9005f12c))
    };
}
function $3603cd93c948c062$export$afdc36ed4a0008a8(json) {
    return $3603cd93c948c062$export$417fab72481e47f8(json, false);
}
function $3603cd93c948c062$export$417fab72481e47f8(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': value['result'].map((0, $b6b28a4cc4785441$export$b14998057ceceb27))
    };
}


class $71420c5435d6de42$export$536cc970372a085 extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for getStats without sending the request
     */ async getStatsRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getStats().');
        if (requestParameters['bin'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('bin', 'Required parameter "bin" was null or undefined when calling getStats().');
        const queryParameters = {};
        if (requestParameters['bin'] != null) queryParameters['bin'] = requestParameters['bin'];
        if (requestParameters['start'] != null) queryParameters['start'] = requestParameters['start'].toISOString();
        if (requestParameters['end'] != null) queryParameters['end'] = requestParameters['end'].toISOString();
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/stats`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */ async getStatsRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $138e0bfbdcf02633$export$2fc6c9fe8c3c59d0)(jsonValue));
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */ async getStats(requestParameters, initOverrides) {
        const response = await this.getStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getStatsBilling without sending the request
     */ async getStatsBillingRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getStatsBilling().');
        const queryParameters = {};
        if (requestParameters['start'] != null) queryParameters['start'] = requestParameters['start'].toISOString();
        if (requestParameters['end'] != null) queryParameters['end'] = requestParameters['end'].toISOString();
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/stats/billing`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */ async getStatsBillingRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getStatsBillingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f330536b9406725a$export$1da8bec36382d2b9)(jsonValue));
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */ async getStatsBilling(requestParameters, initOverrides) {
        const response = await this.getStatsBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates request options for getStatsMitm without sending the request
     */ async getStatsMitmRequestOpts(requestParameters) {
        if (requestParameters['slashIDOrgID'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('slashIDOrgID', 'Required parameter "slashIDOrgID" was null or undefined when calling getStatsMitm().');
        const queryParameters = {};
        if (requestParameters['start'] != null) queryParameters['start'] = requestParameters['start'].toISOString();
        if (requestParameters['end'] != null) queryParameters['end'] = requestParameters['end'].toISOString();
        const headerParameters = {};
        if (requestParameters['slashIDOrgID'] != null) headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/stats/mitm`;
        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        };
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */ async getStatsMitmRaw(requestParameters, initOverrides) {
        const requestOptions = await this.getStatsMitmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3603cd93c948c062$export$4ec9178c24341b15)(jsonValue));
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */ async getStatsMitm(requestParameters, initOverrides) {
        const response = await this.getStatsMitmRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $71420c5435d6de42$export$32c133930031d4c3 = {
    NUMBER_60: 60,
    NUMBER_1440: 1440,
    NUMBER_43200: 43200
};


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ const $8714c740f4948a9e$export$80cd9ef7a7c5d538 = {
    InvalidTokenContent: 'invalid_token_content',
    Expired: 'expired',
    InvalidIssuer: 'invalid_issuer',
    NotEnoughFactors: 'not_enough_factors',
    PersonNotActive: 'person_not_active'
};
function $8714c740f4948a9e$export$38dbf72c17eda641(value) {
    if (!('valid' in value) || value['valid'] === undefined) return false;
    return true;
}
function $8714c740f4948a9e$export$1d7fdf6b6870e0e7(json) {
    return $8714c740f4948a9e$export$be603d3798694712(json, false);
}
function $8714c740f4948a9e$export$be603d3798694712(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'valid': json['valid'],
        'invalidity_reason': json['invalidity_reason'] == null ? undefined : json['invalidity_reason'],
        'expires_in_seconds': json['expires_in_seconds'] == null ? undefined : json['expires_in_seconds'],
        'expires_at': json['expires_at'] == null ? undefined : new Date(json['expires_at'])
    };
}
function $8714c740f4948a9e$export$6ada45142b7d15a5(json) {
    return $8714c740f4948a9e$export$521a112716ec3822(json, false);
}
function $8714c740f4948a9e$export$521a112716ec3822(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'valid': value['valid'],
        'invalidity_reason': value['invalidity_reason'],
        'expires_in_seconds': value['expires_in_seconds'],
        'expires_at': value['expires_at'] == null ? value['expires_at'] : value['expires_at'].toISOString()
    };
}




function $063937b12ffd0d90$export$edb1cba5f52eec11(value) {
    return true;
}
function $063937b12ffd0d90$export$6b84b521d90710d5(json) {
    return $063937b12ffd0d90$export$16e23935a5c17df6(json, false);
}
function $063937b12ffd0d90$export$16e23935a5c17df6(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'meta': json['meta'] == null ? undefined : (0, $a32bba956ade8bec$export$70023f934842ce53)(json['meta']),
        'errors': json['errors'] == null ? undefined : json['errors'].map((0, $0ee1bbca4508c5f9$export$9a91be5fb3879fb9)),
        'result': json['result'] == null ? undefined : (0, $8714c740f4948a9e$export$1d7fdf6b6870e0e7)(json['result'])
    };
}
function $063937b12ffd0d90$export$22872bcd4560fb07(json) {
    return $063937b12ffd0d90$export$e0f7ec3013f8f9a(json, false);
}
function $063937b12ffd0d90$export$e0f7ec3013f8f9a(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'meta': (0, $a32bba956ade8bec$export$a688b751866cf7f3)(value['meta']),
        'errors': value['errors'] == null ? undefined : value['errors'].map((0, $0ee1bbca4508c5f9$export$797f61dd859e886c)),
        'result': (0, $8714c740f4948a9e$export$6ada45142b7d15a5)(value['result'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $727f0e49e54c1779$export$f422059f8ea5e525(value) {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}
function $727f0e49e54c1779$export$bc9b8e9658ece7a(json) {
    return $727f0e49e54c1779$export$2ef8c1fc67b5deb2(json, false);
}
function $727f0e49e54c1779$export$2ef8c1fc67b5deb2(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'token': json['token']
    };
}
function $727f0e49e54c1779$export$d0f7f45459c0bb03(json) {
    return $727f0e49e54c1779$export$d2fadd32efc67833(json, false);
}
function $727f0e49e54c1779$export$d2fadd32efc67833(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'token': value['token']
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $43fbaceaaa73a34c$export$574081f636b3004e(value) {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}
function $43fbaceaaa73a34c$export$c19b74f1215c1f46(json) {
    return $43fbaceaaa73a34c$export$aa09d6fd184f9d48(json, false);
}
function $43fbaceaaa73a34c$export$aa09d6fd184f9d48(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'token': json['token']
    };
}
function $43fbaceaaa73a34c$export$3bd7d2b6a8fd413d(json) {
    return $43fbaceaaa73a34c$export$5a8f9601aed5b6a4(json, false);
}
function $43fbaceaaa73a34c$export$5a8f9601aed5b6a4(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'token': value['token']
    };
}


class $c2eb2d00a68063df$export$72bb25602803ae5f extends $d34fdaa1d1a4aef1$export$70edad7ad5bb3f5d {
    /**
     * Creates request options for postTokenRevoke without sending the request
     */ async postTokenRevokeRequestOpts(requestParameters) {
        if (requestParameters['revokeTokenReq'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('revokeTokenReq', 'Required parameter "revokeTokenReq" was null or undefined when calling postTokenRevoke().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (requestParameters['slashIDRequiredConsistency'] != null) headerParameters['SlashID-Required-Consistency'] = String(requestParameters['slashIDRequiredConsistency']);
        if (requestParameters['slashIDRequiredConsistencyTimeout'] != null) headerParameters['SlashID-Required-Consistency-Timeout'] = String(requestParameters['slashIDRequiredConsistencyTimeout']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/token/revoke`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $727f0e49e54c1779$export$d0f7f45459c0bb03)(requestParameters['revokeTokenReq'])
        };
    }
    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */ async postTokenRevokeRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postTokenRevokeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$20446dc680588cc3(response);
    }
    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */ async postTokenRevoke(requestParameters, initOverrides) {
        await this.postTokenRevokeRaw(requestParameters, initOverrides);
    }
    /**
     * Creates request options for postTokenValidate without sending the request
     */ async postTokenValidateRequestOpts(requestParameters) {
        if (requestParameters['validateTokenReq'] == null) throw new $d34fdaa1d1a4aef1$export$a27bea7cdb975d70('validateTokenReq', 'Required parameter "validateTokenReq" was null or undefined when calling postTokenValidate().');
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['slashIDSdkVersion'] != null) headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        let urlPath = `/token/validate`;
        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, $43fbaceaaa73a34c$export$3bd7d2b6a8fd413d)(requestParameters['validateTokenReq'])
        };
    }
    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */ async postTokenValidateRaw(requestParameters, initOverrides) {
        const requestOptions = await this.postTokenValidateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);
        return new $d34fdaa1d1a4aef1$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $063937b12ffd0d90$export$6b84b521d90710d5)(jsonValue));
    }
    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */ async postTokenValidate(requestParameters, initOverrides) {
        const response = await this.postTokenValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $c2eb2d00a68063df$export$86071dbb24ab2a0d = {
    LocalRegion: 'local_region',
    AllRegions: 'all_regions'
};




/* tslint:disable */ /* eslint-disable */ 












/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $df56d9899fa8e1d4$export$3115cb5e7f1d8877(value) {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}
function $df56d9899fa8e1d4$export$514140d1566d2164(json) {
    return $df56d9899fa8e1d4$export$7e04f5374583ac72(json, false);
}
function $df56d9899fa8e1d4$export$7e04f5374583ac72(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'challenge_id': json['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['challenge_type'])
    };
}
function $df56d9899fa8e1d4$export$43ad8a418ad29a9f(json) {
    return $df56d9899fa8e1d4$export$264027fc5eab960e(json, false);
}
function $df56d9899fa8e1d4$export$264027fc5eab960e(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'challenge_id': value['challenge_id'],
        'challenge_type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['challenge_type'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $9bf418069827e254$export$d8b8de51640512f3(value) {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}
function $9bf418069827e254$export$6ba513db151a5ff1(json) {
    return $9bf418069827e254$export$80085d460a32fb43(json, false);
}
function $9bf418069827e254$export$80085d460a32fb43(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'handle': (0, $0465af89d7cf9aa3$export$11c41aa448e0ad82)(json['handle']),
        'timestamp': new Date(json['timestamp']),
        'method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['method'])
    };
}
function $9bf418069827e254$export$7f86f8f881fe1819(json) {
    return $9bf418069827e254$export$ca357372969bb75c(json, false);
}
function $9bf418069827e254$export$ca357372969bb75c(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'handle': (0, $0465af89d7cf9aa3$export$82ff335443c9930)(value['handle']),
        'timestamp': value['timestamp'].toISOString(),
        'method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['method'])
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $82a2a21527eddcd3$export$c5459ab3d3525af9(value) {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}
function $82a2a21527eddcd3$export$794a97c33188e2cf(json) {
    return $82a2a21527eddcd3$export$182e1ae9b4b1a286(json, false);
}
function $82a2a21527eddcd3$export$182e1ae9b4b1a286(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'name': (0, $4765eb42481daa21$export$292cf3eb24b36615)(json['name'])
    };
}
function $82a2a21527eddcd3$export$3cc18af1b4b5aed9(json) {
    return $82a2a21527eddcd3$export$55f933fdcd8354c6(json, false);
}
function $82a2a21527eddcd3$export$55f933fdcd8354c6(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'name': (0, $4765eb42481daa21$export$f789e2ae354140f9)(value['name'])
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $39de6475bc811aeb$export$17f7ef3862c4dda9(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}
function $39de6475bc811aeb$export$6e7bcb022586c1f6(json) {
    return $39de6475bc811aeb$export$ff1bb9fe67f257bd(json, false);
}
function $39de6475bc811aeb$export$ff1bb9fe67f257bd(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'type': (0, $4928fc6e055557be$export$7da7fa2b5d7d85f3)(json['type']),
        'authentication_method': (0, $6b68392b32751678$export$67789e1d0e9f3dc1)(json['authentication_method'])
    };
}
function $39de6475bc811aeb$export$9e42112df54de254(json) {
    return $39de6475bc811aeb$export$e5c9fe4b5b129bd0(json, false);
}
function $39de6475bc811aeb$export$e5c9fe4b5b129bd0(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'type': (0, $4928fc6e055557be$export$e418cafec408031e)(value['type']),
        'authentication_method': (0, $6b68392b32751678$export$6eefe3f1006b48e7)(value['authentication_method'])
    };
}







/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $85af7abc7ebfc748$export$aaae14f4a8a8cf0a(value) {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    return true;
}
function $85af7abc7ebfc748$export$79bd163dd2c25c4(json) {
    return $85af7abc7ebfc748$export$73ef40828bd37093(json, false);
}
function $85af7abc7ebfc748$export$73ef40828bd37093(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'event_name': (0, $55eca41019d00c09$export$9b4cd0a6cee9140c)(json['event_name'])
    };
}
function $85af7abc7ebfc748$export$234c0234de4b43e3(json) {
    return $85af7abc7ebfc748$export$d5eefb08c2204d27(json, false);
}
function $85af7abc7ebfc748$export$d5eefb08c2204d27(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'event_name': (0, $55eca41019d00c09$export$ca1aceefe82885b)(value['event_name'])
    };
}






/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $66bc8e2ac26590a0$export$3d5e609ff68202cd(value) {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}
function $66bc8e2ac26590a0$export$a60fb0f1e80eac31(json) {
    return $66bc8e2ac26590a0$export$c01099be85a3eac3(json, false);
}
function $66bc8e2ac26590a0$export$c01099be85a3eac3(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : new Date(json['last_used'])
    };
}
function $66bc8e2ac26590a0$export$427426ab8fbd2632(json) {
    return $66bc8e2ac26590a0$export$3f4c3633e8b04380(json, false);
}
function $66bc8e2ac26590a0$export$3f4c3633e8b04380(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString()
    };
}



































/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $f0bea44654deb176$export$5156413c1767706(value) {
    return true;
}
function $f0bea44654deb176$export$62ec57aaaf69c325(json) {
    return $f0bea44654deb176$export$6704fc837c56e008(json, false);
}
function $f0bea44654deb176$export$6704fc837c56e008(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'aud': json['aud'] == null ? undefined : json['aud'],
        'id': json['id'] == null ? undefined : json['id'],
        'iat': json['iat'] == null ? undefined : json['iat'],
        'exp': json['exp'] == null ? undefined : json['exp'],
        'nbf': json['nbf'] == null ? undefined : json['nbf'],
        'iss': json['iss'] == null ? undefined : json['iss'],
        'sub': json['sub'] == null ? undefined : json['sub']
    };
}
function $f0bea44654deb176$export$b0e56383df8f8631(json) {
    return $f0bea44654deb176$export$a46e0cea460400a0(json, false);
}
function $f0bea44654deb176$export$a46e0cea460400a0(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'aud': value['aud'],
        'id': value['id'],
        'iat': value['iat'],
        'exp': value['exp'],
        'nbf': value['nbf'],
        'iss': value['iss'],
        'sub': value['sub']
    };
}













/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $4f83339039652402$export$221d642ac9e50c72(value) {
    if (!('authn_id' in value) || value['authn_id'] === undefined) return false;
    if (!('token_types' in value) || value['token_types'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    return true;
}
function $4f83339039652402$export$76b919b75d277795(json) {
    return $4f83339039652402$export$8ab6b61e28fd892c(json, false);
}
function $4f83339039652402$export$8ab6b61e28fd892c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'authn_id': json['authn_id'],
        'token_types': json['token_types'],
        'provider': (0, $e7f514e9ec7972cd$export$272e68d050da029c)(json['provider']),
        'client_id': json['client_id'],
        'oidc_groups': json['oidc_groups'] == null ? undefined : json['oidc_groups']
    };
}
function $4f83339039652402$export$6c26bd44fa13d939(json) {
    return $4f83339039652402$export$ef71251b8681220e(json, false);
}
function $4f83339039652402$export$ef71251b8681220e(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'authn_id': value['authn_id'],
        'token_types': value['token_types'],
        'provider': (0, $e7f514e9ec7972cd$export$a580c37c81d39e5c)(value['provider']),
        'client_id': value['client_id'],
        'oidc_groups': value['oidc_groups']
    };
}











/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $f3cb9462aa03c9a9$export$2a2d1f6758f48dd2(value) {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}
function $f3cb9462aa03c9a9$export$9ea85f8c7fcc82aa(json) {
    return $f3cb9462aa03c9a9$export$4b027521195a9337(json, false);
}
function $f3cb9462aa03c9a9$export$4b027521195a9337(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'type': (0, $59e949b392b8d9ae$export$7bbec83240b0eeeb)(json['type']),
        'params': (0, $e3b6faf8c875a3e5$export$928a6f09136df146)(json['params']),
        'label': json['label'] == null ? undefined : json['label']
    };
}
function $f3cb9462aa03c9a9$export$3122cf98e8657e57(json) {
    return $f3cb9462aa03c9a9$export$7fec16c1c3558f55(json, false);
}
function $f3cb9462aa03c9a9$export$7fec16c1c3558f55(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'type': (0, $59e949b392b8d9ae$export$ee7a066c014b3dac)(value['type']),
        'params': (0, $e3b6faf8c875a3e5$export$f9ebf1cd3c73df35)(value['params']),
        'label': value['label']
    };
}




































/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $c0f12230b9c86934$export$169e9c926128ac82(value) {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}
function $c0f12230b9c86934$export$45a23555e4ce3c92(json) {
    return $c0f12230b9c86934$export$262a7fd3b810b163(json, false);
}
function $c0f12230b9c86934$export$262a7fd3b810b163(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'type': (0, $59e949b392b8d9ae$export$7bbec83240b0eeeb)(json['type']),
        'params': (0, $c68db1e5a957affb$export$cb838a8294c45d7f)(json['params']),
        'label': json['label'] == null ? undefined : json['label']
    };
}
function $c0f12230b9c86934$export$23bdd0b159ac1803(json) {
    return $c0f12230b9c86934$export$d183e4467934d881(json, false);
}
function $c0f12230b9c86934$export$d183e4467934d881(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'type': (0, $59e949b392b8d9ae$export$ee7a066c014b3dac)(value['type']),
        'params': (0, $c68db1e5a957affb$export$37444c8007920ed9)(value['params']),
        'label': value['label']
    };
}


































/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $6702a828065e7f7a$export$2d9264c742d6943a(value) {
    if (!('user_token' in value) || value['user_token'] === undefined) return false;
    return true;
}
function $6702a828065e7f7a$export$a365a919a100fd83(json) {
    return $6702a828065e7f7a$export$223ead298c9cf3bd(json, false);
}
function $6702a828065e7f7a$export$223ead298c9cf3bd(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'aud': json['aud'] == null ? undefined : json['aud'],
        'id': json['id'] == null ? undefined : json['id'],
        'iat': json['iat'] == null ? undefined : json['iat'],
        'exp': json['exp'] == null ? undefined : json['exp'],
        'nbf': json['nbf'] == null ? undefined : json['nbf'],
        'iss': json['iss'] == null ? undefined : json['iss'],
        'sub': json['sub'] == null ? undefined : json['sub'],
        'user_token': json['user_token'],
        'oidc_tokens': json['oidc_tokens'] == null ? undefined : json['oidc_tokens'].map((0, $4f83339039652402$export$76b919b75d277795))
    };
}
function $6702a828065e7f7a$export$1ecabdf4344007a6(json) {
    return $6702a828065e7f7a$export$d105840f88ca2a3c(json, false);
}
function $6702a828065e7f7a$export$d105840f88ca2a3c(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'aud': value['aud'],
        'id': value['id'],
        'iat': value['iat'],
        'exp': value['exp'],
        'nbf': value['nbf'],
        'iss': value['iss'],
        'sub': value['sub'],
        'user_token': value['user_token'],
        'oidc_tokens': value['oidc_tokens'] == null ? undefined : value['oidc_tokens'].map((0, $4f83339039652402$export$6c26bd44fa13d939))
    };
}








/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $6afb8c532a2aecb7$export$ae58097fa9f3a0a(value) {
    return true;
}
function $6afb8c532a2aecb7$export$fc5843c172697631(json) {
    return $6afb8c532a2aecb7$export$eec2f87507b4c61c(json, false);
}
function $6afb8c532a2aecb7$export$eec2f87507b4c61c(json, ignoreDiscriminator) {
    if (json == null) return json;
    return {
        'aud': json['aud'] == null ? undefined : json['aud'],
        'id': json['id'] == null ? undefined : json['id'],
        'iat': json['iat'] == null ? undefined : json['iat'],
        'exp': json['exp'] == null ? undefined : json['exp'],
        'nbf': json['nbf'] == null ? undefined : json['nbf'],
        'iss': json['iss'] == null ? undefined : json['iss'],
        'sub': json['sub'] == null ? undefined : json['sub'],
        'prev_token_id': json['prev_token_id'] == null ? undefined : json['prev_token_id'],
        'oid': json['oid'] == null ? undefined : json['oid'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'person_type': json['person_type'] == null ? undefined : (0, $7fdfe1d233bd281f$export$851ad6a45f8bc66)(json['person_type']),
        'first_token': json['first_token'] == null ? undefined : json['first_token'],
        'authentications': json['authentications'] == null ? undefined : json['authentications'].map((0, $9bf418069827e254$export$6ba513db151a5ff1)),
        'authenticated_methods': json['authenticated_methods'] == null ? undefined : json['authenticated_methods'].map((0, $6b68392b32751678$export$67789e1d0e9f3dc1)),
        'groups_claim_name': json['groups_claim_name'] == null ? undefined : json['groups_claim_name'],
        'prev_anonymous_person_id': json['prev_anonymous_person_id'] == null ? undefined : json['prev_anonymous_person_id']
    };
}
function $6afb8c532a2aecb7$export$2bf0bd3743394bdb(json) {
    return $6afb8c532a2aecb7$export$d47ff99695ffce80(json, false);
}
function $6afb8c532a2aecb7$export$d47ff99695ffce80(value, ignoreDiscriminator = false) {
    if (value == null) return value;
    return {
        'aud': value['aud'],
        'id': value['id'],
        'iat': value['iat'],
        'exp': value['exp'],
        'nbf': value['nbf'],
        'iss': value['iss'],
        'sub': value['sub'],
        'prev_token_id': value['prev_token_id'],
        'oid': value['oid'],
        'person_id': value['person_id'],
        'person_type': (0, $7fdfe1d233bd281f$export$5bebd3993c7ac4e8)(value['person_type']),
        'first_token': value['first_token'],
        'authentications': value['authentications'] == null ? undefined : value['authentications'].map((0, $9bf418069827e254$export$7f86f8f881fe1819)),
        'authenticated_methods': value['authenticated_methods'] == null ? undefined : value['authenticated_methods'].map((0, $6b68392b32751678$export$6eefe3f1006b48e7)),
        'groups_claim_name': value['groups_claim_name'],
        'prev_anonymous_person_id': value['prev_anonymous_person_id']
    };
}

















function $d0755c8abf3bf998$var$getCenteredWindowParams() {
    const width = 400;
    const height = 600;
    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;
    return `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`;
}
function $d0755c8abf3bf998$export$5d0606a13b21f3f8() {
    const windowParams = $d0755c8abf3bf998$var$getCenteredWindowParams();
    const myWindow = window.open(window.location.href, "/id:popup", windowParams);
    if (!myWindow) // TODO standardise error handling
    throw new Error("SlashId: Popup blocked, please consider redirect instead");
    const redirectMessage = '<div style="position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);">You will be redirected in a moment...</div>';
    try {
        myWindow?.document?.write(redirectMessage);
    } catch (e) {
        console.error(e);
        if (myWindow.document && myWindow.document.body) myWindow.document.body.innerHTML = redirectMessage;
    } finally{
        myWindow.blur();
    }
    const setWindowUrl = (url)=>{
        if (myWindow) {
            myWindow.location = url;
            myWindow.focus();
        }
        return myWindow;
    };
    return [
        myWindow,
        setWindowUrl
    ];
}


/**
 * Compare two complete URLs and check if they are the same looking only at the origin and the pathname.
 * This ignores query params and fragments.
 * @param {URL} base
 * @param {URL} comparison
 * @returns {boolean}
 */ function $e800fbca613e1fbe$export$ca8daecbc0756b1b(base, comparison) {
    return base.origin + base.pathname === comparison.origin + comparison.pathname;
}
function $e800fbca613e1fbe$export$fc99885b7e473d08(input) {
    let url;
    try {
        url = new URL(input);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}


const $758fb4e9365600ce$export$61f12a353e32d6b4 = "challenges";
const $758fb4e9365600ce$export$b1acc9d748d757e8 = "sidcp";
const $758fb4e9365600ce$export$911cde4811331c58 = "@SLASHID/CSRF_TOKEN";
const $758fb4e9365600ce$export$3f272757255eeb30 = "@SLASHID/PKCE_CODE_VERIFIER";
const $758fb4e9365600ce$export$fc7d295eacb42f43 = "@SLASHID/OIDC_CLIENT_ID";
const $758fb4e9365600ce$export$9dfd5bd22831bc40 = "@SLASHID/OIDC_REDIRECT_URI";


var $321a099d23035c75$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType[MessageType["StorageGetItem"] = 0] = "StorageGetItem";
    MessageType[MessageType["StorageSetItem"] = 1] = "StorageSetItem";
    MessageType[MessageType["Ping"] = 2] = "Ping";
    MessageType[MessageType["ChallengeWebauthnCreate"] = 3] = "ChallengeWebauthnCreate";
    MessageType[MessageType["ChallengeWebauthnGet"] = 4] = "ChallengeWebauthnGet";
    MessageType[MessageType["SSOChallenge"] = 5] = "SSOChallenge";
    return MessageType;
}({});
class $321a099d23035c75$export$e863b19988e8aafd {
    constructor(){
        this.id = $321a099d23035c75$var$randomId();
        this.type = 2;
    }
}
class $321a099d23035c75$export$612749e00a84ad10 {
    constructor(id, error){
        this.id = id;
        this.error = error;
    }
}
class $321a099d23035c75$export$561665cd9d5caa15 {
    constructor(options, challenge){
        this.type = 3;
        this.id = $321a099d23035c75$var$randomId();
        this.slashIDOptions = options;
        this.challenge = challenge;
    }
}
class $321a099d23035c75$export$8b7d42a6791cdca9 {
    constructor(id, attestation, error){
        this.id = id;
        this.attestation = attestation;
        this.error = error;
    }
}
class $321a099d23035c75$export$b2a6577196c1aa92 {
    constructor(options, challenge){
        this.type = 4;
        this.id = $321a099d23035c75$var$randomId();
        this.slashIDOptions = options;
        this.challenge = challenge;
    }
}
class $321a099d23035c75$export$85b72b60e2ec2ca5 {
    constructor(id, attestation, error){
        this.id = id;
        this.attestation = attestation;
        this.error = error;
    }
}
class $321a099d23035c75$export$f01d2f4fd62a4592 {
    constructor(key){
        this.type = 0;
        this.id = $321a099d23035c75$var$randomId();
        this.key = key;
    }
}
class $321a099d23035c75$export$b622fa8237033579 {
    constructor(id, value, error){
        this.id = id;
        this.value = value;
        this.error = error;
    }
}
class $321a099d23035c75$export$cbc7b39b5c005822 {
    constructor(key, value){
        this.id = $321a099d23035c75$var$randomId();
        this.type = 1;
        this.key = key;
        this.value = value;
    }
}
class $321a099d23035c75$export$b19581adb4c22a0e {
    constructor(id, error){
        this.id = id;
        this.error = error;
    }
}
function $321a099d23035c75$var$randomId() {
    const rndArray = new Uint32Array(1);
    window.crypto.getRandomValues(rndArray);
    return rndArray[0];
}
function $321a099d23035c75$export$e3ec70811b10f90d(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const ssoChallengeID = urlParams.get("sso_challenge_id");
    const ssoCode = urlParams.get("sso_code");
    const csrfToken = urlParams.get("csrf_token");
    if (!ssoChallengeID || !ssoCode || !csrfToken) return null;
    return {
        ssoChallengeID: ssoChallengeID,
        ssoCode: ssoCode,
        csrfToken: csrfToken
    };
}
function $321a099d23035c75$export$2f1c2e17db43d9ae(message) {
    return message.type === 3;
}
function $321a099d23035c75$export$3d155c9fa32292c(message) {
    return message.type === 4;
}
function $321a099d23035c75$export$68ca8012194a4829(message) {
    return message && message.type === 5;
}
function $321a099d23035c75$export$68a74503f112f3ea(message) {
    return message.type === 2;
}


// Map from the string values above to method option types
class $d3aa02db23ac975e$var$FactorMethodOptionsTypeMap {
}
function $d3aa02db23ac975e$export$51e4260dae945f14(environment) {
    return typeof environment === "object" && Boolean(environment.baseURL) && Boolean(environment.sdkURL);
}
function $d3aa02db23ac975e$export$c51332e5b5280a9f(handleType) {
    return handleType === "email_address" || handleType === "phone_number";
}




var $43ff6ce83801d41a$exports = {};

$parcel$export($43ff6ce83801d41a$exports, "ERROR_NAMES", function () { return $43ff6ce83801d41a$export$daceac3b97803ce1; });
$parcel$export($43ff6ce83801d41a$exports, "isFlowCancelledError", function () { return $43ff6ce83801d41a$export$fbcc115299f660c; });
$parcel$export($43ff6ce83801d41a$exports, "isHandlePatternNotAllowedError", function () { return $43ff6ce83801d41a$export$383ea5b2e29d8119; });
$parcel$export($43ff6ce83801d41a$exports, "isSignUpAwaitingApprovalError", function () { return $43ff6ce83801d41a$export$3176c4f9177c827; });
$parcel$export($43ff6ce83801d41a$exports, "isSignInAwaitingApprovalError", function () { return $43ff6ce83801d41a$export$b39f48fbaa61f6ef; });
$parcel$export($43ff6ce83801d41a$exports, "isSelfRegistrationNotAllowedError", function () { return $43ff6ce83801d41a$export$e77249f11b3becf7; });
$parcel$export($43ff6ce83801d41a$exports, "isNoPasswordSetError", function () { return $43ff6ce83801d41a$export$3bfbe7e1e4370b9a; });
$parcel$export($43ff6ce83801d41a$exports, "isNonReachableHandleTypeError", function () { return $43ff6ce83801d41a$export$b3a935821f1baeb0; });
$parcel$export($43ff6ce83801d41a$exports, "isTimeoutError", function () { return $43ff6ce83801d41a$export$f47339bf28a93789; });
$parcel$export($43ff6ce83801d41a$exports, "isHookFactorUnresolvedError", function () { return $43ff6ce83801d41a$export$fe020fb2a17fef38; });
$parcel$export($43ff6ce83801d41a$exports, "isRateLimitError", function () { return $43ff6ce83801d41a$export$a8908c3867f6f20b; });
$parcel$export($43ff6ce83801d41a$exports, "isBadPasskeyScopeError", function () { return $43ff6ce83801d41a$export$62f820c3bd739e62; });
$parcel$export($43ff6ce83801d41a$exports, "isPasskeyPromptError", function () { return $43ff6ce83801d41a$export$2d8742981298631e; });
$parcel$export($43ff6ce83801d41a$exports, "isAPIResponseError", function () { return $43ff6ce83801d41a$export$5a62b7ffa29b147c; });
$parcel$export($43ff6ce83801d41a$exports, "isInvalidSlashIDConfigurationError", function () { return $43ff6ce83801d41a$export$2e53c7453e352ae5; });
$parcel$export($43ff6ce83801d41a$exports, "isInvalidURLParamsError", function () { return $43ff6ce83801d41a$export$b50161abe6d1888e; });
$parcel$export($43ff6ce83801d41a$exports, "isInvalidAuthenticationMethodError", function () { return $43ff6ce83801d41a$export$e53d48902fc18ef; });
$parcel$export($43ff6ce83801d41a$exports, "isInvalidActionError", function () { return $43ff6ce83801d41a$export$1aedaf54d72debec; });
$parcel$export($43ff6ce83801d41a$exports, "isPersonExistsError", function () { return $43ff6ce83801d41a$export$5376529ff6d74e7e; });
$parcel$export($43ff6ce83801d41a$exports, "isInvalidEmailAddressFormatError", function () { return $43ff6ce83801d41a$export$7217cc8708dd65ea; });
$parcel$export($43ff6ce83801d41a$exports, "isInvalidPhoneNumberFormatError", function () { return $43ff6ce83801d41a$export$74db601249abc762; });
$parcel$export($43ff6ce83801d41a$exports, "isUnreachablePhoneNumberError", function () { return $43ff6ce83801d41a$export$5afd3243fc90544d; });
$parcel$export($43ff6ce83801d41a$exports, "isUnexpectedError", function () { return $43ff6ce83801d41a$export$68de2e41a5e9d0c3; });
$parcel$export($43ff6ce83801d41a$exports, "createSlashIDError", function () { return $43ff6ce83801d41a$export$f59d87dc47407b7f; });
$parcel$export($43ff6ce83801d41a$exports, "isSlashIDError", function () { return $43ff6ce83801d41a$export$ea73e85faa39c9c0; });
$parcel$export($43ff6ce83801d41a$exports, "isClientGeneratedErrorSlug", function () { return $43ff6ce83801d41a$export$6fbf0ec11a25c8b2; });
$parcel$export($43ff6ce83801d41a$exports, "CLIENT_GENERATED_ERROR_SLUGS", function () { return $b18eec6826b7d21f$export$866513626aaa7357; });
$parcel$export($43ff6ce83801d41a$exports, "ERROR_NAMES_TO_SLUGS_MAP", function () { return $b18eec6826b7d21f$export$b972448359fee0f0; });
var $b18eec6826b7d21f$exports = {};

$parcel$export($b18eec6826b7d21f$exports, "errorToResponseBodyErrorMessage", function () { return $b18eec6826b7d21f$export$c663841bdeb76d42; });
$parcel$export($b18eec6826b7d21f$exports, "isResponseError", function () { return $b18eec6826b7d21f$export$a98b3b17ec378e54; });
$parcel$export($b18eec6826b7d21f$exports, "isSlashIDError", function () { return $b18eec6826b7d21f$export$ea73e85faa39c9c0; });
$parcel$export($b18eec6826b7d21f$exports, "RESPONSE_HEADERS", function () { return $b18eec6826b7d21f$export$d1e90a466859723f; });
$parcel$export($b18eec6826b7d21f$exports, "serialiseResponseError", function () { return $b18eec6826b7d21f$export$65ed285adeaeb183; });
$parcel$export($b18eec6826b7d21f$exports, "isNoPasswordSetError", function () { return $b18eec6826b7d21f$export$3bfbe7e1e4370b9a; });
$parcel$export($b18eec6826b7d21f$exports, "isSelfRegistrationNotAllowedError", function () { return $b18eec6826b7d21f$export$e77249f11b3becf7; });
$parcel$export($b18eec6826b7d21f$exports, "HOOK_FACTOR_UNRESOLVED_MESSAGE", function () { return $b18eec6826b7d21f$export$675f660cdd34e2c4; });
$parcel$export($b18eec6826b7d21f$exports, "isHookFactorUnresolvedError", function () { return $b18eec6826b7d21f$export$fe020fb2a17fef38; });
$parcel$export($b18eec6826b7d21f$exports, "isHandlePatternNotAllowedError", function () { return $b18eec6826b7d21f$export$383ea5b2e29d8119; });
$parcel$export($b18eec6826b7d21f$exports, "isSignUpAwaitingApprovalError", function () { return $b18eec6826b7d21f$export$3176c4f9177c827; });
$parcel$export($b18eec6826b7d21f$exports, "isSignInAwaitingApprovalError", function () { return $b18eec6826b7d21f$export$b39f48fbaa61f6ef; });
$parcel$export($b18eec6826b7d21f$exports, "isRateLimitError", function () { return $b18eec6826b7d21f$export$a8908c3867f6f20b; });
$parcel$export($b18eec6826b7d21f$exports, "isTimeoutError", function () { return $b18eec6826b7d21f$export$f47339bf28a93789; });
$parcel$export($b18eec6826b7d21f$exports, "isRegistrationAlreadyCompleteError", function () { return $b18eec6826b7d21f$export$962d82e4f8aa9684; });
$parcel$export($b18eec6826b7d21f$exports, "isInvalidEmailAddressFormat", function () { return $b18eec6826b7d21f$export$c4397d750cfa1d04; });
$parcel$export($b18eec6826b7d21f$exports, "isInvalidPhoneNumberFormat", function () { return $b18eec6826b7d21f$export$d899f0be2b68ca7d; });
$parcel$export($b18eec6826b7d21f$exports, "isUnreachablePhoneNumber", function () { return $b18eec6826b7d21f$export$a76c2b256a86c8c6; });
$parcel$export($b18eec6826b7d21f$exports, "isBadPasskeyScopeError", function () { return $b18eec6826b7d21f$export$62f820c3bd739e62; });
$parcel$export($b18eec6826b7d21f$exports, "isPasskeyPromptError", function () { return $b18eec6826b7d21f$export$2d8742981298631e; });
$parcel$export($b18eec6826b7d21f$exports, "isThrownResponse", function () { return $b18eec6826b7d21f$export$5f71bfa25cb0590e; });
$parcel$export($b18eec6826b7d21f$exports, "isTimeoutInPayload", function () { return $b18eec6826b7d21f$export$df846a7dbca1e3d2; });
$parcel$export($b18eec6826b7d21f$exports, "isRateLimitInPayload", function () { return $b18eec6826b7d21f$export$dbb6fdd470346077; });
$parcel$export($b18eec6826b7d21f$exports, "isOIDCPopupBlockedError", function () { return $b18eec6826b7d21f$export$cb6677d413c01a7a; });
$parcel$export($b18eec6826b7d21f$exports, "isNetworkError", function () { return $b18eec6826b7d21f$export$476aa014e2fd89d5; });
$parcel$export($b18eec6826b7d21f$exports, "CLIENT_GENERATED_ERROR_SLUGS", function () { return $b18eec6826b7d21f$export$866513626aaa7357; });
$parcel$export($b18eec6826b7d21f$exports, "ERROR_NAMES_TO_SLUGS_MAP", function () { return $b18eec6826b7d21f$export$b972448359fee0f0; });
$parcel$export($b18eec6826b7d21f$exports, "SlashIDError", function () { return $b18eec6826b7d21f$export$f471a06c79be5983; });
$parcel$export($b18eec6826b7d21f$exports, "createSlashIDAPIResponseError", function () { return $b18eec6826b7d21f$export$65efd56077f75087; });
$parcel$export($b18eec6826b7d21f$exports, "toSlashIDError", function () { return $b18eec6826b7d21f$export$ed0b6181311676c; });
$parcel$export($b18eec6826b7d21f$exports, "ensureError", function () { return $b18eec6826b7d21f$export$f0ff5c81573c8df0; });
$parcel$export($b18eec6826b7d21f$exports, "getErrorMessage", function () { return $b18eec6826b7d21f$export$82f46aa4e6535a45; });
$parcel$export($b18eec6826b7d21f$exports, "createEventFromError", function () { return $b18eec6826b7d21f$export$7f84d4628fc07381; });

const $b18eec6826b7d21f$export$c663841bdeb76d42 = async (error)=>{
    if ($b18eec6826b7d21f$export$a98b3b17ec378e54(error)) return (await error.response.clone().json()).errors?.[0]?.message ?? error.message;
    if ($b18eec6826b7d21f$export$ea73e85faa39c9c0(error)) {
        if (!error.context.response?.body) return error.message;
        try {
            const body = JSON.parse(error.context.response?.body);
            return body.errors?.[0]?.message ?? error.message;
        } catch  {
            return error.message;
        }
    }
    if (error instanceof Error) return error.message;
    return "";
};
const $b18eec6826b7d21f$var$errorToResponseStatusCode = (error)=>{
    if ($b18eec6826b7d21f$export$a98b3b17ec378e54(error)) return error.response.status;
    if ($b18eec6826b7d21f$export$ea73e85faa39c9c0(error)) return error.context.response?.status;
    return error.response?.status;
};
function $b18eec6826b7d21f$export$a98b3b17ec378e54(error) {
    return error.name === "ResponseError" && error.response instanceof Response;
}
const $b18eec6826b7d21f$export$d1e90a466859723f = {
    SlashIDCorrelationID: "slashid-correlation-id"
};
const $b18eec6826b7d21f$export$65ed285adeaeb183 = async (error)=>{
    const data = {
        status: error.response.status,
        statusText: error.response.statusText,
        url: error.response.url,
        type: error.response.type,
        ok: error.response.ok,
        redirected: error.response.redirected,
        headers: Object.fromEntries(error.response.headers),
        body: JSON.stringify(await error.response.clone().json(), null, 2)
    };
    return data;
};
async function $b18eec6826b7d21f$export$3bfbe7e1e4370b9a(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 403 && message === "no password set";
}
async function $b18eec6826b7d21f$export$e77249f11b3becf7(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 403 && message === "self-registration not allowed for this organization";
}
const $b18eec6826b7d21f$export$675f660cdd34e2c4 = "hook factor method: no authentication factor was resolved for this identifier";
async function $b18eec6826b7d21f$export$fe020fb2a17fef38(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 401 && message === $b18eec6826b7d21f$export$675f660cdd34e2c4;
}
async function $b18eec6826b7d21f$export$383ea5b2e29d8119(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 403 && message === "person cannot be registered";
}
async function $b18eec6826b7d21f$export$3176c4f9177c827(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 403 && message === "person is not active";
}
async function $b18eec6826b7d21f$export$b39f48fbaa61f6ef(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    // the SDK doesn't have person ID to match
    return status === 403 && message.includes("Person") && message.includes("is inactive");
}
function $b18eec6826b7d21f$export$a8908c3867f6f20b(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    return status === 429;
}
async function $b18eec6826b7d21f$export$f47339bf28a93789(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return (status === 401 || status === 403) && message === "authentication has expired";
}
async function $b18eec6826b7d21f$export$962d82e4f8aa9684(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 409 && message === "person exists";
}
async function $b18eec6826b7d21f$export$c4397d750cfa1d04(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 400 && message.startsWith("malformed e-mail address");
}
async function $b18eec6826b7d21f$export$d899f0be2b68ca7d(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 400 && message.startsWith("malformed phone number");
}
async function $b18eec6826b7d21f$export$a76c2b256a86c8c6(error) {
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 400 && message.startsWith("unreachable phone number");
}
async function $b18eec6826b7d21f$export$62f820c3bd739e62(error) {
    const regexp = /selected scope '(.*?)' is not equal to or a registrable domain suffix of origin '(.*?)'/;
    const status = $b18eec6826b7d21f$var$errorToResponseStatusCode(error);
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return status === 400 && regexp.test(message);
}
async function $b18eec6826b7d21f$export$2d8742981298631e(error) {
    const chromeRegexp = /The operation either timed out or was not allowed. See: https:\/\/www.w3.org\/TR\/webauthn-2\/#sctn-privacy-considerations-client./;
    const safariRegexp = /This request has been cancelled by the user./;
    const firefoxRegexp = /The operation was aborted./;
    const iosRegExp = /Operation failed./;
    const notAvailableRegexp = /The WebAuthn API is not available in the current environment/;
    const credentialManagerRegexp = /An unknown error occurred while talking to the credential manager./;
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return error instanceof Error && (chromeRegexp.test(message) || safariRegexp.test(message) || firefoxRegexp.test(message) || iosRegExp.test(message) || notAvailableRegexp.test(message) || credentialManagerRegexp.test(message));
}
function $b18eec6826b7d21f$export$5f71bfa25cb0590e(response) {
    return typeof response === "object" && Array.isArray(response.errors) && response.errors.every((error)=>{
        return typeof error.httpcode === "number" && typeof error.message === "string";
    });
}
function $b18eec6826b7d21f$export$df846a7dbca1e3d2(response) {
    return response.errors.some((error)=>error.message === "authentication has expired");
}
function $b18eec6826b7d21f$export$dbb6fdd470346077(response) {
    return response.errors.some((error)=>error.httpcode === 429);
}
async function $b18eec6826b7d21f$export$cb6677d413c01a7a(error) {
    const regex = /Popup blocked, please consider redirect instead/;
    const message = await $b18eec6826b7d21f$export$c663841bdeb76d42(error);
    return error instanceof DOMException && regex.test(message);
}
function $b18eec6826b7d21f$export$476aa014e2fd89d5(error, response) {
    if (error instanceof TypeError && !response) return true;
    return false;
}
const $b18eec6826b7d21f$export$866513626aaa7357 = [
    // these slugs are generated from events
    "incorrect_otp_code_via_email",
    "incorrect_otp_code_via_sms",
    "incorrect_otp_code",
    "invalid_password",
    "incorrect_password",
    "recovery_failed",
    "oidc_popup_blocked",
    "client_side_error",
    "unspecified",
    // these slugs are generated from SlashIDError instances
    "no_password_set",
    "flow_cancelled",
    "handle_pattern_not_allowed",
    "sign_up_awaiting_approval",
    "sign_in_awaiting_approval",
    "self_registration_not_allowed",
    "recover_non_reachable_handle_type",
    "timeout",
    "rate_limit_exceeded",
    "passkey_bad_scope",
    "passkey_prompt_failed",
    "api_response_error",
    "invalid_slashid_configuration",
    "invalid_slashid_url_params",
    "invalid_authentication_method",
    "invalid_action",
    "invalid_email_address_format",
    "invalid_phone_number_format",
    "unreachable_phone_number",
    "person_exists",
    "hook_factor_unresolved"
];
const $b18eec6826b7d21f$export$b972448359fee0f0 = {
    noPasswordSet: "no_password_set",
    UnexpectedError: "unspecified",
    FlowCancelledError: "flow_cancelled",
    HandlePatternNotAllowedError: "handle_pattern_not_allowed",
    SignUpAwaitingApprovalError: "sign_up_awaiting_approval",
    SignInAwaitingApprovalError: "sign_in_awaiting_approval",
    SelfRegistrationNotAllowed: "self_registration_not_allowed",
    recoverNonReachableHandleType: "recover_non_reachable_handle_type",
    TimeoutError: "timeout",
    RateLimitError: "rate_limit_exceeded",
    BadPasskeyScopeError: "passkey_bad_scope",
    PasskeyPromptError: "passkey_prompt_failed",
    APIResponseError: "api_response_error",
    InvalidSlashIDConfigurationError: "invalid_slashid_configuration",
    InvalidSlashIDURLParamsError: "invalid_slashid_url_params",
    InvalidAuthenticationMethodError: "invalid_authentication_method",
    InvalidActionError: "invalid_action",
    InvalidEmailAddressFormatError: "invalid_email_address_format",
    InvalidPhoneNumberFormatError: "invalid_phone_number_format",
    UnreachablePhoneNumberError: "unreachable_phone_number",
    PersonExistsError: "person_exists",
    HookFactorUnresolvedError: "hook_factor_unresolved"
};
class $b18eec6826b7d21f$export$f471a06c79be5983 extends Error {
    constructor({ name: name = (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown, message: message = "An error occured in @slashid/slashid", context: context = {}, cause: cause }){
        super(message, {
            cause: cause
        });
        this.name = name;
        this.context = context;
    }
}
function $b18eec6826b7d21f$export$ea73e85faa39c9c0(error) {
    return error instanceof $b18eec6826b7d21f$export$f471a06c79be5983;
}
async function $b18eec6826b7d21f$export$65efd56077f75087(responseError, context) {
    // specific to webauthn
    if (await $b18eec6826b7d21f$export$62f820c3bd739e62(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).badPasskeyScopeError,
        message: "Passkey scope is invalid",
        cause: responseError
    });
    if ($b18eec6826b7d21f$export$a8908c3867f6f20b(responseError)) {
        const rateLimitMessage = await $b18eec6826b7d21f$export$c663841bdeb76d42(responseError);
        const serialisedResponse = await $b18eec6826b7d21f$export$65ed285adeaeb183(responseError);
        return new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).rateLimitError,
            message: rateLimitMessage,
            cause: responseError,
            context: {
                response: serialisedResponse,
                ...context
            }
        });
    }
    if (await $b18eec6826b7d21f$export$3bfbe7e1e4370b9a(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).noPasswordSet,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $b18eec6826b7d21f$export$e77249f11b3becf7(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).selfRegistrationNotAllowed,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $b18eec6826b7d21f$export$383ea5b2e29d8119(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).handlePatternNotAllowed,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $b18eec6826b7d21f$export$3176c4f9177c827(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).signUpAwaitingApproval,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $b18eec6826b7d21f$export$b39f48fbaa61f6ef(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).signInAwaitingApproval,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $b18eec6826b7d21f$export$f47339bf28a93789(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).timeoutError,
        message: "Authentication has expired",
        cause: responseError
    });
    if (await $b18eec6826b7d21f$export$62f820c3bd739e62(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).badPasskeyScopeError,
        message: "Passkey scope is invalid",
        cause: responseError
    });
    if (await $b18eec6826b7d21f$export$962d82e4f8aa9684(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).personExistsError,
        message: "Person with the given handle already exists",
        cause: responseError
    });
    if (await $b18eec6826b7d21f$export$c4397d750cfa1d04(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidEmailAddressFormatError,
        message: "Email address is malformed",
        cause: responseError
    });
    if (await $b18eec6826b7d21f$export$d899f0be2b68ca7d(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidPhoneNumberFormatError,
        message: "Phone number is malformed",
        cause: responseError
    });
    if (await $b18eec6826b7d21f$export$a76c2b256a86c8c6(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unreachablePhoneNumberError,
        message: "Phone number is unreachable",
        cause: responseError
    });
    if (await $b18eec6826b7d21f$export$fe020fb2a17fef38(responseError)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).hookFactorUnresolved,
        message: "No authentication factor was resolved by the identify_user hook",
        cause: responseError,
        context: {
            ...context
        }
    });
    // catch-all, in case nothing was matched
    const response = await $b18eec6826b7d21f$export$65ed285adeaeb183(responseError);
    return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).apiResponseError,
        message: "An error occured in @slashid/slashid while processing the response",
        context: {
            response: response,
            correlationId: response.headers[$b18eec6826b7d21f$export$d1e90a466859723f.SlashIDCorrelationID]
        },
        cause: responseError
    });
}
async function $b18eec6826b7d21f$export$ed0b6181311676c(value) {
    if (value instanceof $b18eec6826b7d21f$export$f471a06c79be5983) return value;
    if (value instanceof Error) {
        // webauthn specific errors
        if (await $b18eec6826b7d21f$export$2d8742981298631e(value)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).passkeyPromptError,
            message: "Passkey prompt was dismissed",
            cause: value
        });
        if ($b18eec6826b7d21f$export$a98b3b17ec378e54(value)) return await $b18eec6826b7d21f$export$65efd56077f75087(value);
        return new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Unknown error: ${value.message}`,
            cause: value
        });
    }
    // in some cases the response body is thrown instead of the error or the full response object
    if ($b18eec6826b7d21f$export$5f71bfa25cb0590e(value)) {
        // special case for thrown responses with a timeout error in the payload
        if ($b18eec6826b7d21f$export$df846a7dbca1e3d2(value)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).timeoutError,
            message: "Authentication has expired",
            context: {
                thrownResponse: value
            }
        });
        // special case for thrown responses with a rate limit error in the payload
        if ($b18eec6826b7d21f$export$dbb6fdd470346077(value)) return new $b18eec6826b7d21f$export$f471a06c79be5983({
            message: "Rate limit exceeded",
            context: {
                thrownResponse: value
            },
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).rateLimitError
        });
        return new $b18eec6826b7d21f$export$f471a06c79be5983({
            message: "An error occured in @slashid/slashid",
            context: {
                thrownResponse: value
            },
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).apiResponseError
        });
    }
    let stringified = "[Unable to stringify the thrown value]";
    try {
        stringified = JSON.stringify(value);
    } catch  {
    // ignore
    }
    const error = new Error(`Non-Error thrown: ${stringified}`);
    return new $b18eec6826b7d21f$export$f471a06c79be5983({
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
        message: error.message,
        cause: error
    });
}
function $b18eec6826b7d21f$export$f0ff5c81573c8df0(value) {
    if (value instanceof Error) return value;
    let stringified = "[Unable to stringify the thrown value]";
    try {
        stringified = JSON.stringify(value);
    } catch  {
    // ignore
    }
    const error = new Error(`Non-Error thrown: ${stringified}`);
    return error;
}
async function $b18eec6826b7d21f$export$82f46aa4e6535a45(error) {
    const normalisedError = $b18eec6826b7d21f$export$ea73e85faa39c9c0(error) ? error : await $b18eec6826b7d21f$export$ed0b6181311676c(error);
    return normalisedError.message;
}
async function $b18eec6826b7d21f$export$7f84d4628fc07381(error, { authenticationFactor: authenticationFactor, handle: handle, previousToken: previousToken, challengeId: challengeId }) {
    const slashIDError = await $b18eec6826b7d21f$export$ed0b6181311676c(error);
    const errorSlug = $b18eec6826b7d21f$export$b972448359fee0f0[slashIDError.name];
    const event = {
        authenticationFactor: authenticationFactor,
        handle: handle,
        errorText: errorSlug || "client_side_error",
        previousToken: previousToken,
        challengeId: challengeId,
        failureDetail: await $b18eec6826b7d21f$export$82f46aa4e6535a45(error)
    };
    return event;
}


const $43ff6ce83801d41a$export$daceac3b97803ce1 = {
    noPasswordSet: "noPasswordSet",
    // TODO not standardised yet
    unknown: "UnexpectedError",
    flowCancelled: "FlowCancelledError",
    handlePatternNotAllowed: "HandlePatternNotAllowedError",
    signUpAwaitingApproval: "SignUpAwaitingApprovalError",
    signInAwaitingApproval: "SignInAwaitingApprovalError",
    selfRegistrationNotAllowed: "SelfRegistrationNotAllowed",
    recoverNonReachableHandleType: "recoverNonReachableHandleType",
    timeoutError: "TimeoutError",
    rateLimitError: "RateLimitError",
    badPasskeyScopeError: "BadPasskeyScopeError",
    passkeyPromptError: "PasskeyPromptError",
    apiResponseError: "APIResponseError",
    invalidSlashIDConfigurationError: "InvalidSlashIDConfigurationError",
    invalidSlashIDURLParamsError: "InvalidSlashIDURLParamsError",
    invalidAuthenticationMethodError: "InvalidAuthenticationMethodError",
    invalidActionError: "InvalidActionError",
    invalidEmailAddressFormatError: "InvalidEmailAddressFormatError",
    invalidPhoneNumberFormatError: "InvalidPhoneNumberFormatError",
    unreachablePhoneNumberError: "UnreachablePhoneNumberError",
    personExistsError: "PersonExistsError",
    hookFactorUnresolved: "HookFactorUnresolvedError"
};
function $43ff6ce83801d41a$export$fbcc115299f660c(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.flowCancelled;
}
function $43ff6ce83801d41a$export$383ea5b2e29d8119(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.handlePatternNotAllowed;
}
function $43ff6ce83801d41a$export$3176c4f9177c827(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.signUpAwaitingApproval;
}
function $43ff6ce83801d41a$export$b39f48fbaa61f6ef(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.signInAwaitingApproval;
}
function $43ff6ce83801d41a$export$e77249f11b3becf7(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.selfRegistrationNotAllowed;
}
function $43ff6ce83801d41a$export$3bfbe7e1e4370b9a(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.noPasswordSet;
}
function $43ff6ce83801d41a$export$b3a935821f1baeb0(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.recoverNonReachableHandleType;
}
function $43ff6ce83801d41a$export$f47339bf28a93789(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.timeoutError;
}
function $43ff6ce83801d41a$export$fe020fb2a17fef38(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.hookFactorUnresolved;
}
function $43ff6ce83801d41a$export$a8908c3867f6f20b(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.rateLimitError;
}
function $43ff6ce83801d41a$export$62f820c3bd739e62(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.badPasskeyScopeError;
}
function $43ff6ce83801d41a$export$2d8742981298631e(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.passkeyPromptError;
}
function $43ff6ce83801d41a$export$5a62b7ffa29b147c(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.apiResponseError;
}
function $43ff6ce83801d41a$export$2e53c7453e352ae5(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.invalidSlashIDConfigurationError;
}
function $43ff6ce83801d41a$export$b50161abe6d1888e(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.invalidSlashIDURLParamsError;
}
function $43ff6ce83801d41a$export$e53d48902fc18ef(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.invalidAuthenticationMethodError;
}
function $43ff6ce83801d41a$export$1aedaf54d72debec(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.invalidActionError;
}
function $43ff6ce83801d41a$export$5376529ff6d74e7e(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.personExistsError;
}
function $43ff6ce83801d41a$export$7217cc8708dd65ea(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.invalidEmailAddressFormatError;
}
function $43ff6ce83801d41a$export$74db601249abc762(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.invalidPhoneNumberFormatError;
}
function $43ff6ce83801d41a$export$5afd3243fc90544d(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.unreachablePhoneNumberError;
}
function $43ff6ce83801d41a$export$68de2e41a5e9d0c3(error) {
    return error instanceof (0, $b18eec6826b7d21f$export$f471a06c79be5983) && error.name === $43ff6ce83801d41a$export$daceac3b97803ce1.unknown;
}
function $43ff6ce83801d41a$export$f59d87dc47407b7f({ message: message, name: name, cause: cause, context: context }) {
    const error = new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
        message: message,
        name: name,
        cause: cause,
        context: context
    });
    // we know this must be a SlashIDError as we created it
    return error;
}
function $43ff6ce83801d41a$export$ea73e85faa39c9c0(error) {
    return (0, $b18eec6826b7d21f$export$ea73e85faa39c9c0)(error);
}
const $43ff6ce83801d41a$export$6fbf0ec11a25c8b2 = (text)=>{
    return (0, $b18eec6826b7d21f$export$866513626aaa7357).includes(text);
};



const $95827f61328b407c$var$ACCEPTED_BASE_URL_PROTOCOLS = [
    "http:",
    "https:"
];
function $95827f61328b407c$export$7586e69c60094c9d(options) {
    if (!options) throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
        message: "options cannot be null",
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
    if (options.environment) {
        if (typeof options.environment === "string" && options.environment !== "production" && options.environment !== "sandbox") throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
            message: "If 'environment' is set as a string, it must be either 'production' or 'sandbox'",
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
        if (typeof options.environment === "object") {
            if (typeof options.environment.baseURL !== "string") throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
                message: "'environment.baseURL' must be a string",
                name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
            if (typeof options.environment.sdkURL !== "string") throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
                message: "'environment.sdkURL' must be a string",
                name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
        }
    }
    if (options.environment && (options.baseURL || options.sdkURL)) throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
        message: "If 'environment' is set, 'baseURL' and 'sdkURL' cannot be set at the same time. Use a custom environment instead.",
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
    if (options.baseURL) {
        if (typeof options.baseURL !== "string") throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
            message: "'baseURL' must be a string",
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
        let url;
        try {
            url = new URL(options.baseURL);
        } catch (_) {
            throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
                message: "'baseURL' must be a valid URL",
                name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
        }
        if ($95827f61328b407c$var$ACCEPTED_BASE_URL_PROTOCOLS.indexOf(url.protocol) === -1) throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
            message: "'baseURL' must be either an http or https URL",
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
    }
    if (options.sdkURL) {
        if (typeof options.sdkURL !== "string") throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
            message: "'sdkURL' must be a string",
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
        try {
            new URL(options.sdkURL);
        } catch (_) {
            throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
                message: "'sdkURL' must be a valid URL",
                name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
        }
    }
    const { analyticsEnabled: analyticsEnabled = true, oid: oid, identityProviderInitiatedSSOEnabled: identityProviderInitiatedSSOEnabled = false } = options;
    if (analyticsEnabled && !oid) throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
        message: "Analytics require the 'oid' parameter to be set when instantiating SlashID()",
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
    if (identityProviderInitiatedSSOEnabled && !oid) throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
        message: "Identity provider initiated SSO requires the 'oid' parameter to be set when instantiating SlashID()",
        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
}
function $95827f61328b407c$var$getSlashIDURLsFromOptions(options) {
    // prefer the environment setting
    if (options.environment) return $95827f61328b407c$var$getSlashIDURLsFromEnvironment(options.environment);
    // default to production if individual options are not set
    return {
        baseURL: options.baseURL || $95827f61328b407c$export$58b6d978d250d3b1.production.baseURL,
        sdkURL: options.sdkURL || $95827f61328b407c$export$58b6d978d250d3b1.production.sdkURL
    };
}
const $95827f61328b407c$export$58b6d978d250d3b1 = {
    production: {
        baseURL: "https://api.slashid.com",
        sdkURL: "https://cdn.slashid.com/sdk.html"
    },
    sandbox: {
        baseURL: "https://api.sandbox.slashid.com",
        sdkURL: "https://cdn.sandbox.slashid.com/sdk.html"
    }
};
function $95827f61328b407c$var$getSlashIDURLsFromEnvironment(environment) {
    if (typeof environment === "string") return $95827f61328b407c$export$58b6d978d250d3b1[environment];
    if ((0, $d3aa02db23ac975e$export$51e4260dae945f14)(environment)) return {
        baseURL: environment.baseURL,
        sdkURL: environment.sdkURL
    };
    throw new TypeError("'environment' must be either a string or an object");
}
function $95827f61328b407c$export$851d251ce7109e65(options) {
    const urls = $95827f61328b407c$var$getSlashIDURLsFromOptions(options);
    const config = {
        oid: options.oid,
        analyticsEnabled: options.analyticsEnabled ?? true,
        identityProviderInitiatedSSOEnabled: options.identityProviderInitiatedSSOEnabled ?? false,
        ...urls
    };
    return config;
}
class $95827f61328b407c$export$1fd9c30e1b817ee4 {
    constructor(obj){
        this.getOTP = obj?.getOTP;
    }
}
class $95827f61328b407c$export$b9ee3a7fe7868e4b {
    constructor(obj){
        this.getOTP = obj?.getOTP;
    }
}
async function $95827f61328b407c$export$af64486b3e452a98(authenticationFactor) {
    if (authenticationFactor.method !== "oidc") throw new Error(`Can't create OIDC extras for method: ${authenticationFactor.method}`);
    let extras = {};
    const { client_id: client_id, provider: provider } = authenticationFactor.options;
    let { ux_mode: ux_mode, redirect_target: redirect_target } = authenticationFactor.options;
    if (!ux_mode) ux_mode = (0, $24233137c2c49c70$export$947f28fa7e24f5f5).Popup;
    if (!redirect_target) redirect_target = window.location.href;
    if (ux_mode === (0, $24233137c2c49c70$export$947f28fa7e24f5f5).Redirect) {
        if (!(0, $e800fbca613e1fbe$export$fc99885b7e473d08)(redirect_target)) throw new Error(`If OIDC ux_mode was set to "redirect" a "redirect_target" is required, got ${redirect_target}`);
    }
    if (ux_mode === (0, $24233137c2c49c70$export$947f28fa7e24f5f5).Popup) {
        const [popup, setPopupUrl] = (0, $d0755c8abf3bf998$export$5d0606a13b21f3f8)();
        extras = {
            ...extras,
            popup: popup,
            setPopupUrl: setPopupUrl
        };
    }
    return {
        ...authenticationFactor,
        options: {
            ...authenticationFactor.options,
            client_id: client_id,
            provider: provider,
            ux_mode: ux_mode,
            redirect_target: redirect_target
        },
        extras: extras
    };
}
async function $95827f61328b407c$export$98f5d2f2dc6acbbd(authenticationFactor) {
    if (authenticationFactor.method !== "saml") throw new Error(`Can't create SAML extras for method: ${authenticationFactor.method}`);
    let extras = {};
    let { ux_mode: ux_mode, redirect_target: redirect_target } = authenticationFactor.options;
    if (!ux_mode) ux_mode = (0, $f60351fa401f4ee9$export$6dc0f627c99c13a9).Popup;
    if (!redirect_target) redirect_target = window.location.href;
    if (ux_mode === (0, $f60351fa401f4ee9$export$6dc0f627c99c13a9).Redirect) {
        if (!(0, $e800fbca613e1fbe$export$fc99885b7e473d08)(redirect_target)) throw new Error(`If SAML ux_mode was set to "redirect" a "redirect_target" is required, got ${redirect_target}`);
    }
    if (ux_mode === (0, $f60351fa401f4ee9$export$6dc0f627c99c13a9).Popup) {
        const [popup, setPopupUrl] = (0, $d0755c8abf3bf998$export$5d0606a13b21f3f8)();
        extras = {
            ...extras,
            popup: popup,
            setPopupUrl: setPopupUrl
        };
    }
    return {
        ...authenticationFactor,
        options: {
            ...authenticationFactor.options,
            ux_mode: ux_mode,
            redirect_target: redirect_target
        },
        extras: extras
    };
}
const $95827f61328b407c$export$1a3951e5faecec2e = "iss";
function $95827f61328b407c$var$isValidIssuer(iss) {
    const parts = iss.split(":");
    return parts.length === 3 && parts[0] === "social";
}
function $95827f61328b407c$export$b75ec5c826df5f51(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const iss = urlParams.get($95827f61328b407c$export$1a3951e5faecec2e);
    if (!iss || !$95827f61328b407c$var$isValidIssuer(iss)) return null;
    return {
        iss: iss
    };
}
function $95827f61328b407c$export$8f4f34b0b24b2663(location) {
    const url = new URL(location.href);
    url.searchParams.delete($95827f61328b407c$export$1a3951e5faecec2e);
    return url.toString();
}
async function $95827f61328b407c$export$7c6a3491e5c44625(params) {
    // social: prefix is unused at the moment
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, provider, client_id] = params.iss.split(":");
    return $95827f61328b407c$export$af64486b3e452a98({
        method: "oidc",
        options: {
            provider: provider,
            client_id: client_id,
            ux_mode: (0, $24233137c2c49c70$export$947f28fa7e24f5f5).Redirect,
            redirect_target: $95827f61328b407c$export$8f4f34b0b24b2663(window.location)
        }
    });
}


function $b090022adc3d6924$var$e(e) {
    this.message = e;
}
$b090022adc3d6924$var$e.prototype = new Error, $b090022adc3d6924$var$e.prototype.name = "InvalidCharacterError";
var $b090022adc3d6924$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $b090022adc3d6924$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $b090022adc3d6924$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($b090022adc3d6924$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $b090022adc3d6924$var$r(t);
    }
}
function $b090022adc3d6924$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $b090022adc3d6924$var$o(e, r) {
    if ("string" != typeof e) throw new $b090022adc3d6924$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($b090022adc3d6924$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $b090022adc3d6924$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$b090022adc3d6924$export$b9721ef022f71a68.prototype = new Error, $b090022adc3d6924$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $b090022adc3d6924$export$2e2bcd8739ae039 = $b090022adc3d6924$var$o;






const $476f36b956c2ebb2$export$d7905dc64d88e9a = {
    end_user_read_write: "end_user_read_write",
    end_user_read_only: "end_user_read_only",
    end_user_no_access: "end_user_no_access",
    "person_pool-end_user_read_write": "person_pool-end_user_read_write",
    "person_pool-end_user_read_only": "person_pool-end_user_read_only",
    "person_pool-end_user_no_access": "person_pool-end_user_no_access"
};
class $476f36b956c2ebb2$export$356eb44c374cfc19 {
    constructor({ user: user, bucketName: bucketName }){
        this.user = user;
        this.bucketName = bucketName;
    }
    /**
     * Retrieve attributes for a person from the bucket
     *
     * @param attributeNames You can optionally filter which attributes to retrieve by supplying a list of attribute names. If you don't the method returns all attributes.
     *
     * @returns A map from `string` to basic types containing user data previously associated with {@link set}.
     * @throws `Error` if the operation fails.
     */ async get(attributeNames) {
        const response = await this.user.getAttributesClient().getAttributesBucketName({
            bucketName: this.bucketName,
            attributes: attributeNames,
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Set attributes for a person in the bucket
     *
     * @param attributes A serializable object to associate with the user credential.
     * @throws `Error` if the operation fails.
     */ async set(attributes) {
        const response = await this.user.getAttributesClient().putAttributesBucketName({
            bucketName: this.bucketName,
            body: attributes,
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return;
    }
    /**
     * Delete person attributes from the bucket
     *
     * @param attributeNames You must specify which data attributes to delete by supplying a list of filter strings.
     * @throws `Error` if the operation fails.
     */ async delete(attributeNames) {
        const response = await this.user.getAttributesClient().deleteAttributesBucketName({
            bucketName: this.bucketName,
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
            attributes: attributeNames
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return;
    }
}






function $82539a0f7276774c$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


const $a1defa33305d4825$var$RETRY_COUNT_HEADER = "SlashID-SdkRetryCount";
function $a1defa33305d4825$var$getRetryCount(init) {
    if (!init.headers) return 0;
    const headers = new Headers(init.headers);
    const retryCountHeader = headers.get($a1defa33305d4825$var$RETRY_COUNT_HEADER);
    return retryCountHeader ? parseInt(retryCountHeader) : 0;
}
function $a1defa33305d4825$export$ee3eb40e76801bba({ baseDelayMs: baseDelayMs, maxRetries: maxRetries }) {
    // alternative: pass context through init (SlashID-SDK-retry header) or error
    // alternative: wrapper on top of the client, proxy to retry
    // cache (url, init) => retries - clear on success/max retries after throwing an error
    return {
        onError: async ({ error: error, response: response, url: url, init: init, fetch: fetchApi })=>{
            if ((0, $b18eec6826b7d21f$export$476aa014e2fd89d5)(error, response)) {
                const retryCount = $a1defa33305d4825$var$getRetryCount(init);
                if (retryCount >= maxRetries) return response;
                await (0, $82539a0f7276774c$export$e772c8ff12451969)(Math.pow(2, retryCount) * baseDelayMs);
                return await fetchApi(url, {
                    ...init,
                    headers: {
                        ...init.headers,
                        [$a1defa33305d4825$var$RETRY_COUNT_HEADER]: `${retryCount + 1}`
                    }
                });
            }
            return response;
        }
    };
}


const $06fb94e8077e467b$export$48a8ffe18f8d9950 = async ({ environment: environment, oid: oid })=>{
    const { baseURL: baseURL } = (0, $95827f61328b407c$export$851d251ce7109e65)({
        environment: environment
    });
    const personsClient = new $f0e0cb433712a97f$export$f5f4fdd1b1ffabb3(new $d34fdaa1d1a4aef1$export$fa89be98fe0936f2({
        ...$d34fdaa1d1a4aef1$export$ac4f8128ea29c5,
        basePath: baseURL,
        middleware: [
            (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                maxRetries: 5,
                baseDelayMs: 500
            })
        ]
    }));
    try {
        const { result: token } = await personsClient.postPersonsAnonymous({
            slashIDOrgID: oid,
            anonymousPersonCreateReq: {}
        });
        return token;
    } catch (e) {
        if (e instanceof Error) throw $b18eec6826b7d21f$export$ed0b6181311676c(e);
        throw e;
    }
};
function $06fb94e8077e467b$var$checkOid(options) {
    if (typeof options.oid !== "string") throw new TypeError("'oid' must be of type string");
}
const $06fb94e8077e467b$export$a96acc74924a1a1 = (context)=>{
    (0, $95827f61328b407c$export$7586e69c60094c9d)(context);
    const options = (0, $95827f61328b407c$export$851d251ce7109e65)(context);
    $06fb94e8077e467b$var$checkOid(options);
    const { baseURL: baseURL, sdkURL: sdkURL, oid: oid } = options;
    const tokenCreateOptions = {
        environment: {
            baseURL: baseURL,
            sdkURL: sdkURL
        },
        oid: oid
    };
    return tokenCreateOptions;
};




function $02b8f885a1dbea9f$var$isTokenContainer(token) {
    if (!token) return false;
    if (typeof token.user_token === "string") return true;
    return false;
}
class $02b8f885a1dbea9f$export$d3bddec52a513503 {
    static async createAnonymousUser(options) {
        const createAnonUserOptions = (0, $06fb94e8077e467b$export$a96acc74924a1a1)(options);
        const token = await (0, $06fb94e8077e467b$export$48a8ffe18f8d9950)(createAnonUserOptions);
        return new $02b8f885a1dbea9f$export$d3bddec52a513503(token, options);
    }
    /**
     * Reconstruct an authenticated user from its token value.
     *
     * @param token A user {@link token} value.
     * @param optionsOrSid SlashID instance or SlashID connection options. It is preferred to pass in the SlashID instance
     *
     * @throws `TypeError` If the given `optionsOrSid`, if defined, fail validation, or
     * the given token cannot be decoded.
     */ constructor(token, options){
        this.initialize(token, options);
    }
    /**
     * Must be called in the constructor, before anything else happens.
     * Initializes the internal state of the instance.
     */ initialize(token, options) {
        try {
            // try JSON-decode it, just in case this is somehow coming back from a
            // previous JSON.stringify(user) without having been JSON-parsed first
            token = JSON.parse(token);
        } catch (_) {
        // ignored
        }
        if (typeof token !== "string") throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: $43ff6ce83801d41a$export$daceac3b97803ce1.invalidActionError,
            message: "token must be a string",
            context: {
                token: token
            }
        });
        try {
            const decodedToken = (0, $b090022adc3d6924$export$2e2bcd8739ae039)(token);
            if ($02b8f885a1dbea9f$var$isTokenContainer(decodedToken)) {
                this._token = decodedToken.user_token;
                this._tokenContainer = token;
            } else this._token = token;
        } catch (e) {
            throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                name: $43ff6ce83801d41a$export$daceac3b97803ce1.unknown,
                message: `error when decoding token: ${e.toString()}`,
                cause: e,
                context: {
                    token: token
                }
            });
        }
        // TODO get the environment config from the token
        this._clientOptions = (0, $95827f61328b407c$export$851d251ce7109e65)(options ?? {});
        this.initializeClients();
    }
    /**
     * Use a new token to update the internal state of the user. Same set of options is reused.
     */ updateToken(token) {
        this.initialize(token, this._clientOptions);
    }
    get decoded() {
        if (!this._token) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: $43ff6ce83801d41a$export$daceac3b97803ce1.invalidActionError,
            message: "Cannot call methods on unauthenticated user"
        });
        try {
            return (0, $b090022adc3d6924$export$2e2bcd8739ae039)(this._token);
        } catch (e) {
            throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                name: $43ff6ce83801d41a$export$daceac3b97803ce1.unknown,
                message: `error when decoding token: ${e.toString()}`,
                cause: e,
                context: {
                    token: this._token
                }
            });
        }
    }
    /**
     * The claims of the user token.
     * @returns {UserToken}
     */ get tokenClaims() {
        return this.decoded;
    }
    get decodedTokenContainer() {
        if (!this._tokenContainer) return;
        try {
            return (0, $b090022adc3d6924$export$2e2bcd8739ae039)(this._tokenContainer);
        } catch (e) {
            throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                name: $43ff6ce83801d41a$export$daceac3b97803ce1.unknown,
                message: `error when decoding token container: ${e.toString()}`,
                cause: e,
                context: {
                    tokenContainer: this._tokenContainer
                }
            });
        }
    }
    /**
     * If the user instance is created with a {@link Types.TokenContainer} this will return the claims of the token container.
     * Otherwise it will return undefined.
     * @returns {api.TokenContainer | undefined}
     */ get tokenContainerClaims() {
        return this.decodedTokenContainer;
    }
    updateClient(token) {
        this._token = token;
        this.initializeClients();
    }
    /**
     * Initializes every client with new Configuration based on currently stored
     * _clientOptions and _token.
     */ initializeClients() {
        const clientConfig = new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            ...this._clientOptions?.baseURL && {
                basePath: this._clientOptions.baseURL
            },
            accessToken: this._token
        });
        this._apiClient = new $125642d21ec07f66$export$872437fb2a17cd0e(clientConfig);
        this._attrsClient = new $fe4f85292cc128f9$export$95d3101c7670792a(clientConfig);
        this._tokenClient = new (0, $c2eb2d00a68063df$export$72bb25602803ae5f)(clientConfig);
        this._personConsentsApi = new $3be9d8c115e99746$export$f2ae3e6781ddb521(clientConfig);
    }
    /**
     * This user's ID. Use this property in your backend services when interacting with the [SlashID User Management API](https://developer.slashid.com/docs/category/api/persons).
     */ get ID() {
        return this.decoded.person_id;
    }
    /**
     * The entire, signed authentication token of this user.
     */ get token() {
        return this._token ?? "";
    }
    /**
     * The entire token container
     * @returns either the token container string or an empty string
     */ get tokenContainer() {
        return this._tokenContainer || "";
    }
    /**
     * The organization ID this user belongs to.
     */ get oid() {
        return this.decoded.oid;
    }
    /**
     * Indicates whether the user has been just registered, otherwise it's a returning user.
     */ get firstLogin() {
        return this.decoded.first_token;
    }
    /**
     * Indicates which authentication methods the user has been verified with. It can contain multiple items in case of multi factor authentication.
     */ get authentication() {
        return this.decoded.authenticated_methods || [];
    }
    /**
     * Indicates which authentication methods the user has been verified with, including the handles used for each method.
     */ get authentications() {
        return this.decoded.authentications || [];
    }
    /**
     * Indicates if the user is an anonymous user
     */ get anonymous() {
        return this.decoded.person_type === "anonymous";
    }
    /**
     * Indicates if the user is authenticated
     *
     * For anonymous users this will return `false`
     */ async isAuthenticated() {
        const { valid: valid } = await this.validateToken();
        return valid && this.decoded.person_type !== "anonymous";
    }
    /**
     * Create a DirectID based on your token
     * @returns directID token
     */ async createDirectID() {
        const { result: directID } = await this._apiClient.postDirectId({
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        });
        return directID;
    }
    /**
     * Log out of the current session. Clears the SlashID token.
     * Will attempt revoking the token server-side.
     */ async logout() {
        try {
            await this._tokenClient.postTokenRevoke({
                slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
                revokeTokenReq: {
                    token: this.token
                }
            });
        } catch (_) {
        // we ignore the error as revoking the token is a side effect
        // this endpoint will return a 400 any time you try to revoke a token that is already revoked or expired
        // we expect this to happen frequently
        }
        this.updateClient(undefined);
        this._tokenContainer = undefined;
    }
    /**
     * Resolves to a token validity info object which tells if the token is genuine and if it has expired yet.
     * @returns {Promise} Token validity info
     */ async validateToken() {
        const response = await this._tokenClient?.postTokenValidate({
            validateTokenReq: {
                token: this.token
            },
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Get an array of group names that the user belongs to.
     */ getGroups() {
        const groupsClaimName = this.decoded.groups_claim_name || "groups";
        const token = this.decoded;
        return token[groupsClaimName];
    }
    /**
     * Exposes the attributes client so the Bucket instance can access it
     */ getAttributesClient() {
        return this._attrsClient;
    }
    /**
     *  Creates a {@link Types.Bucket} object used to access attributes.
     *
     * @param bucketName name of the bucket we want to access - uses "end_user_read_write" as default.
     * You can pass in any string that corresponds to a name of a bucket set up for your organization.
     * You can use any of the preset bucket names with corresponding permissions and scopes - {@link Types.DefaultBucketName}.
     * @returns
     */ getBucket(bucketName = (0, $476f36b956c2ebb2$export$d7905dc64d88e9a).end_user_read_write) {
        const bucket = new (0, $476f36b956c2ebb2$export$356eb44c374cfc19)({
            user: this,
            bucketName: bucketName
        });
        return bucket;
    }
    /**
     * @deprecated Use {@link getBucket} instead.
     */ async get(attributeNames) {
        const endUserReadWriteBucket = this.getBucket();
        return endUserReadWriteBucket.get(attributeNames);
    }
    /**
     * @deprecated Use {@link getBucket} instead.
     */ async set(attributes) {
        const endUserReadWriteBucket = this.getBucket();
        return endUserReadWriteBucket.set(attributes);
    }
    /**
     * @deprecated Use {@link getBucket} instead.
     */ async delete(attributeNames) {
        const endUserReadWriteBucket = this.getBucket();
        return endUserReadWriteBucket.delete(attributeNames);
    }
    /**
     * Fetch the GDPR consent levels for the current user.
     * @returns {Promise} GDPR consent info
     */ async getGDPRConsent() {
        const response = await this._personConsentsApi.getConsentGdpr({
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Set the GDPR consent levels for the current user.
     * This will overwrite any existing consent levels and set the consent levels to only the ones included with the request.
     *
     * @param {api.GDPRConsentRequest} request with consentLevels to set
     * @returns {Promise} GDPR consent info
     */ async setGDPRConsent({ consentLevels: consentLevels }) {
        const response = await this._personConsentsApi.putConsentGdpr({
            gDPRConsentRequest: {
                consent_levels: consentLevels
            },
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Add the GDPR consent levels to the current user.
     * Consent levels not included in the request will not be changed.
     *
     * @param {api.GDPRConsentRequest} request with consent levels to add
     * @returns {Promise} GDPR consent info
     */ async addGDPRConsent({ consentLevels: consentLevels }) {
        const response = await this._personConsentsApi.postConsentGdpr({
            gDPRConsentRequest: {
                consent_levels: consentLevels
            },
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Remove the GDPR consent levels from the current user.
     * Consent levels not included in the request will not be changed.
     *
     * @param {api.ConsentGdprDeleteRequest} request with consentLevels to remove
     */ async removeGDPRConsent({ consentLevels: consentLevels }) {
        return this._personConsentsApi.deleteConsentGdpr({
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
            consentLevels: consentLevels
        });
    }
    /**
     * Remove all stored GDPR consent levels from the current user.
     * Consent levels not included in the request will not be changed, unless deleteAll flag is set to true.
     */ async removeGDPRConsentAll() {
        return this._personConsentsApi.deleteConsentGdpr({
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
            deleteAll: true
        });
    }
    /**
     * Get the organizations the user belongs to.
     * @returns {Promise} A list of organizations the user belongs to
     */ async getOrganizations() {
        const response = await this._apiClient.getMe();
        const errors = response.errors;
        if (errors) throw errors;
        return response.result.organizations;
    }
    /**
     * Fetch all the handles associated with this user from the SlashID API.
     * @returns {Promise} A list of handles available for the user
     */ async getHandles() {
        const { errors: errors, result: result } = await this._apiClient.getMe();
        if (errors) throw errors;
        return result.handles;
    }
    /**
     * Given an organization ID, get a new token for the same user in the Organization specified by the Organization ID.
     *
     * For the call to succeed the following conditions must be met:
     * - the token must be valid at the time of the request
     * - the two Organizations must share the same person pool
     * - the user must be a member of both Organizations
     *
     * This operation does not count as an authentication, so the new token will have the same expiration time as the original.
     * @param oid
     * @returns {Promise} A new token for the specified Organization ID
     */ async getTokenForOrganization(oid) {
        const response = await this._apiClient.getToken({
            slashIDOrgID: oid,
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * User objects stringify to their token value for convenience:
     *
     * @example
     * ```js
     * user.toString() === "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSm9obiBTbWl0aCIsImlhdCI6MTUxNjIzOTAyMn0.dzKuKf6u9G7Crk9tsFnS2cey1zglWTFQv_hjWjmtXms"
     * ```
     */ toString() {
        return this._tokenContainer ?? this._token ?? "";
    }
    /**
     * User objects encode to JSON as a string containing their token value.
     *
     * @example
     * ```js
     * JSON.stringify(user) === "\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSm9obiBTbWl0aCIsImlhdCI6MTUxNjIzOTAyMn0.dzKuKf6u9G7Crk9tsFnS2cey1zglWTFQv_hjWjmtXms\""
     * ```
     */ toJSON() {
        return `${this._tokenContainer ?? this._token ?? ""}`;
    }
}






/**
 * @ignore
 *
 * @param str Base64 string with URL-safe alphabet as described
 * in https://datatracker.ietf.org/doc/html/rfc4648#section-5, either
 * padded or unpadded.
 * @returns typed array of the decoded data
 */ function $ff4fa6023341e739$export$2f872c0f2117be69(str) {
    const urlEncodedStr = str.replace(/_/g, "/").replace(/-/g, "+");
    const binStr = atob(urlEncodedStr);
    return Uint8Array.from(binStr, (c)=>c.charCodeAt(0));
}
function $ff4fa6023341e739$export$c564cdbbe6da493(data, urlSafe = true) {
    const binStr = String.fromCharCode(...data);
    const str = btoa(binStr);
    if (urlSafe) return str.replace(/\//g, "_").replace(/\+/g, "-").replace(/=/g, "");
    else return str;
}



async function $76a5a02979c884f4$export$d245da411ccc251b() {
    const hadFocus = document.hasFocus();
    // Polling document.hasFocus() is not ideal but its result reliably changes
    // when the window gets focus, unlike the "focus" and "focusin" events, which
    // only get triggered when an input field gets focus.
    while(!hadFocus && !document.hasFocus())await $82539a0f7276774c$export$e772c8ff12451969(50);
    return hadFocus;
}
const $76a5a02979c884f4$export$32deff8ed92da53f = {
    PopupBlocked: "Popup blocked",
    BadOAuthURL: "Bad OAuth sign in URL"
};
const $76a5a02979c884f4$export$af2e6529191b5a73 = {
    PopupBlocked: "Popup blocked",
    BadAuthURL: "Bad authentication URL"
};
const $76a5a02979c884f4$export$4b60518ae108432a = {
    ApiCallFailed: "API call failed"
};
function $76a5a02979c884f4$export$2d39cf9e3832749f(event) {
    return event.errorText === "client_side_error";
}
const $76a5a02979c884f4$export$dff4d4401577a965 = [
    "otpSmsSent",
    "otpCodeSent",
    "totpKeyGenerated",
    "totpCodeRequested",
    "otpIncorrectCodeSubmitted",
    "passwordSetReady",
    "passwordResetReady",
    "passwordVerifyReady",
    "invalidPasswordSubmitted",
    "incorrectPasswordSubmitted",
    "oauthFlowStarted",
    "oauthFlowFailed",
    "userAuthenticatedFromURL",
    "idFlowSucceeded",
    "idFlowStarted",
    "idFlowFailed",
    "recoveryFlowStarted",
    "recoveryFlowSucceeded",
    "recoveryFlowFailed",
    "webAuthnChallengeProcessed",
    "redirectUriDiscovered",
    "uiCustomizationReceived",
    "authnContextUpdateChallengeReceivedEvent"
];
const $76a5a02979c884f4$export$b7ca98e78eb4b7f2 = [
    "otpCodeSubmitted",
    "passwordSubmitted",
    "flowCancelled"
];
const $76a5a02979c884f4$var$PRIVATE_EVENTS = [
    "clientSideError"
];
function $76a5a02979c884f4$export$ab1e84ca8f5ea7e(evt) {
    return $76a5a02979c884f4$export$dff4d4401577a965.includes(evt);
}
function $76a5a02979c884f4$export$fdd1788388ec077b(evt) {
    return $76a5a02979c884f4$export$b7ca98e78eb4b7f2.includes(evt);
}
function $76a5a02979c884f4$export$a447b62f94c26639(evt) {
    return $76a5a02979c884f4$var$PRIVATE_EVENTS.includes(evt);
}
function $76a5a02979c884f4$export$45e9ff32b647b1fa() {
    const legacyToWrappedHandlerMap = new Map();
    function decorate(legacyHandler) {
        function decoratedHandler(event) {
            // TODO type check fails because of event payload types that are void or string
            // @ts-expect-error
            legacyHandler(event.payload);
        }
        legacyToWrappedHandlerMap.set(legacyHandler, decoratedHandler);
        return decoratedHandler;
    }
    function getDecorator(legacyHandler) {
        if (legacyToWrappedHandlerMap.has(legacyHandler)) return legacyToWrappedHandlerMap.get(legacyHandler);
        return undefined;
    }
    return {
        decorate: decorate,
        getDecorator: getDecorator
    };
}






async function $1d8da30c174c275e$export$ccfc10b8bad1155a(win) {
    // eslint-disable-next-line
    const pong = new Promise(async (resolve, reject)=>{
        const request = new $321a099d23035c75$export$e863b19988e8aafd();
        let ponged = false;
        const responseListener = (event)=>{
            const response = event.data;
            if (response.id !== request.id) return;
            window.removeEventListener("message", responseListener);
            if (response.error) reject(response.error);
            else {
                ponged = true;
                resolve(win);
            }
        };
        window.addEventListener("message", responseListener);
        while(!ponged){
            win.postMessage(request, "*");
            await $82539a0f7276774c$export$e772c8ff12451969(50);
        }
    });
    return pong;
}


class $2f79ecfdbc9bfdc9$export$68371093923cfc31 {
    constructor(iframe, remoteOrigin){
        this.remoteReady = false;
        this.remote = iframe;
        this.remoteOrigin = remoteOrigin;
        if (!this.remote) // we are the remote => expect request messages
        window.addEventListener("message", this.processEvent.bind(this));
    }
    async getRemoteWindow() {
        const win = this.remote?.contentWindow;
        if (!win) throw new Error("this context has no remote");
        if (this.remoteReady) return win;
        await $1d8da30c174c275e$export$ccfc10b8bad1155a(win);
        this.remoteReady = true;
        return win;
    }
    async processEvent(event) {
        let sourceWindow = null;
        if (window.parent && event.source === window.parent) sourceWindow = window.parent;
        if (!sourceWindow) return;
        switch(event.data.type){
            case $321a099d23035c75$export$80edbf15fa61a4db.StorageGetItem:
                {
                    const msg = event.data;
                    try {
                        const value = await this.localGetItem(msg.key);
                        sourceWindow.postMessage(new $321a099d23035c75$export$b622fa8237033579(event.data.id, value), "*");
                    } catch (e) {
                        sourceWindow.postMessage(new $321a099d23035c75$export$b622fa8237033579(event.data.id, null, e), "*");
                    }
                }
                break;
            case $321a099d23035c75$export$80edbf15fa61a4db.StorageSetItem:
                {
                    const msg = event.data;
                    try {
                        await this.localSetItem(msg.key, msg.value);
                        sourceWindow.postMessage(new $321a099d23035c75$export$b19581adb4c22a0e(event.data.id), "*");
                    } catch (e) {
                        sourceWindow.postMessage(new $321a099d23035c75$export$b19581adb4c22a0e(event.data.id, e), "*");
                    }
                }
                break;
            default:
                break;
        }
    }
    async localGetItem(key) {
        return window.localStorage.getItem(key);
    }
    async remoteGetItem(key) {
        let remoteValue = null;
        if (this.remote) remoteValue = await new Promise((resolve, reject)=>{
            const request = new $321a099d23035c75$export$f01d2f4fd62a4592(key);
            const responseListener = (event)=>{
                const response = event.data;
                if (response.id !== request.id) return;
                window.removeEventListener("message", responseListener);
                if (response.error) reject(response.error);
                else resolve(response.value);
            };
            window.addEventListener("message", responseListener);
            this.getRemoteWindow().then((win)=>{
                win.postMessage(request, "*");
            });
        });
        return remoteValue;
    }
    async localSetItem(key, value) {
        return window.localStorage.setItem(key, value);
    }
    async remoteSetItem(key, value) {
        if (this.remote) await new Promise((resolve, reject)=>{
            const request = new $321a099d23035c75$export$cbc7b39b5c005822(key, value);
            const responseListener = (event)=>{
                const response = event.data;
                if (response.id !== request.id) return;
                window.removeEventListener("message", responseListener);
                if (response.error) reject(response.error);
                else resolve();
            };
            window.addEventListener("message", responseListener);
            this.getRemoteWindow().then((win)=>{
                win.postMessage(request, "*");
            });
        });
    }
}
class $2f79ecfdbc9bfdc9$var$StorageBase {
    constructor(store){
        this.store = store;
    }
}
class $2f79ecfdbc9bfdc9$export$720664048a0262dc extends $2f79ecfdbc9bfdc9$var$StorageBase {
    static{
        this.LOCAL_STORAGE_IDENTIFIERS_KEY = "SLASHID_IDENTIFIERS";
    }
    stringify(identifiers) {
        return JSON.stringify(identifiers);
    }
    parse(value) {
        if (!value) return [];
        const identifiers = JSON.parse(value);
        return identifiers;
    }
    async getAll() {
        const localIdentifiers = this.parse(await this.store.localGetItem($2f79ecfdbc9bfdc9$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY));
        const remoteIdentifiers = this.parse(await this.store.remoteGetItem($2f79ecfdbc9bfdc9$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY));
        return $2f79ecfdbc9bfdc9$export$720664048a0262dc.merge(localIdentifiers, remoteIdentifiers);
    }
    async add(identifier) {
        const identifiers = await this.getAll();
        const updatedIdentifiers = this.stringify($2f79ecfdbc9bfdc9$export$720664048a0262dc.merge(identifiers, [
            identifier
        ]));
        await this.store.localSetItem($2f79ecfdbc9bfdc9$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY, updatedIdentifiers);
        await this.store.remoteSetItem($2f79ecfdbc9bfdc9$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY, updatedIdentifiers);
    }
    static identifiersEqual(id1, id2) {
        return id1.type === id2.type && id1.value === id2.value;
    }
    static merge(ids1, ids2) {
        return ids1.concat(...ids2).reduce((acc, cur)=>{
            for (const id of acc){
                if ($2f79ecfdbc9bfdc9$export$720664048a0262dc.identifiersEqual(id, cur)) return acc;
            }
            acc.push(cur);
            return acc;
        }, []);
    }
}
class $2f79ecfdbc9bfdc9$var$CredentialsStorageBase extends $2f79ecfdbc9bfdc9$var$StorageBase {
    static identifiersEqual(id1, id2) {
        return id1 === id2;
    }
    static merge(ids1, ids2) {
        return ids1.concat(...ids2).reduce((acc, cur)=>{
            for (const id of acc){
                if ($2f79ecfdbc9bfdc9$var$CredentialsStorageBase.identifiersEqual(id, cur)) return acc;
            }
            acc.push(cur);
            return acc;
        }, []);
    }
}
class $2f79ecfdbc9bfdc9$export$24dd33171b764b1e extends $2f79ecfdbc9bfdc9$var$CredentialsStorageBase {
    static{
        this.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY = "SLASHID_WEBAUTHN_CREDENTIAL_ID";
    }
    stringify(credIds) {
        return JSON.stringify(credIds);
    }
    parse(value) {
        if (!value) return [];
        let parsed = null;
        try {
            parsed = JSON.parse(value);
        } catch (e) {
            return [
                value
            ];
        }
        if (!Array.isArray(parsed)) return [];
        const credIds = parsed.filter((item)=>typeof item === "string");
        return credIds;
    }
    async getAll() {
        const localCredIds = this.parse(await this.store.localGetItem($2f79ecfdbc9bfdc9$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY));
        const remoteCredIds = this.parse(await this.store.remoteGetItem($2f79ecfdbc9bfdc9$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY));
        return $2f79ecfdbc9bfdc9$export$24dd33171b764b1e.merge(localCredIds, remoteCredIds);
    }
    async add(credId) {
        const credIds = await this.getAll();
        const updatedCredIds = this.stringify($2f79ecfdbc9bfdc9$export$24dd33171b764b1e.merge(credIds, [
            credId
        ]));
        await this.store.localSetItem($2f79ecfdbc9bfdc9$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY, updatedCredIds);
        await this.store.remoteSetItem($2f79ecfdbc9bfdc9$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY, updatedCredIds);
    }
}
class $2f79ecfdbc9bfdc9$export$28d449e9c93b4ea6 extends $2f79ecfdbc9bfdc9$var$CredentialsStorageBase {
    static{
        this.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY_V2 = "SLASHID_WEBAUTHN_CREDENTIAL_ID_V2";
    }
    constructor(store){
        super(store);
        this.v1Storage = new $2f79ecfdbc9bfdc9$export$24dd33171b764b1e(store);
    }
    stringify(credIdsMap) {
        return JSON.stringify(credIdsMap);
    }
    parse(value) {
        if (!value) return {};
        let parsed = null;
        try {
            parsed = JSON.parse(value);
        } catch (e) {
            return {};
        }
        if (typeof parsed !== "object") return {};
        const credIdsMap = {};
        for (const scope of Object.keys(parsed)){
            if (typeof scope !== "string") continue;
            if (!Array.isArray(parsed[scope])) continue;
            const credIds = parsed[scope].filter((item)=>typeof item === "string");
            credIdsMap[scope] = credIds;
        }
        return credIdsMap;
    }
    async getAll() {
        const localCredIdsMap = this.parse(await this.store.localGetItem($2f79ecfdbc9bfdc9$export$28d449e9c93b4ea6.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY_V2));
        return localCredIdsMap;
    }
    async get(scope) {
        if (!this.store.remoteOrigin || this.store.remoteOrigin.endsWith(scope)) return this.v1Storage.getAll();
        const localCredIds = (await this.getAll())[scope] || [];
        return localCredIds;
    }
    async add(scope, credId) {
        if (!this.store.remoteOrigin || this.store.remoteOrigin.endsWith(scope)) {
            this.v1Storage.add(credId);
            return;
        }
        const localCredIdsMap = await this.getAll();
        const localCredIds = localCredIdsMap[scope] || [];
        for (const id of localCredIds)if (id === credId) {
            console.warn(`Attempted to add already present credential ID: scope=${scope} credId=${credId}`);
            return;
        }
        localCredIds.push(credId);
        localCredIdsMap[scope] = localCredIds;
        const updatedCredIdsMap = this.stringify(localCredIdsMap);
        await this.store.localSetItem($2f79ecfdbc9bfdc9$export$28d449e9c93b4ea6.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY_V2, updatedCredIdsMap);
    }
}






const $1b21b70eb89499a0$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $1b21b70eb89499a0$export$2e2bcd8739ae039 = {
    randomUUID: $1b21b70eb89499a0$var$randomUUID
};


let $648c6f9293507c4f$var$getRandomValues;
const $648c6f9293507c4f$var$rnds8 = new Uint8Array(16);
function $648c6f9293507c4f$export$2e2bcd8739ae039() {
    if (!$648c6f9293507c4f$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $648c6f9293507c4f$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $648c6f9293507c4f$var$getRandomValues($648c6f9293507c4f$var$rnds8);
}


var $b1359df9bf70a16b$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $b7770cb080b53437$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $b1359df9bf70a16b$export$2e2bcd8739ae039).test(uuid);
}
var $b7770cb080b53437$export$2e2bcd8739ae039 = $b7770cb080b53437$var$validate;


const $75937cd2e0594468$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$75937cd2e0594468$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $75937cd2e0594468$export$8fb373d660548968(arr, offset = 0) {
    return ($75937cd2e0594468$var$byteToHex[arr[offset + 0]] + $75937cd2e0594468$var$byteToHex[arr[offset + 1]] + $75937cd2e0594468$var$byteToHex[arr[offset + 2]] + $75937cd2e0594468$var$byteToHex[arr[offset + 3]] + '-' + $75937cd2e0594468$var$byteToHex[arr[offset + 4]] + $75937cd2e0594468$var$byteToHex[arr[offset + 5]] + '-' + $75937cd2e0594468$var$byteToHex[arr[offset + 6]] + $75937cd2e0594468$var$byteToHex[arr[offset + 7]] + '-' + $75937cd2e0594468$var$byteToHex[arr[offset + 8]] + $75937cd2e0594468$var$byteToHex[arr[offset + 9]] + '-' + $75937cd2e0594468$var$byteToHex[arr[offset + 10]] + $75937cd2e0594468$var$byteToHex[arr[offset + 11]] + $75937cd2e0594468$var$byteToHex[arr[offset + 12]] + $75937cd2e0594468$var$byteToHex[arr[offset + 13]] + $75937cd2e0594468$var$byteToHex[arr[offset + 14]] + $75937cd2e0594468$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $75937cd2e0594468$var$stringify(arr, offset = 0) {
    const uuid = $75937cd2e0594468$export$8fb373d660548968(arr, offset);
    if (!(0, $b7770cb080b53437$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $75937cd2e0594468$export$2e2bcd8739ae039 = $75937cd2e0594468$var$stringify;


function $85977a4a88521617$var$v4(options, buf, offset) {
    if ((0, $1b21b70eb89499a0$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $1b21b70eb89499a0$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $648c6f9293507c4f$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $75937cd2e0594468$export$8fb373d660548968)(rnds);
}
var $85977a4a88521617$export$2e2bcd8739ae039 = $85977a4a88521617$var$v4;







function $903aaedbe0db6f0b$export$5fb04c0b31ecb34c(params) {
    // set up the client ID and redirect URI in the session storage
    window.sessionStorage.setItem((0, $758fb4e9365600ce$export$fc7d295eacb42f43), params.clientId);
    window.sessionStorage.setItem((0, $758fb4e9365600ce$export$9dfd5bd22831bc40), params.redirectUri);
}
function $903aaedbe0db6f0b$export$a2218d2039ce5af0() {
    const clientId = window.sessionStorage.getItem((0, $758fb4e9365600ce$export$fc7d295eacb42f43));
    const redirectUri = window.sessionStorage.getItem((0, $758fb4e9365600ce$export$9dfd5bd22831bc40));
    if (!clientId || !redirectUri) // TODO make this a SlashID error
    throw new Error("Client ID or redirect URI not found in session storage");
    return {
        clientId: clientId,
        redirectUri: redirectUri
    };
}
function $903aaedbe0db6f0b$export$8af8138ab9f57e02() {
    window.sessionStorage.removeItem((0, $758fb4e9365600ce$export$fc7d295eacb42f43));
    window.sessionStorage.removeItem((0, $758fb4e9365600ce$export$9dfd5bd22831bc40));
}
async function $903aaedbe0db6f0b$export$9f45878548a7cf78() {
    const csrf_token = (0, $85977a4a88521617$export$2e2bcd8739ae039)();
    const pkce_code_verifier = (0, $85977a4a88521617$export$2e2bcd8739ae039)() + (0, $85977a4a88521617$export$2e2bcd8739ae039)() // recommended increased entropy
    ;
    const data = new TextEncoder().encode(pkce_code_verifier);
    const hash = await window.crypto.subtle.digest("SHA-256", data);
    const pkce_code_challenge = $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(hash));
    // TODO side effect, consider moving outside
    window.localStorage.setItem((0, $758fb4e9365600ce$export$911cde4811331c58), csrf_token);
    window.localStorage.setItem((0, $758fb4e9365600ce$export$3f272757255eeb30), pkce_code_verifier);
    return {
        csrf_token: csrf_token,
        pkce_code_challenge: pkce_code_challenge
    };
}
function $903aaedbe0db6f0b$export$2a015c1c89819b5a(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const ssoCode = urlParams.get("code");
    // TODO this is specific to our flow
    const csrfToken = urlParams.get("state");
    if (!ssoCode || !csrfToken) return null;
    return {
        ssoCode: ssoCode,
        csrfToken: csrfToken
    };
}
async function $903aaedbe0db6f0b$export$64ca83e534616343(input) {
    const csrf_token = window.localStorage.getItem((0, $758fb4e9365600ce$export$911cde4811331c58));
    const pkce_code_verifier = window.localStorage.getItem((0, $758fb4e9365600ce$export$3f272757255eeb30));
    if (!csrf_token || !pkce_code_verifier) throw new Error("CSRF token or PKCE code verifier not found");
    if (csrf_token !== input.csrfToken) throw new Error("CSRF token mismatch");
    const payload = new URLSearchParams();
    payload.set("client_id", input.clientId);
    payload.set("code", input.ssoCode);
    payload.set("code_verifier", pkce_code_verifier);
    payload.set("grant_type", "authorization_code");
    payload.set("redirect_uri", input.redirectUri);
    // TODO proper error handling
    const response = await fetch(`${input.apiBaseURL}/oauth2/tokens`, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: payload.toString()
    });
    if (!response.ok) // TODO throw proper error
    throw new Error("Failed to obtain access token");
    const data = await response.json();
    return data;
}


class $f6b03dd3570fd99b$export$ec7121d802e738bd extends (0, $02b8f885a1dbea9f$export$d3bddec52a513503) {
    constructor(token, optionsOrSid){
        // both the options and SlashID instances have the same fields (baseURL, sdkURL, oid)
        super(token, optionsOrSid);
        this._slashid = optionsOrSid instanceof (0, $b5612fac2c319704$export$261888861cdb8a55) ? optionsOrSid : new (0, $b5612fac2c319704$export$261888861cdb8a55)(optionsOrSid);
    }
    /**
     * Request the user to authenticate with the given method. This method is essentially equivalent to
     * {@link SlashID.id}, but since the user is already authenticated you can omit the `handle` or
     * `authenticationFactor` parameters, depending on the desired outcome. Please refer to the examples
     * for the use cases this method covers.
     *
     * @param handle A user handle, either a new one to be associated to the user, or an existing
     * one to deliver the authetication request to.
     *
     * @param authenticationFactor The authentication factor, please to refer to {@link SlashID.id}
     * documentation for details.
     *
     * @throws `slashid.errors.InvalidAuthenticationMethodError` if the chosen method is
     * incompatible with the given handle or is not available on the current device.
     * `Error` if the operation fails otherwise.
     *
     * @example
     *
     * One thing you can do with `mfa()` is attach other handles to the user.
     * For example, the user has already authenticated via e-mail magic link with
     * {@link SlashID.id}, but you want to also attach their phone number. In that case all
     * the method requires is the handle, not
     *
     * ```js
     * await user.mfa({
     *   type: "phone_number",
     *   value: "+13337777777"
     * })
     * ```
     *
     * SlashID will send a challenge SMS to the phone number to verify it. If `mfa()` returns
     * without throwing any error the procedure is complete and the user object will have been
     * updated with a refreshed {@link token}. For future authentications the user will be able
     * to use the newly-attached phone number as an alternative to the e-mail address. Consider
     * though that this call only verified ownership of the phone number and added it to the user
     * handles, as such the {@link authentication} array stays unchanged.
     *
     * If you want to step-up the user authentication, or simply re-authenticate the user,
     * you can do so by also providing an authentication factor. For example let's assume
     * you want to send a magic link to one of the user's e-mail address:
     *
     * ```js
     * await user.mfa({
     *   type: "email_address",
     *   value: "..." // one previously-attached address, or a new one to be attached
     * }, {
     *   method: "email_link"
     * })
     * ```
     *
     * If the e-mail address provided above was not attached to the user, SlashID will verify it
     * and also perform the authentication. Once again, when `mfa()` returns the user will have
     * a refreshed {@link token}, but this time its {@link authentication} array will also include
     * `"email_link"` in addition to the method chosen for the first authentication with
     * {@link SlashID.id}.
     *
     * The only edge case to note is that for performing MFA with WebAuthn authentication
     * there's no need to specify an handle, as the ceremony happens on the current device:
     *
     * ```js
     * await user.mfa(undefined, {
     *   method: "webauthn"
     * })
     * ```
     */ async mfa(handleOrFactor, authenticationFactor) {
        let handle = undefined;
        if (!handleOrFactor) throw new Error("at least one of PersonHandle or Factor is required");
        if (handleOrFactor.type && handleOrFactor.value) handle = handleOrFactor;
        if (handleOrFactor.method) authenticationFactor = handleOrFactor;
        // On WebAuthn, if the key does not exist on the authenticator:
        //  - Firefox throws "InvalidStateError: An attempt was made to use an object that is not, or is no longer, usable"
        //  - Chrome throws "NotAllowedError: The operation either timed out or was not allowed. See: https://www.w3.org/TR/webauthn-2/#sctn-privacy-considerations-client."
        const updatedUser = await this._slashid._id(this.decoded.oid, handle, authenticationFactor, this._token);
        this.updateToken(updatedUser.toString());
        return;
    }
    /**
     * Given an organization ID, get a new token for the same user in the Organization specified by the Organization ID.
     *
     * For the call to succeed the following conditions must be met:
     * - the token must be valid at the time of the request
     * - the two Organizations must share the same person pool
     * - the user must be a member of both Organizations
     *
     * This operation does not count as an authentication, so the new token will have the same expiration time as the original.
     * @param oid
     * @returns {Promise} A new token for the specified Organization ID
     * @override
     */ async getTokenForOrganization(oid) {
        const metadata = await (0, $903aaedbe0db6f0b$export$9f45878548a7cf78)();
        const response = await this._apiClient.postTokenV2({
            slashIDOrgID: oid,
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
            postTokenRequestV2: {
                metadata: metadata
            }
        });
        const errors = response.errors;
        if (errors) throw errors;
        if (response.result?.type === "challenge_list") {
            // process challenges to obtain a token
            const challengeProcessor = this._slashid.createChallengeProcessor({
                authFlowId: (0, $85977a4a88521617$export$2e2bcd8739ae039)()
            });
            return challengeProcessor.processChallenges({
                challenges: response.result.challenges,
                previousToken: this._token
            });
        }
        if (response.result?.type === "token") return response.result.token;
        throw new (0, $b18eec6826b7d21f$export$f471a06c79be5983)({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: "Unknown response type",
            context: response
        });
    }
}








const $77ceb9e5a8ca350c$var$BROWSERS_WITHOUT_KEEPALIVE_SUPPORT = /firefox|fxios|deno/i;
const $77ceb9e5a8ca350c$export$9e4ae37cd458911c = (fetch, config)=>{
    return {
        sendEvent: async (payload)=>{
            try {
                await fetch(`${config.baseURL}/actions/sdk`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
            } catch (error) {
                console.error("@slashid/slashid-sdk: failed to send event", {
                    error: error,
                    event: payload
                });
            }
        }
    };
};
const $77ceb9e5a8ca350c$export$b4a760bcaae97034 = (config)=>{
    return {
        sendEvent: async (payload)=>{
            const blob = new Blob([
                JSON.stringify(payload)
            ], {
                type: "application/json"
            });
            navigator.sendBeacon(`${config.baseURL}/actions/sdk`, blob);
        }
    };
};
const $77ceb9e5a8ca350c$export$406a9cc5152be3c5 = (fetch, config)=>{
    return {
        sendEvent: async (payload)=>{
            const noKeepAliveSupport = $77ceb9e5a8ca350c$var$BROWSERS_WITHOUT_KEEPALIVE_SUPPORT.test(navigator.userAgent);
            try {
                await fetch(`${config.baseURL}/actions/sdk`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload),
                    keepalive: !noKeepAliveSupport
                });
            } catch (error) {
                console.error("@slashid/slashid-sdk: failed to send event", {
                    error: error,
                    event: payload
                });
            }
        }
    };
};


class $fc510a0582bb8f09$export$e2273de0aec30cd2 {
    constructor({ options: options, user: user, transport: transport }){
        if (options) (0, $95827f61328b407c$export$7586e69c60094c9d)(options);
        this.config = (0, $95827f61328b407c$export$851d251ce7109e65)(options ?? {});
        this.transport = transport ?? (0, $77ceb9e5a8ca350c$export$9e4ae37cd458911c)(fetch, this.config);
        this.eventsAPI = new (0, $4c625453fa2fc885$export$9d7eae2d04d44e94)(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.config.baseURL
        }));
        this.user = user;
        // how do we keep this in sync with the server side
        this.correlationId = this.createCorrelationID();
    }
    createCorrelationID() {
        return (0, $85977a4a88521617$export$2e2bcd8739ae039)();
    }
    createEventMetadata({ location: location, userAgent: userAgent } = {
        location: "/",
        userAgent: ""
    }) {
        return {
            organization_id: this.config.oid ?? this.user?.oid ?? "",
            analytics_correlation_id: this.correlationId,
            window_location: location,
            user_agent: userAgent
        };
    }
    sendEvent(payload) {
        this.transport.sendEvent(payload);
    }
    trackPersonIdentified({ user: user }) {
        const personIdentifiedEvent = {
            event_name: (0, $55eca41019d00c09$export$8e49444f78fbbdb8).PersonIdentifiedV1,
            person_id: user.ID
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: personIdentifiedEvent
        };
        this.sendEvent(payload);
    }
    trackPersonLoggedOut(e) {
        const user = new (0, $02b8f885a1dbea9f$export$d3bddec52a513503)(e.token, this.config);
        const personLoggedOut = {
            event_name: (0, $55eca41019d00c09$export$8e49444f78fbbdb8).PersonLoggedOutV1,
            person_id: user.ID
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: personLoggedOut
        };
        this.sendEvent(payload);
    }
    /**
     * Identifies a user for the purpose of user activity tracking. Where possible
     * user identification is done automatically.
     *
     * @param user The user being identified.
     */ identify(user) {
        this.user = user;
        this.trackPersonIdentified({
            user: user
        });
    }
    /**
     * Logs the user out from the point-of-view of the {@link Types.BaseAnalytics} class only,
     * this method does not have a side-effect which affects the logged in state of the user.
     *
     * After removing a stored token this method should be called to record the log out event.
     */ logout() {
        const user = this.user;
        if (!user) return;
        this.trackPersonLoggedOut({
            token: user.token
        });
        this.user = undefined;
    }
    /**
     * Tracks a virtual page view
     *
     * A virtual page view allows you to track a page view, even when a page is not physically
     * loaded in the browser. For example, when navigating using a client-side router in a
     * single page application, or navigating within a sub-section of a page (like a tabbed pane,
     * or navigation drawer) without changing the page itself.
     *
     * The exact meaning of a virtual page view will vary by implementation, it depends on your
     * routing paradigm and what you're trying to track. You will need to implement this event
     * in a way which makes sense for your product.
     *
     * @param options.url The URL of the page to track as the subject of the virtual page view.
     */ trackVirtualPageView(options) {
        const { url: url = "" } = options;
        const virtualPageLoadEvent = {
            event_name: (0, $55eca41019d00c09$export$8e49444f78fbbdb8).VirtualPageLoadedV1,
            ...this.user && {
                person_id: this.user.ID
            }
        };
        const payload = {
            ...this.createEventMetadata({
                location: url,
                userAgent: options.userAgent ?? ""
            }),
            event_data: virtualPageLoadEvent
        };
        this.sendEvent(payload);
    }
}





class $6b2e562d245e2fa0$export$a7b0438860379c35 extends (0, $fc510a0582bb8f09$export$e2273de0aec30cd2) {
    constructor({ sdk: sdk, user: user }){
        const options = {
            oid: sdk.oid,
            baseURL: sdk.baseURL,
            sdkURL: sdk.sdkURL,
            analyticsEnabled: true
        };
        const config = (0, $95827f61328b407c$export$851d251ce7109e65)(options);
        super({
            options: options,
            user: user,
            transport: (0, $77ceb9e5a8ca350c$export$406a9cc5152be3c5)(fetch, config)
        });
        this.sdk = sdk;
        this.subscribeToDomainEvents();
        this.trackSdkLoaded();
    }
    createCorrelationID() {
        const CORRELATION_ID_STORAGE_KEY = "@slashid/EVENTS_CORRELATION_ID";
        try {
            const storedCorrelationID = sessionStorage.getItem(CORRELATION_ID_STORAGE_KEY);
            if (storedCorrelationID) return storedCorrelationID;
        } catch  {
        // web storage is not available
        }
        const correlationID = (0, $85977a4a88521617$export$2e2bcd8739ae039)();
        try {
            sessionStorage.setItem(CORRELATION_ID_STORAGE_KEY, correlationID);
        } catch  {
        // web storage is not available
        }
        return correlationID;
    }
    createEventMetadata({ location: location, userAgent: userAgent } = {
        location: window.location.href,
        userAgent: navigator.userAgent
    }) {
        return super.createEventMetadata({
            location: location,
            userAgent: userAgent
        });
    }
    subscribeToDomainEvents() {
        this.sdk.subscribe("idFlowSucceeded", (e)=>this.trackAuthenticationSuccess(e));
        this.sdk.subscribe("idFlowFailed", (e)=>this.trackAuthenticationFailure(e));
        this.sdk.subscribe("invalidPasswordSubmitted", (e)=>this.trackAuthenticationFailure({
                ...e,
                errorText: "invalid_password"
            }));
        this.sdk.subscribe("incorrectPasswordSubmitted", (e)=>this.trackAuthenticationFailure({
                ...e,
                errorText: "incorrect_password"
            }));
        this.sdk.subscribe("otpIncorrectCodeSubmitted", (e)=>{
            const reason = (()=>{
                if (e.factor?.method === "otp_via_email") return "incorrect_otp_code_via_email";
                if (e.factor?.method === "otp_via_sms") return "incorrect_otp_code_via_sms";
                return "incorrect_otp_code";
            })();
            this.trackAuthenticationFailure({
                errorText: reason,
                authenticationFactor: {
                    method: e.factor?.method
                },
                challengeId: e.challengeId
            });
        });
        const internal = (0, $b5612fac2c319704$export$5f74d2b45f2a2732)(this.sdk);
        internal.subscribe("clientSideError", (event)=>{
            this.trackAuthenticationFailure({
                ...event,
                errorText: "client_side_error"
            });
        });
    }
    trackAuthenticationSuccess(e) {
        const user = this.sdk.getUser(e.token);
        this.identify(user);
        const authenticationSucceededEvent = {
            event_name: (0, $55eca41019d00c09$export$8e49444f78fbbdb8).AuthenticationSucceededV1,
            person_id: user.ID,
            success_authn_method: e.authenticationFactor?.method,
            authenticated_methods: user.authentication,
            ...e.handle && {
                handle: e.handle
            }
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: authenticationSucceededEvent
        };
        this.sendEvent(payload);
    }
    trackAuthenticationFailure(e) {
        const user = e.previousToken ? this.sdk.getUser(e.previousToken) : this.user;
        const authenticationFailedEvent = {
            event_name: (0, $55eca41019d00c09$export$8e49444f78fbbdb8).AuthenticationFailedV1,
            failed_authn_method: e.authenticationFactor?.method,
            authenticated_methods: user?.authentication,
            failure_reason: e.errorText,
            ...e.handle && {
                handle: e.handle
            },
            ...e.challengeId && {
                challenge_id: e.challengeId
            },
            ...e.failureDetail && {
                failure_detail: e.failureDetail
            },
            ...user && {
                person_id: user.ID
            }
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: authenticationFailedEvent
        };
        this.sendEvent(payload);
    }
    trackSdkLoaded() {
        const payload = {
            ...this.createEventMetadata(),
            event_data: {
                event_name: (0, $55eca41019d00c09$export$8e49444f78fbbdb8).SlashIdsdkLoadedV1
            }
        };
        this.sendEvent(payload);
    }
    /**
     * Tracks a virtual page view
     *
     * A virtual page view allows you to track a page view, even when a page is not physically
     * loaded in the browser. For example, when navigating using a client-side router in a
     * single page application, or navigating within a sub-section of a page (like a tabbed pane,
     * or navigation drawer) without changing the page itself.
     *
     * The exact meaning of a virtual page view will vary by implementation, it depends on your
     * routing paradigm and what you're trying to track. You will need to implement this event
     * in a way which makes sense for your product.
     *
     * @param options.url The URL of the page to track as the subject of the virtual page view.
     */ trackVirtualPageView(options) {
        const { url: url = window.location.href, userAgent: userAgent = navigator.userAgent } = options;
        super.trackVirtualPageView({
            url: url,
            userAgent: userAgent
        });
    }
}


















function $3766ece64074472c$export$7cd497ab1d81979(rule) {
    const flags = rule.pattern_qualifiers?.reduce((acc, flag)=>{
        if (flag === "case_insensitive") return acc + "i";
        return acc;
    }, "");
    const regexp = new RegExp(rule.pattern, flags);
    return regexp;
}
function $3766ece64074472c$export$633e2a16484dff95(challenge) {
    // right now we only support Regex rules
    const regexRules = challenge.options.validation_rules.regular_expressions;
    if (!regexRules) return [];
    const rules = regexRules.map((rule)=>{
        const regexp = $3766ece64074472c$export$7cd497ab1d81979(rule);
        return {
            type: "regex",
            name: rule.name,
            regexp: regexp,
            matchType: rule.match_type
        };
    });
    return rules;
}
function $3766ece64074472c$export$a22775fa5e2eebd9({ password: password, rules: rules }) {
    const failedRules = [];
    rules.forEach((rule)=>{
        const match = rule.regexp.test(password);
        if (match && rule.matchType === "must_not_match") failedRules.push(rule);
        else if (!match && rule.matchType === "must_match") failedRules.push(rule);
    });
    if (failedRules.length === 0) return {
        valid: true,
        failedRules: []
    };
    return {
        valid: false,
        failedRules: failedRules
    };
}



const $6e0c5c565800e425$var$OTP_CHALLENGES = new Set([
    $4928fc6e055557be$export$7962c6bffc1da42.Otp,
    $4928fc6e055557be$export$7962c6bffc1da42.TotpRegister,
    $4928fc6e055557be$export$7962c6bffc1da42.TotpVerify
]);
function $6e0c5c565800e425$export$4502c327d844b59c(challenge) {
    return $6e0c5c565800e425$var$OTP_CHALLENGES.has(challenge);
}
class $6e0c5c565800e425$export$3b603621c2caaf6c {
    constructor(slashID, emitter, flowMeta){
        this.flowCancelled = false;
        this.notifySlashID = (key, event)=>{
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.emit({
                name: key,
                payload: event,
                meta: {
                    access: "public",
                    ...this.flowMeta
                }
            });
        };
        // TODO do we need the whole config?
        this.slashID = slashID;
        this.authnClient = new $125642d21ec07f66$export$872437fb2a17cd0e(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        this.emitter = emitter;
        this.flowMeta = flowMeta;
        this.listenForEvents();
    }
    listenForEvents() {
        this.emitter.on("flowCancelled", ()=>{
            this.flowCancelled = true;
        });
    }
    updateClient(token) {
        this.authnClient = new $125642d21ec07f66$export$872437fb2a17cd0e(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ],
            ...token && {
                accessToken: token
            }
        }));
    }
    async processChallenges({ challenges: challenges, authnFactor: authnFactor, previousToken: previousToken }) {
        this.updateClient(previousToken);
        this.authnFactor = authnFactor;
        let userToken = undefined;
        // TODO make sure the challenge detail is added to the error if it happens
        for (const ch of challenges)userToken = await this.process(ch, this.authnFactor);
        // clear auth factor
        this.authnFactor = undefined;
        if (!userToken) throw new Error("no user token in attestation response");
        return userToken;
    }
    async process(challenge, authnFactor) {
        let attestation;
        switch(challenge.type){
            case $4928fc6e055557be$export$7962c6bffc1da42.AuthnContextUpdate:
                return this.processAuthnContextUpdateChallenge(challenge);
            case $4928fc6e055557be$export$7962c6bffc1da42.Proxy:
                return this.processProxyChallenge(challenge);
            case $4928fc6e055557be$export$7962c6bffc1da42.Nonce:
                attestation = await this.processNonceChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.Otp:
                {
                    const otpOpts = new (0, $95827f61328b407c$export$1fd9c30e1b817ee4)(authnFactor?.options);
                    attestation = await this.processOTPChallenge(challenge, otpOpts);
                    break;
                }
            case $4928fc6e055557be$export$7962c6bffc1da42.TotpRegister:
                attestation = await this.processTOTPRegisterChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.TotpVerify:
                attestation = await this.processTOTPVerifyChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.WebauthnGet:
                attestation = await this.processWebAuthnGetChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.WebauthnCreate:
                attestation = await this.processWebAuthnCreateChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.Oidc:
                return this.processOIDCChallenge(challenge, authnFactor);
            case $4928fc6e055557be$export$7962c6bffc1da42.Saml:
                return this.processSAMLChallenge(challenge, authnFactor);
            case $4928fc6e055557be$export$7962c6bffc1da42.PasswordSet:
                attestation = await this.processPasswordSetChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.PasswordVerify:
                attestation = await this.processPasswordVerifyChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.PasswordReset:
                attestation = await this.processPasswordResetChallenge(challenge);
                break;
            case $4928fc6e055557be$export$7962c6bffc1da42.UiCustomization:
                return this.processUiCustomizationChallenge(challenge);
            default:
                console.warn("Please update the SDK to the latest version. Ignoring unhandled challenge type: " + JSON.stringify(challenge));
                return "";
        }
        let response;
        let headers;
        let originalError;
        try {
            const resp = await this.authnClient.postAttestationV3Raw({
                // @ts-expect-error challenge_type is typed as possible undefined
                attestation: attestation,
                slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            response = await resp.value();
            headers = resp.raw.headers;
        } catch (e) {
            if ($b18eec6826b7d21f$export$a98b3b17ec378e54(e)) {
                response = await e.response.clone().json();
                headers = e.response.headers;
                originalError = e;
            } else throw e;
        }
        const headersIncludesLocation = headers.has("location");
        if (headersIncludesLocation) {
            const redirectUri = headers.get("location");
            if (typeof redirectUri === "string" && Boolean(redirectUri)) this.emitter.emit({
                name: "redirectUriDiscovered",
                payload: {
                    redirectUri: redirectUri
                },
                meta: {
                    access: "public"
                }
            });
        }
        if ($b18eec6826b7d21f$export$5f71bfa25cb0590e(response) && response.errors.length) {
            // retryable errors
            if (response.errors[0].httpcode === 400 && challenge.type === $4928fc6e055557be$export$7962c6bffc1da42.PasswordSet) {
                // password validation failed server side
                this.notifySlashID("invalidPasswordSubmitted", {
                    failedRules: [],
                    authenticationFactor: authnFactor,
                    challengeId: challenge.id,
                    failureDetail: response.errors[0].message
                });
                return this.process(challenge, authnFactor);
            }
            if (response.errors[0].httpcode === 401 && challenge.type === $4928fc6e055557be$export$7962c6bffc1da42.PasswordVerify) {
                // password does not match what is recorded for the given handle
                this.notifySlashID("incorrectPasswordSubmitted", {
                    authenticationFactor: authnFactor,
                    challengeId: challenge.id,
                    failureDetail: response.errors[0].message
                });
                return this.process(challenge, authnFactor);
            }
            if (response.errors[0].httpcode === 401 && $6e0c5c565800e425$export$4502c327d844b59c(challenge.type)) {
                // unlike all other challenges OTPs are potentially subject to user errors => retry on Unauthorized
                this.notifySlashID("otpIncorrectCodeSubmitted", {
                    factor: authnFactor,
                    challengeId: challenge.id
                });
                return this.process(challenge, authnFactor);
            }
            const sidError = await $b18eec6826b7d21f$export$ed0b6181311676c(originalError);
            throw sidError;
        }
        const userToken = response.result.token;
        if (!userToken) throw new Error("no user token in attestation response");
        if (challenge.type === $4928fc6e055557be$export$7962c6bffc1da42.WebauthnCreate) {
            const options = challenge.options;
            this.slashID.credentialStorage.add(options.rp.id, attestation.data.rawId);
        }
        return userToken;
    }
    async processProxyChallenge(challenge) {
        let userToken = undefined;
        while(!userToken){
            if (this.flowCancelled) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                name: $43ff6ce83801d41a$export$daceac3b97803ce1.flowCancelled,
                message: "The flow has been cancelled!",
                context: {
                    challenge: challenge
                }
            });
            await $82539a0f7276774c$export$e772c8ff12451969(1000);
            // TODO review
            const response = await this.authnClient.getChallengeChallengeIdV2({
                challengeId: challenge.options.challenge_id,
                slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            // v7 client returns null on HTTP 202 (still pending) — loop continues.
            if (response?.errors) {
                if (response.errors.length !== 1 || response.errors[0].httpcode !== 202) throw response;
            }
            userToken = response?.result;
        }
        return userToken;
    }
    /**
     * When the server sends an AuthnContextUpdateChallenge, the client can subscribe to this event so it can update the authn context
     */ async processAuthnContextUpdateChallenge(challenge) {
        this.notifySlashID("authnContextUpdateChallengeReceivedEvent", {
            targetOrgId: challenge.options.target_org_id,
            factor: challenge.options.factor
        });
        // update the internal context
        if (challenge.options.factor) {
            this.authnFactor = challenge.options.factor;
            // SSO - client side effects
            switch(this.authnFactor.method){
                case $6b68392b32751678$export$8279f5e63c6521d8.Oidc:
                    this.authnFactor = await (0, $95827f61328b407c$export$af64486b3e452a98)(this.authnFactor);
                    break;
                case $6b68392b32751678$export$8279f5e63c6521d8.Saml:
                    this.authnFactor = await (0, $95827f61328b407c$export$98f5d2f2dc6acbbd)(this.authnFactor);
                    break;
            }
        }
        // this should never be the final challenge
        return "";
    }
    async processNonceChallenge(challenge) {
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                challenge: challenge.options?.challenge
            }
        };
        return attestation;
    }
    shouldProcessEvent(event) {
        if (!event.meta) return true;
        if (!event.meta.authFlowId && !event.meta.recoveryFlowId) return true;
        if (this.flowMeta?.authFlowId && event.meta?.authFlowId !== this.flowMeta.authFlowId) return false;
        if (this.flowMeta?.recoveryFlowId && event.meta?.recoveryFlowId !== this.flowMeta.recoveryFlowId) return false;
        return true;
    }
    async processOTPChallenge(challenge, otpFactorOptions) {
        this.notifySlashID("otpSmsSent");
        this.notifySlashID("otpCodeSent");
        const handleOtpInput = new Promise((resolve)=>{
            const getOtp = (event)=>{
                if (!this.shouldProcessEvent(event)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("otpCodeSubmitted", getOtp);
                resolve(event.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("otpCodeSubmitted", getOtp);
        });
        // backward compatibility - in case a client sends in getOTP we wrap it with the event
        if (typeof otpFactorOptions.getOTP === "function") otpFactorOptions.getOTP().then((otp)=>this.notifySlashID("otpCodeSubmitted", otp));
        const otpCode = await handleOtpInput;
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                otp: otpCode
            }
        };
        return attestation;
    }
    async processTOTPRegisterChallenge(challenge) {
        this.notifySlashID("totpKeyGenerated", {
            uri: challenge.options?.key_uri,
            qrCode: challenge.options?.qr_code_data_b64,
            recoveryCodes: challenge.options?.recovery_codes
        });
        const handleTotpInput = new Promise((resolve)=>{
            const getOtp = (event)=>{
                if (!this.shouldProcessEvent(event)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("otpCodeSubmitted", getOtp);
                resolve(event.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("otpCodeSubmitted", getOtp);
        });
        const totpCode = await handleTotpInput;
        if (!totpCode) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: $43ff6ce83801d41a$export$daceac3b97803ce1.invalidActionError,
            message: "no TOTP code provided",
            context: {
                challengeId: challenge.id
            }
        });
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                otp: totpCode
            }
        };
        return attestation;
    }
    async processTOTPVerifyChallenge(challenge) {
        this.notifySlashID("totpCodeRequested");
        const handleTotpInput = new Promise((resolve)=>{
            const getOtp = (event)=>{
                if (!this.shouldProcessEvent(event)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("otpCodeSubmitted", getOtp);
                resolve(event.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("otpCodeSubmitted", getOtp);
        });
        const totpCode = await handleTotpInput;
        if (!totpCode) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: $43ff6ce83801d41a$export$daceac3b97803ce1.invalidActionError,
            message: "no TOTP code provided",
            context: {
                challengeId: challenge.id
            }
        });
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                otp: totpCode
            }
        };
        return attestation;
    }
    async processWebAuthnGetChallenge(challenge) {
        // Calling WebAuthn API needs focus
        const hadFocus = await $76a5a02979c884f4$export$d245da411ccc251b();
        const options = challenge.options;
        if (!this.slashID.isLocalScope(options.rpId)) {
            const sdkURL = this.slashID.getSDKUrl();
            let sdkWindow;
            if (await (0, $b5612fac2c319704$export$261888861cdb8a55).canGetPublicKeyCredentialsInIFrame()) {
                sdkWindow = this.slashID.iframe.contentWindow;
                if (!sdkWindow) throw new Error("cannot get global id iframe");
            } else {
                // Empirically if we don't wait here the "popup"
                // on Chrome is created but doesn't get focus
                if (!hadFocus) await $82539a0f7276774c$export$e772c8ff12451969(200);
                // no target, features args => should open a tab, not a popup
                sdkWindow = window.open(sdkURL.toString());
                if (!sdkWindow) throw new Error("cannot open global id window");
            }
            const attestationPromise = new Promise((resolve, reject)=>{
                const request = new $321a099d23035c75$export$b2a6577196c1aa92({
                    baseURL: this.slashID.baseURL,
                    sdkURL: this.slashID.sdkURL
                }, challenge);
                const responseListener = (event)=>{
                    const response = event.data;
                    if (response.id !== request.id) return;
                    // has no effect on an IFrame
                    sdkWindow.close();
                    window.removeEventListener("message", responseListener);
                    if (response.error) reject(response.error);
                    else resolve(response.attestation);
                };
                window.addEventListener("message", responseListener);
                // TODO handle retries
                $1d8da30c174c275e$export$ccfc10b8bad1155a(sdkWindow).then((win)=>{
                    win.postMessage(request, sdkURL.origin);
                });
            });
            return attestationPromise;
        } else {
            const decodedOptions = {
                challenge: $ff4fa6023341e739$export$2f872c0f2117be69(options.challenge),
                extensions: options.extensions,
                rpId: options.rpId,
                timeout: options.timeout,
                userVerification: options.userVerification
            };
            const allowCredentials = options.allowCredentials;
            if (allowCredentials) {
                decodedOptions.allowCredentials = new Array(allowCredentials.length);
                for(let idx = 0; idx < allowCredentials.length; idx++){
                    const credential = allowCredentials[idx];
                    decodedOptions.allowCredentials[idx] = {
                        id: $ff4fa6023341e739$export$2f872c0f2117be69(credential.id),
                        type: credential.type,
                        transports: credential.transports
                    };
                }
            }
            const credential = await navigator.credentials.get({
                publicKey: decodedOptions
            });
            if (!credential) throw new Error("could not create assert credential");
            const attestationResponse = credential.response;
            const rawId = $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(credential.rawId));
            const encodedCredential = {
                id: credential.id,
                rawId: rawId,
                type: credential.type,
                clientExtensionResults: credential.getClientExtensionResults(),
                response: {
                    clientDataJSON: $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(attestationResponse.clientDataJSON)),
                    authenticatorData: $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(attestationResponse.authenticatorData)),
                    signature: $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(attestationResponse.signature)),
                    userHandle: attestationResponse.userHandle ? $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(attestationResponse.userHandle)) : null
                }
            };
            const attestation = {
                challenge_id: challenge.id,
                challenge_type: challenge.type,
                data: encodedCredential
            };
            this.notifySlashID("webAuthnChallengeProcessed", {
                credentialId: rawId
            });
            return attestation;
        }
    }
    async processWebAuthnCreateChallenge(challenge) {
        // Calling WebAuthn API needs focus
        const hadFocus = await $76a5a02979c884f4$export$d245da411ccc251b();
        const options = challenge.options;
        if (!this.slashID.isLocalScope(options.rp.id)) {
            // Empirically if we don't wait here the "popup"
            // on Chrome is created but doesn't get focus
            if (!hadFocus) await $82539a0f7276774c$export$e772c8ff12451969(200);
            const attestationPromise = new Promise((resolve, reject)=>{
                const sdkURL = this.slashID.getSDKUrl();
                // no target, features args => should open a tab, not a popup
                const sdkWindow = window.open(sdkURL.toString());
                if (!sdkWindow) {
                    reject(new Error("cannot open global id window"));
                    return;
                }
                const request = new $321a099d23035c75$export$561665cd9d5caa15({
                    baseURL: this.slashID.baseURL,
                    sdkURL: this.slashID.sdkURL
                }, challenge);
                const responseListener = (event)=>{
                    const response = event.data;
                    if (response.id !== request.id) return;
                    sdkWindow.close();
                    window.removeEventListener("message", responseListener);
                    if (response.error) reject(response.error);
                    else resolve(response.attestation);
                };
                window.addEventListener("message", responseListener);
                // TODO handle retries
                $1d8da30c174c275e$export$ccfc10b8bad1155a(sdkWindow).then((win)=>{
                    win.postMessage(request, sdkURL.origin);
                });
            });
            return attestationPromise;
        } else {
            const decodedOptions = {
                challenge: $ff4fa6023341e739$export$2f872c0f2117be69(options.challenge),
                rp: options.rp,
                user: {
                    id: $ff4fa6023341e739$export$2f872c0f2117be69(options.user.id),
                    name: options.user.name,
                    displayName: options.user.displayName
                },
                pubKeyCredParams: options.pubKeyCredParams,
                authenticatorSelection: options.authenticatorSelection,
                timeout: options.timeout,
                extensions: options.extensions,
                attestation: options.attestation
            };
            const excludeCredentials = options.excludeCredentials;
            if (excludeCredentials) {
                decodedOptions.excludeCredentials = new Array(excludeCredentials.length);
                for(let idx = 0; idx < excludeCredentials.length; idx++){
                    const credential = excludeCredentials[idx];
                    decodedOptions.excludeCredentials[idx] = {
                        id: $ff4fa6023341e739$export$2f872c0f2117be69(credential.id),
                        type: credential.type,
                        transports: credential.transports
                    };
                }
            }
            const credential = await navigator.credentials.create({
                publicKey: decodedOptions
            });
            if (!credential) throw new Error("cannot create credential");
            const attestationResponse = credential.response;
            const rawId = $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(credential.rawId));
            const encodedCredential = {
                id: credential.id,
                rawId: rawId,
                type: credential.type,
                clientExtensionResults: credential.getClientExtensionResults(),
                response: {
                    attestationObject: $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(attestationResponse.attestationObject)),
                    clientDataJSON: $ff4fa6023341e739$export$c564cdbbe6da493(new Uint8Array(attestationResponse.clientDataJSON))
                }
            };
            const attestation = {
                challenge_id: challenge.id,
                challenge_type: challenge.type,
                data: encodedCredential
            };
            this.notifySlashID("webAuthnChallengeProcessed", {
                credentialId: rawId
            });
            return attestation;
        }
    }
    async processOIDCChallenge(challenge, authenticationFactor) {
        if (authenticationFactor.options.ux_mode === $24233137c2c49c70$export$947f28fa7e24f5f5.Popup) {
            const handle = authenticationFactor.extras.setPopupUrl(challenge.options.auth_code_url);
            if (!challenge?.options?.auth_code_url) {
                this.notifySlashID("oauthFlowFailed", {
                    ...authenticationFactor.options,
                    reason: $76a5a02979c884f4$export$32deff8ed92da53f.BadOAuthURL
                });
                throw new Error(`Bad OAuth URL - got ${challenge?.options?.auth_code_url}`);
            }
            if (!handle) {
                this.notifySlashID("oauthFlowFailed", {
                    ...authenticationFactor.options,
                    reason: $76a5a02979c884f4$export$32deff8ed92da53f.PopupBlocked
                });
                throw new Error("OIDC flow unsuccesful!");
            }
        } else if (authenticationFactor.options.ux_mode === $24233137c2c49c70$export$947f28fa7e24f5f5.Redirect) window.location.assign(challenge.options.auth_code_url);
        else throw new Error(`Unsupported OAuth ux_mode - got ${authenticationFactor.options.ux_mode}`);
        this.notifySlashID("oauthFlowStarted", authenticationFactor.options);
        // no token yet - proxy challenge will result with a token
        return "";
    }
    async processSAMLChallenge(challenge, authenticationFactor) {
        if (authenticationFactor.options.ux_mode === $f60351fa401f4ee9$export$6dc0f627c99c13a9.Popup) {
            const popup = authenticationFactor.extras.setPopupUrl(challenge.options.start_authentication_url);
            if (!challenge?.options?.start_authentication_url) {
                this.notifySlashID("popupFailed", {
                    reason: $76a5a02979c884f4$export$af2e6529191b5a73.BadAuthURL
                });
                throw new Error(`Bad authentication URL - got ${challenge?.options?.start_authentication_url}`);
            }
            if (!popup) {
                this.notifySlashID("popupFailed", {
                    reason: $76a5a02979c884f4$export$af2e6529191b5a73.PopupBlocked
                });
                throw new Error("SAML flow unsuccesful!");
            }
        } else if (authenticationFactor.options.ux_mode === $f60351fa401f4ee9$export$6dc0f627c99c13a9.Redirect) window.location.assign(challenge.options.start_authentication_url);
        else throw new Error(`Unsupported SAML ux_mode - got ${authenticationFactor.options.ux_mode}`);
        // no token yet - proxy challenge will result with a token
        return "";
    }
    async processPasswordSetChallenge(challenge) {
        // let the client know the password input is ready
        this.notifySlashID("passwordSetReady");
        // wait for the client to submit the password
        const handlePasswordInput = new Promise((resolve)=>{
            const getPassword = (passwordEvent)=>{
                if (!this.shouldProcessEvent(passwordEvent)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("passwordSubmitted", getPassword);
                resolve(passwordEvent.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("passwordSubmitted", getPassword);
        });
        const password = await handlePasswordInput;
        const passwordValidation = (0, $3766ece64074472c$export$a22775fa5e2eebd9)({
            password: password,
            rules: (0, $3766ece64074472c$export$633e2a16484dff95)(challenge)
        });
        if (!passwordValidation.valid) {
            this.notifySlashID("invalidPasswordSubmitted", {
                failedRules: passwordValidation.failedRules,
                challengeId: challenge.id,
                authenticationFactor: {
                    method: $6b68392b32751678$export$8279f5e63c6521d8.Password
                },
                failureDetail: `invalid_password: ${passwordValidation.failedRules.map((rule)=>rule.name).join(",")}`
            });
            return await this.processPasswordSetChallenge(challenge);
        }
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                password: password
            }
        };
        return attestation;
    }
    processPasswordVerifyChallenge(challenge) {
        // let the client know the password input is ready
        this.notifySlashID("passwordVerifyReady");
        // wait for the client to submit the password
        const handlePasswordInput = new Promise((resolve)=>{
            const getPassword = (passwordEvent)=>{
                if (!this.shouldProcessEvent(passwordEvent)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("passwordSubmitted", getPassword);
                resolve(passwordEvent.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("passwordSubmitted", getPassword);
        });
        return handlePasswordInput.then((password)=>{
            if (!password) throw new Error("No password provided");
            const attestation = {
                challenge_id: challenge.id,
                challenge_type: challenge.type,
                data: {
                    password: password
                }
            };
            return attestation;
        });
    }
    /**
     * TODO complete copy paste of password set challenge
     * TODO write docs
     */ async processPasswordResetChallenge(challenge) {
        // let the client know the password input is ready
        this.notifySlashID("passwordResetReady");
        // wait for the client to submit the password
        const handlePasswordInput = new Promise((resolve)=>{
            const getPassword = (passwordEvent)=>{
                if (!this.shouldProcessEvent(passwordEvent)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("passwordSubmitted", getPassword);
                resolve(passwordEvent.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("passwordSubmitted", getPassword);
        });
        const password = await handlePasswordInput;
        const passwordValidation = (0, $3766ece64074472c$export$a22775fa5e2eebd9)({
            password: password,
            rules: (0, $3766ece64074472c$export$633e2a16484dff95)(challenge)
        });
        if (!passwordValidation.valid) {
            this.notifySlashID("invalidPasswordSubmitted", {
                authenticationFactor: {
                    method: $6b68392b32751678$export$8279f5e63c6521d8.Password
                },
                failedRules: passwordValidation.failedRules,
                challengeId: challenge.id,
                failureDetail: `invalid_password: ${passwordValidation.failedRules.map((rule)=>rule.name).join(",")}`
            });
            return await this.processPasswordSetChallenge(challenge);
        }
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                password: password
            }
        };
        return attestation;
    }
    async processUiCustomizationChallenge(challenge) {
        const customizationProperties = challenge.options?.authn_redirect_page_ui_config;
        if (!customizationProperties) throw new Error("No customization properties provided!");
        this.notifySlashID("uiCustomizationReceived", {
            customizationProperties: customizationProperties
        });
        // this challenge is processed at the beginning, before actual authentication
        return "";
    }
}





class $0c37c96de0d5eaeb$export$4d9fb5586e103031 {
    constructor(slashID, emitter){
        this.slashID = slashID;
        this.flowId = (0, $85977a4a88521617$export$2e2bcd8739ae039)();
        this.emitter = emitter;
    }
    shouldProcessEvent(event) {
        if (this.flowId && event.meta?.authFlowId !== this.flowId) return false;
        return true;
    }
    /**
     * Returns a User instance upon successful authentication.
     * If authContextUpdateEnabled flag is raised, login flow will block and wait until the corresponding ACK event is submitted.
     */ async _id({ oid: oid, authenticationFactor: authenticationFactor, handle: handle, prevToken: prevToken }) {
        if (authenticationFactor) switch(authenticationFactor.method){
            case $6b68392b32751678$export$8279f5e63c6521d8.Webauthn.toString():
                {
                    if (!(navigator && window.PublicKeyCredential)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                        message: "The WebAuthn API is not available in the current environment",
                        context: {
                            method: $6b68392b32751678$export$8279f5e63c6521d8.Webauthn,
                            handle: handle,
                            authenticationFactor: authenticationFactor
                        }
                    });
                    let opts = authenticationFactor.options;
                    if (!opts) opts = {};
                    // default to local scope
                    if (!opts.scope) opts.scope = window.location.hostname;
                    const knownCredIds = await this.slashID.credentialStorage.get(opts.scope);
                    if (knownCredIds) opts.available_credential_ids = knownCredIds;
                    // fallback to default SlashID WebAuthn options if not provided explicitly
                    if (!opts.attachment) opts.attachment = $df7f3daf49d23371$export$51952aaa367c79db.Any;
                    if (!opts.user_verification) opts.user_verification = $42e936753c078d49$export$1bc598454e9d0dfc.Preferred;
                    if (!opts.resident_key) opts.resident_key = $2f59d893d3ed77d4$export$df3e12f65ba023ba.Preferred;
                    if (!opts.attestation) opts.attestation = $9bab85da82296f1a$export$c1ff3c79d2429507.None;
                    if (opts.attachment === $df7f3daf49d23371$export$51952aaa367c79db.Platform) {
                        const hasPlatformAuthenticator = await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
                        if (!hasPlatformAuthenticator) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                            message: "This device has no platform authenticator available",
                            context: {
                                method: $6b68392b32751678$export$8279f5e63c6521d8.Webauthn,
                                handle: handle,
                                authenticationFactor: authenticationFactor
                            }
                        });
                    }
                    authenticationFactor.options = opts;
                }
                break;
            case $6b68392b32751678$export$8279f5e63c6521d8.EmailLink.toString():
            case $6b68392b32751678$export$8279f5e63c6521d8.OtpViaEmail.toString():
                if (handle && handle.type !== $eb92675354d724ac$export$885886f088cd0586.EmailAddress) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                    name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                    message: `A handle of type '${$eb92675354d724ac$export$885886f088cd0586.EmailAddress}' is required, got '${handle.type}' instead`,
                    context: {
                        method: $6b68392b32751678$export$8279f5e63c6521d8.EmailLink,
                        handle: handle,
                        authenticationFactor: authenticationFactor
                    }
                });
                break;
            case $6b68392b32751678$export$8279f5e63c6521d8.SmsLink.toString():
            case $6b68392b32751678$export$8279f5e63c6521d8.OtpViaSms.toString():
                if (handle && handle.type !== $eb92675354d724ac$export$885886f088cd0586.PhoneNumber) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                    name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                    message: `A handle of type '${$eb92675354d724ac$export$885886f088cd0586.PhoneNumber}' is required, got '${handle.type}' instead`,
                    context: {
                        method: $6b68392b32751678$export$8279f5e63c6521d8.SmsLink,
                        handle: handle,
                        authenticationFactor: authenticationFactor
                    }
                });
                authenticationFactor.options = new (0, $95827f61328b407c$export$1fd9c30e1b817ee4)(authenticationFactor.options);
                break;
            case $6b68392b32751678$export$8279f5e63c6521d8.Oidc.toString():
                {
                    //OIDC should not be used with handles
                    if (handle) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                        message: "OIDC should not be used with handles",
                        context: {
                            method: $6b68392b32751678$export$8279f5e63c6521d8.Oidc,
                            handle: handle,
                            authenticationFactor: authenticationFactor
                        }
                    });
                    authenticationFactor = await (0, $95827f61328b407c$export$af64486b3e452a98)(authenticationFactor);
                    const cleanUpAfterError = (event)=>{
                        if (!this.shouldProcessEvent(event)) return;
                        const oidcOptions = authenticationFactor;
                        if (oidcOptions?.extras?.popup) oidcOptions?.extras?.popup.close();
                        this.emitter.off("oauthFlowFailed", cleanUpAfterError);
                    };
                    this.emitter.on("oauthFlowFailed", cleanUpAfterError);
                }
                break;
            case $6b68392b32751678$export$8279f5e63c6521d8.Saml.toString():
                {
                    if (handle) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                        name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                        message: "SAML should not be used with handles",
                        context: {
                            method: $6b68392b32751678$export$8279f5e63c6521d8.Saml,
                            handle: handle,
                            authenticationFactor: authenticationFactor
                        }
                    });
                    authenticationFactor = await (0, $95827f61328b407c$export$98f5d2f2dc6acbbd)(authenticationFactor);
                    const cleanUpAfterError = (event)=>{
                        if (!this.shouldProcessEvent(event)) return;
                        const saml = authenticationFactor;
                        if (saml?.extras?.popup) saml?.extras?.popup.close();
                        this.emitter.off("popupFailed", cleanUpAfterError);
                    };
                    this.emitter.on("popupFailed", cleanUpAfterError);
                }
                break;
            default:
                break;
        }
        const factor = {
            method: authenticationFactor?.method,
            options: authenticationFactor?.options
        };
        if (factor.method !== undefined) factor.options = {
            ...factor.options,
            method: factor.method
        };
        this.emitter.emit({
            name: "idFlowStarted",
            payload: {
                authenticationFactor: authenticationFactor
            },
            meta: {
                authFlowId: this.flowId,
                access: "public"
            }
        });
        const authnClient = new $125642d21ec07f66$export$872437fb2a17cd0e(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ],
            ...prevToken && {
                accessToken: prevToken
            }
        }));
        const metadata = await (0, $903aaedbe0db6f0b$export$9f45878548a7cf78)();
        const response = await authnClient.postIdV2({
            slashIDOrgID: oid,
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
            iDRequestV2: {
                handle: handle,
                factor: factor,
                metadata: metadata
            }
        }, {
            cache: "no-cache"
        });
        if (response.errors) throw response;
        const challenges = response.result;
        if (!challenges) throw new Error("no challenges in ID response");
        const challengeProcessor = new (0, $6e0c5c565800e425$export$3b603621c2caaf6c)(this.slashID, this.emitter, {
            authFlowId: this.flowId
        });
        const token = await challengeProcessor.processChallenges({
            challenges: challenges,
            authnFactor: authenticationFactor,
            previousToken: prevToken
        });
        if (handle) try {
            this.slashID.identifiersStorage.add(handle);
        } catch (e) {
            console.warn(e);
        }
        /**
         *
         * @event {@link Types.IdFlowSucceededEvent}
         */ this.emitter.emit({
            name: "idFlowSucceeded",
            payload: {
                token: `${token}`,
                authenticationFactor: authenticationFactor,
                handle: handle
            },
            meta: {
                authFlowId: this.flowId,
                access: "public"
            }
        });
        return this.slashID.getUser(token);
    }
    /**
     * Use a verified handle and a factor to start the account recovery flow.
     * The user will receive instructions on how to proceed using a delivery mechanism based on the given handle.
     * After this method resolves, the user will be able to authenticate using the same handle and factor.
     */ async recover({ handle: handle, factor: factor }) {
        const authnClient = new $125642d21ec07f66$export$872437fb2a17cd0e(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        const { result: challenges } = await authnClient.postRecover({
            recoverRequest: {
                handle: handle,
                factor: factor
            },
            slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw,
            slashIDOrgID: this.slashID.oid
        });
        if (!challenges) // TODO improve handling
        throw new Error("no result in recover response");
        const challengeProcessor = new (0, $6e0c5c565800e425$export$3b603621c2caaf6c)(this.slashID, this.emitter, {
            recoveryFlowId: this.flowId
        });
        await challengeProcessor.processChallenges({
            challenges: challenges,
            authnFactor: factor
        });
    }
}



function $1450e8da534d7849$export$abfecd6a8e6070c1() {
    const eventHandlers = {};
    const middlewares = new Set();
    function on(eventName, handler) {
        if (!eventHandlers[eventName]) eventHandlers[eventName] = new Set();
        eventHandlers[eventName].add(handler);
    }
    function off(eventName, handler) {
        const handlers = eventHandlers[eventName];
        if (handlers) handlers.delete(handler);
    }
    function emit(event) {
        const handlers = eventHandlers[event.name];
        if (!handlers || !handlers.size) return;
        let cancelled = false;
        const eventWithMiddleware = middlewares.size > 0 ? [
            ...middlewares
        ].reduce((eventAggregate, middleware)=>{
            if (cancelled) return eventAggregate;
            return middleware(eventAggregate, ()=>{
                cancelled = true;
            }) || eventAggregate;
        }, event) : event;
        if (cancelled) return;
        handlers.forEach((handler)=>handler(eventWithMiddleware));
    }
    /**
     * Each middleware is called in the order it was added.
     * It must either return an event (potentially modified) or call the cancel function to stop the event from being emitted.
     */ function use(middleware) {
        middlewares.add(middleware);
    }
    return {
        on: on,
        off: off,
        emit: emit,
        use: use
    };
}




class $ef74e25b7eeeddfd$export$97e23b13d26a722 extends (0, $02b8f885a1dbea9f$export$d3bddec52a513503) {
    /**
     * Reconstruct an anonymous user from its token value. Call the `id` method to authenticate the user.
     * If this results with registering a new user, the underlying user ID will be the same as the originating anonymous user.
     *
     * Instances can only be constructed in a browser environment due to dependency on {@link SlashID}.
     *
     * @param token A user {@link token} value.
     * @param slashid SlashID instance
     *
     * @throws `TypeError` the given token cannot be decoded.
     */ constructor(token, slashid){
        // both the options and SlashID instances have the same fields (baseURL, sdkURL, oid)
        super(token, slashid);
        if (this.decoded.person_type !== "anonymous") throw new Error("Token must have person_type 'anonymous'");
        this._slashid = slashid;
    }
    /**
     *  Authenticates the [AnonymousUser], on success the user is now a permanently registered user.
     *
     *  @returns `Promise<BrowserUser>`
     */ async id(handle, authenticationFactor) {
        return this._slashid._id(this.decoded.oid, handle, authenticationFactor, this.token);
    }
}




const $b5612fac2c319704$var$SlashIDIFrameID = "__SlashID_iframe";
const $b5612fac2c319704$var$PRIVATE_PUBLISH = Symbol();
const $b5612fac2c319704$var$PRIVATE_SUBSCRIBE = Symbol();
const $b5612fac2c319704$var$PRIVATE_UNSUBSCRIBE = Symbol();
const $b5612fac2c319704$export$5f74d2b45f2a2732 = (sid)=>({
        publish: (type, event)=>sid[$b5612fac2c319704$var$PRIVATE_PUBLISH](type, event),
        subscribe: (type, handler)=>sid[$b5612fac2c319704$var$PRIVATE_SUBSCRIBE](type, handler),
        unsubscribe: (type, handler)=>sid[$b5612fac2c319704$var$PRIVATE_UNSUBSCRIBE](type, handler)
    });
class $b5612fac2c319704$export$261888861cdb8a55 {
    /**
     * @example
     *
     * For production you can simply create your _SlashID_ instance with:
     *
     * ```js
     * import * as slashid from "slashid"
     * const sid = new slashid.SlashID()
     * ```
     *
     * If you want to experiment and connect to the sandbox environment instead:
     *
     * ```js
     * const sid = new slashid.SlashID({
     *   environment: "sandbox"
     * })
     * ```
     *
     * @param options Your SlashID connection options.
     * @throws `TypeError` If the given `options`, if defined, fail validation
     */ constructor(options){
        if (options) (0, $95827f61328b407c$export$7586e69c60094c9d)(options);
        this.config = (0, $95827f61328b407c$export$851d251ce7109e65)(options ?? {});
        const { baseURL: baseURL, sdkURL: sdkURL, oid: oid, analyticsEnabled: analyticsEnabled = true } = this.config;
        this.baseURL = baseURL;
        this.sdkURL = sdkURL;
        this.oid = oid;
        this.authFlow = null;
        this.recoveryFlow = null;
        this.authnClient = new $125642d21ec07f66$export$872437fb2a17cd0e(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.baseURL,
            middleware: [
                (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        this.personsClient = new $f0e0cb433712a97f$export$f5f4fdd1b1ffabb3(new (0, $d34fdaa1d1a4aef1$export$fa89be98fe0936f2)({
            ...(0, $d34fdaa1d1a4aef1$export$ac4f8128ea29c5),
            basePath: this.baseURL,
            middleware: [
                (0, $a1defa33305d4825$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        this.iframe = this.setupIFrame();
        const crossDomainStore = new (0, $2f79ecfdbc9bfdc9$export$68371093923cfc31)(this.iframe, this.getSDKUrl().origin);
        this.identifiersStorage = new (0, $2f79ecfdbc9bfdc9$export$720664048a0262dc)(crossDomainStore);
        this.credentialStorage = new (0, $2f79ecfdbc9bfdc9$export$28d449e9c93b4ea6)(crossDomainStore);
        this.userFromURL = null;
        this.emitter = (0, $1450e8da534d7849$export$abfecd6a8e6070c1)();
        this.emitter.use(this.createFlowScopeMiddleware());
        this.emitterDecoratorFactory = $76a5a02979c884f4$export$45e9ff32b647b1fa();
        this.analytics = analyticsEnabled ? new (0, $6b2e562d245e2fa0$export$a7b0438860379c35)({
            sdk: this
        }) : undefined;
        this.listenForEvents();
    }
    /**
     * Get an instance of the Analytics class. Use the instance to track virtual page views.
     * @throws `Error` If analytics is not enabled or oid is not set.
     * @returns Analytics instance
     */ getAnalytics() {
        if (!this.analytics) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            message: "Analytics has to be enabled to use this method"
        });
        return this.analytics;
    }
    static async canGetPublicKeyCredentialsInIFrame() {
        const jsWindow = window;
        const isChrome = !!jsWindow.chrome && (!!jsWindow.chrome.webstore || !!jsWindow.chrome.runtime);
        return isChrome;
    }
    /**
     * Starts the login flow with a redirect to the hosted login page.
     */ async startHostedLoginFlow(params) {
        // ensure the session storage is ready before starting a new flow
        (0, $903aaedbe0db6f0b$export$5fb04c0b31ecb34c)(params);
        const { csrf_token: csrf_token, pkce_code_challenge: pkce_code_challenge } = await (0, $903aaedbe0db6f0b$export$9f45878548a7cf78)();
        const url = new URL("/oauth2/authorize", this.baseURL);
        url.searchParams.set("redirect_uri", params.redirectUri);
        url.searchParams.set("client_id", params.clientId);
        url.searchParams.set("response_type", "code");
        url.searchParams.set("state", csrf_token);
        url.searchParams.set("scope", "openid");
        url.searchParams.set("code_challenge", pkce_code_challenge);
        url.searchParams.set("code_challenge_method", "S256");
        // navigate
        window.location.assign(url);
    }
    /**
     * Resolves the previously started login flow with a redirect to the hosted login page.
     * Call this method on the page where the hosted login page redirects to.
     */ async resolveHostedLoginFlow() {
        const oidcParams = (0, $903aaedbe0db6f0b$export$2a015c1c89819b5a)(window.location.search);
        if (oidcParams) {
            const { clientId: clientId, redirectUri: redirectUri } = (0, $903aaedbe0db6f0b$export$a2218d2039ce5af0)();
            // POST to /oauth2/tokens
            // TODO no API client for this
            try {
                const { id_token: id_token } = await (0, $903aaedbe0db6f0b$export$64ca83e534616343)({
                    ...oidcParams,
                    clientId: clientId,
                    redirectUri: redirectUri,
                    apiBaseURL: this.baseURL
                });
                const user = this.getUser(id_token);
                if (this.analytics) this.getAnalytics().identify(user);
                (0, $903aaedbe0db6f0b$export$8af8138ab9f57e02)();
                return user;
            } catch (e) {
                await this.processError(e, {});
                throw await $b18eec6826b7d21f$export$ed0b6181311676c(e);
            }
        }
    }
    /**
     * Event emitter middleware that prevents events leaking between flows
     */ createFlowScopeMiddleware() {
        const sdk = this;
        return function middleware(event, cancel) {
            if (event.meta && event.meta.authFlowId && sdk.authFlow?.flowId && sdk.authFlow?.flowId !== event.meta.authFlowId) return cancel();
            if (event.meta && event.meta.recoveryFlowId && sdk.recoveryFlow?.flowId && sdk.recoveryFlow?.flowId !== event.meta.recoveryFlowId) return cancel();
            return event;
        };
    }
    /**
     * Publish an event to the SDK. Currently available events are listed in {@link Types.PublicWriteEvents}.
     * @param type
     * @param event
     */ publish(type, event) {
        if (!$76a5a02979c884f4$export$fdd1788388ec077b(type)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Trying to publish an unsupported event: ${type}`,
            context: {
                type: type,
                event: event
            }
        });
        this.emitter.emit({
            name: type,
            payload: event,
            meta: {
                access: "public",
                authFlowId: this.authFlow?.flowId,
                recoveryFlowId: this.recoveryFlow?.flowId
            }
        });
    }
    /**
     * Variant of [publish] for private events
     */ [$b5612fac2c319704$var$PRIVATE_PUBLISH](type, event) {
        if (!$76a5a02979c884f4$export$a447b62f94c26639(type)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Trying to publish an unsupported event: ${type}`,
            context: {
                type: type,
                event: event
            }
        });
        this.emitter.emit({
            name: type,
            payload: event,
            meta: {
                access: "private",
                authFlowId: this.authFlow?.flowId,
                recoveryFlowId: this.recoveryFlow?.flowId
            }
        });
    }
    /**
     * Subscribe to the events published by the SDK. Currently available events are listed in {@link Types.PublicReadEvents}.
     * @param type
     * @param handler
     */ subscribe(type, handler) {
        if (!$76a5a02979c884f4$export$ab1e84ca8f5ea7e(type)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Trying to subscribe to unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const wrappedHandler = this.emitterDecoratorFactory.decorate(handler);
        this.emitter.on(type, wrappedHandler);
    }
    /**
     * Variant of [subscribe] for private events
     */ [$b5612fac2c319704$var$PRIVATE_SUBSCRIBE](type, handler) {
        if (!$76a5a02979c884f4$export$a447b62f94c26639(type)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Trying to subscribe to unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const wrappedHandler = this.emitterDecoratorFactory.decorate(handler);
        this.emitter.on(type, wrappedHandler);
    }
    /**
     * Unsubscribe from the SDK events. Currently available events are listed in {@link Types.PublicReadEvents}.
     * @param type
     * @param handler
     */ unsubscribe(type, handler) {
        if (!$76a5a02979c884f4$export$ab1e84ca8f5ea7e(type)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Trying to unsubscribe from an unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const decoratedHandler = this.emitterDecoratorFactory.getDecorator(handler);
        if (decoratedHandler) this.emitter.off(type, decoratedHandler);
    }
    /**
     * Variant of [subscribe] for private events
     */ [$b5612fac2c319704$var$PRIVATE_UNSUBSCRIBE](type, handler) {
        if (!$76a5a02979c884f4$export$a447b62f94c26639(type)) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
            message: `Trying to unsubscribe from an unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const decoratedHandler = this.emitterDecoratorFactory.getDecorator(handler);
        if (decoratedHandler) this.emitter.off(type, decoratedHandler);
    }
    /**
     * Get a Promise that resolves to an array of challenge objects.
     */ async getChallengesFromURL() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let challengeObjs = undefined;
        const challengePackId = urlParams.get($758fb4e9365600ce$export$b1acc9d748d757e8);
        const encodedChallenges = urlParams.get($758fb4e9365600ce$export$61f12a353e32d6b4);
        if (challengePackId && encodedChallenges) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDURLParamsError,
            message: "found both 'challenges' and 'sidcp' URL query parameters",
            context: {
                challengePackId: challengePackId,
                encodedChallenges: encodedChallenges,
                queryString: queryString
            }
        });
        if (challengePackId) try {
            // we got a challenge pack ID => get the challenges
            const response = await this.authnClient.getChallengePackChallengePackId({
                challengePackId: challengePackId,
                slashIDSdkVersion: (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            if (response.errors) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).apiResponseError,
                message: "error fetching challenges",
                context: {
                    errors: response.errors
                }
            });
            challengeObjs = response.result;
        } catch (e) {
            throw await $b18eec6826b7d21f$export$ed0b6181311676c(e);
        }
        else if (encodedChallenges) {
            // check whether challenges are encoded directly in the params
            const challengesData = $ff4fa6023341e739$export$2f872c0f2117be69(encodedChallenges);
            const challengesStr = new TextDecoder("utf-8").decode(challengesData);
            challengeObjs = JSON.parse(challengesStr);
        }
        return challengeObjs;
    }
    /**
     * Process authentication challenges from the URL query parameters.
     * You can use this in conjunction with the Direct-ID API to allow your users to land on your
     * target page already authenticated.
     *
     * If Identity Provider Initiated SSO is enabled and the organization ID is set,
     * this method will also start the SSO flow given the correct parameters.
     *
     * @returns The authenticated user from the `challenges` URL parameter, if present, `null` otherwise.
     */ async getUserFromURL() {
        // processing challenges consumes them, it's not idempotent => on success we memoize the result
        if (!this.userFromURL) {
            // decide what to process
            // #1 IdP-initiated flow
            if (this.config.identityProviderInitiatedSSOEnabled && this.oid) {
                const idpInitiatedSSOParams = (0, $95827f61328b407c$export$b75ec5c826df5f51)(window.location.search);
                if (idpInitiatedSSOParams) try {
                    const ssoOptions = await (0, $95827f61328b407c$export$7c6a3491e5c44625)(idpInitiatedSSOParams);
                    this._id(this.oid, undefined, ssoOptions);
                } catch (e) {
                    await this.processError(e, {});
                    throw await $b18eec6826b7d21f$export$ed0b6181311676c(e);
                }
            }
            // #2 challenges - regular flow
            let challengeObjs;
            try {
                challengeObjs = await this.getChallengesFromURL();
            } catch (e) {
                await this.processError(e, {});
                throw await $b18eec6826b7d21f$export$ed0b6181311676c(e);
            }
            if (challengeObjs) {
                const ssoParams = $321a099d23035c75$export$e3ec70811b10f90d(window.location.search);
                if (ssoParams) this.resolveSSOChallenge(ssoParams) // should not block challenge processing
                ;
                let token = undefined;
                try {
                    const challengeProcessor = new (0, $6e0c5c565800e425$export$3b603621c2caaf6c)(this, this.emitter);
                    token = await challengeProcessor.processChallenges({
                        challenges: challengeObjs
                    });
                } catch (e) {
                    // check if we could extract the challenge ID from the
                    await this.processError(e, {});
                    const isHandlePatternNotAllowedError = $b18eec6826b7d21f$export$a98b3b17ec378e54(e) && await $b18eec6826b7d21f$export$383ea5b2e29d8119(e);
                    if (isHandlePatternNotAllowedError) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                        name: $43ff6ce83801d41a$export$daceac3b97803ce1.handlePatternNotAllowed,
                        message: e.message,
                        cause: e
                    });
                    const isSignUpAwaitingApprovalError = $b18eec6826b7d21f$export$a98b3b17ec378e54(e) && await $b18eec6826b7d21f$export$3176c4f9177c827(e);
                    if (isSignUpAwaitingApprovalError) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                        name: $43ff6ce83801d41a$export$daceac3b97803ce1.signUpAwaitingApproval,
                        message: e.message,
                        cause: e
                    });
                    throw await $b18eec6826b7d21f$export$ed0b6181311676c(e);
                }
                this.userFromURL = new (0, $02b8f885a1dbea9f$export$d3bddec52a513503)(token, {
                    baseURL: this.baseURL,
                    sdkURL: this.sdkURL
                });
                if (this.userFromURL.authentications?.length) {
                    const lastAuthentication = this.userFromURL.authentications[this.userFromURL.authentications.length - 1];
                    this.emitter.emit({
                        name: "idFlowSucceeded",
                        payload: {
                            token: token,
                            authenticationFactor: {
                                method: lastAuthentication.method
                            },
                            handle: lastAuthentication.handle
                        },
                        meta: {
                            access: "public"
                        }
                    });
                }
            }
        }
        if (this.userFromURL) this.emitter.emit({
            name: "userAuthenticatedFromURL",
            payload: {
                token: this.userFromURL.token
            },
            meta: {
                access: "public"
            }
        });
        return this.userFromURL;
    }
    /**
     * This method first checks for URL params associated with SSO. If they are present, it:
     *  - performs CSRF protection checks
     *  - resolves SSO challenge
     * @returns void
     */ async resolveSSOChallenge({ ssoChallengeID: ssoChallengeID, ssoCode: ssoCode, csrfToken: csrfToken }) {
        if (!ssoChallengeID || !ssoCode || !csrfToken) return;
        try {
            const storedCsrfToken = window.localStorage.getItem($758fb4e9365600ce$export$911cde4811331c58);
            if (!storedCsrfToken) throw new Error("no CSRF token stored");
            if (csrfToken !== storedCsrfToken) throw new Error("CSRF token mismatch");
            const pkceCodeVerifier = window.localStorage.getItem($758fb4e9365600ce$export$3f272757255eeb30);
            if (!pkceCodeVerifier) throw new Error("no PKCE code verifier stored");
            await this.authnClient.postSsoResolve({
                slashIDOrgID: this.oid,
                postSsoResolveRequest: {
                    challenge_id: ssoChallengeID,
                    code: ssoCode,
                    pkce_code_verifier: pkceCodeVerifier
                }
            });
        } catch (err) {
            this.processError(err, {});
        } finally{
            window.localStorage.removeItem($758fb4e9365600ce$export$911cde4811331c58);
            window.localStorage.removeItem($758fb4e9365600ce$export$3f272757255eeb30);
        }
    }
    async processEvent(event) {
        // CSRF protection for SSO popup mode
        if ($321a099d23035c75$export$68ca8012194a4829(event.data)) {
            if (event.origin !== this.baseURL) return;
            const ssoParams = $321a099d23035c75$export$e3ec70811b10f90d(event.data.urlParams);
            if (ssoParams) await this.resolveSSOChallenge(ssoParams);
            return;
        }
        let sourceWindow = null;
        if (window.opener && event.source === window.opener) sourceWindow = window.opener;
        if (window.parent && event.source === window.parent) sourceWindow = window.parent;
        if (!sourceWindow) return;
        if ($321a099d23035c75$export$68a74503f112f3ea(event.data)) {
            const request = event.data;
            try {
                sourceWindow.postMessage(new $321a099d23035c75$export$612749e00a84ad10(request.id), "*");
            } catch (e) {
                sourceWindow.postMessage(new $321a099d23035c75$export$612749e00a84ad10(request.id, e.toString()), "*");
            }
        }
        if ($321a099d23035c75$export$2f1c2e17db43d9ae(event.data)) {
            const request = event.data;
            try {
                const challengeProcessor = new (0, $6e0c5c565800e425$export$3b603621c2caaf6c)(this, this.emitter);
                const attestation = await challengeProcessor.processWebAuthnCreateChallenge(request.challenge);
                sourceWindow.postMessage(new $321a099d23035c75$export$8b7d42a6791cdca9(request.id, attestation), "*");
            } catch (e) {
                sourceWindow.postMessage(new $321a099d23035c75$export$8b7d42a6791cdca9(request.id, null, e.toString()), "*");
            }
        }
        if ($321a099d23035c75$export$3d155c9fa32292c(event.data)) {
            const request = event.data;
            try {
                const challengeProcessor = new (0, $6e0c5c565800e425$export$3b603621c2caaf6c)(this, this.emitter);
                const attestation = await challengeProcessor.processWebAuthnGetChallenge(request.challenge);
                sourceWindow.postMessage(new $321a099d23035c75$export$85b72b60e2ec2ca5(request.id, attestation), "*");
            } catch (e) {
                sourceWindow.postMessage(new $321a099d23035c75$export$85b72b60e2ec2ca5(request.id, null, e.toString()), "*");
            }
        }
    }
    async listenForEvents() {
        window.addEventListener("message", this.processEvent.bind(this));
    }
    setupIFrame() {
        const sdkURLStr = this.getSDKUrl().toString();
        // No need, we're already in the target context
        if ((0, $e800fbca613e1fbe$export$ca8daecbc0756b1b)(new URL(window.location.href), new URL(this.sdkURL))) return null;
        // Try to find an existing one by ID
        let slashIDIFrame = document.getElementById($b5612fac2c319704$var$SlashIDIFrameID);
        if (slashIDIFrame && slashIDIFrame.src !== sdkURLStr) {
            slashIDIFrame.remove();
            slashIDIFrame = null;
        }
        if (!slashIDIFrame) {
            // Not found, create an invisible one
            slashIDIFrame = document.createElement("iframe");
            slashIDIFrame.id = $b5612fac2c319704$var$SlashIDIFrameID;
            slashIDIFrame.allow = "publickey-credentials-get *";
            slashIDIFrame.src = sdkURLStr;
            slashIDIFrame.style.display = "none";
            document.body.appendChild(slashIDIFrame);
        }
        return slashIDIFrame;
    }
    /**
     * List the available authentication methods for the chosen handle type. Currently available
     * authentication methods are listed in {@link Types.FactorMethod}. Before choosing a method to pass
     * to {@link id} you should consult the result of this method. In particular the availability of
     * the {@link Types.FactorMethod['Webauthn']} method depends on the current device configuration and
     * might not always be available.
     *
     * It's important to note that you can rely on some authentication methods to always be available:
     *
     *  - for {@link PersonHandleType['EmailAddress']}: {@link Types.FactorMethod['OtpViaEmail']} and
     *    {@link Types.FactorMethod['EmailLink']} are always available;
     *  - for {@link PersonHandleType['PhoneNumber']}: {@link Types.FactorMethod['OtpViaSms']} and
     *    {@link Types.FactorMethod['SmsLink']} are always available;
     *
     * On the contrary, the availability of {@link Types.FactorMethod['Webauthn']} depends exclusively on the
     * current device configuration.
     *
     * @remarks The availability of authetication methods can vary over time, you probably should not
     * cache or store the result and instead invoke the method any time you need to authenticate a user.
     *
     * @example
     *
     * SlashID supports a number of handle types, each in turn supporting a set of
     * authentication methods. Supposing you identify your users with e-mail addresses,
     * you should check the authentication methods available on the current device before
     * kicking off the authentication flow:
     *
     * ```js
     * const availableMethods = sid.getAvailableAuthenticationMethods("email_address")
     * // => availableMethods === ["webauthn", "email_link"]
     * ```
     *
     * At this point you can choose which method to use in {@link id}. You could decide based on
     * one or a combination of:
     *
     *  - Your static preference: e.g. require WebAuthn, prefer WebAuthn ({@link Types.FactorMethod['Webauthn']})
     *    if available, otherwise fallback to magic link via e-mail ({@link Types.FactorMethod['EmailLink']})
     *    ```
     *    const chosenMethod = availableMethods.includes("webauthn") ? "webauthn" : "email_link"
     *    ```
     *  - User's choice: you could present your users with a selection of the available methods;
     *
     * In general the SlashID SDK does not impose any restriction on how you decide to choose which
     * authentication method to use.
     *
     * @param handleType Available handle types are ``"email_address"``, ``"phone_number"`` and ``"username"``.
     * @returns  An array of the available authentication methods on this device.
     */ async getAvailableAuthenticationMethods(handleType) {
        const availableMethods = [
            $6b68392b32751678$export$8279f5e63c6521d8.Password,
            $6b68392b32751678$export$8279f5e63c6521d8.Totp
        ];
        switch(handleType){
            case $eb92675354d724ac$export$885886f088cd0586.EmailAddress:
                availableMethods.push($6b68392b32751678$export$8279f5e63c6521d8.EmailLink, $6b68392b32751678$export$8279f5e63c6521d8.OtpViaEmail);
                break;
            case $eb92675354d724ac$export$885886f088cd0586.PhoneNumber:
                availableMethods.push($6b68392b32751678$export$8279f5e63c6521d8.SmsLink, $6b68392b32751678$export$8279f5e63c6521d8.OtpViaSms);
                break;
            case $eb92675354d724ac$export$885886f088cd0586.Username:
                break;
            default:
                throw new $b18eec6826b7d21f$export$f471a06c79be5983({
                    name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).unknown,
                    message: `unhandled handle type: ${handleType}`
                });
        }
        if (navigator && window.PublicKeyCredential && $d3aa02db23ac975e$export$c51332e5b5280a9f(handleType)) availableMethods.unshift($6b68392b32751678$export$8279f5e63c6521d8.Webauthn);
        return availableMethods;
    }
    /**
     * Preferred way of creating  a {@link Types.BaseUser} instance based on an existing token.
     *
     * @param token A user {@link Types.UserTokenText} value.
     * @returns User instance
     */ getUser(token) {
        const user = new (0, $f6b03dd3570fd99b$export$ec7121d802e738bd)(token, this);
        return user;
    }
    /**
     * Identify a user. This method implements the SlashID authentication flow.
     * In particular the flow is:
     *
     *  - **passwordless**: all you need to specify to authenticate a user is their handle,
     *    be it an e-mail address or phone number, and how they wish to authenticate; please see
     *    the parameters documentation for more details;
     *
     *  - **unified**: it does not require you to differentiate between first registration and
     *    subsequent logins attempts. The SlashID service takes care of the distinction and will
     *    perform the necessary verification ceremonies on your behalf under the hood.
     *
     *  - **synchronous**: on successful return the user has verified their identity; even when
     *    the authentication spans multiple devices and is comprised of multiple steps (e.g
     *    clicking a magic link on the provided e-mail address and creating a new biometric
     *    credential on the current device), this method will not return until all steps have
     *    completed or errors have been encountered.
     *
     *
     * Before utilizing any authentication method you should check whether it is available with {@link getAvailableAuthenticationMethods}.
     *
     * The currently available options for the `authenticationFactor.method` field are:
     *
     *  - **``"webauthn"``**: Authenticate the user via WebAuthn on this device. If available this
     *    usually entails built-in biometric authentication or the use of an external FIDO key, with a
     *    preference for the former. Please also see the [WebAuthn scope](#webauthn_scope) and
     *    [WebAuthn attachment](#webauthn_attachment) sections below for details.
     *
     *  - **``"email_link"``**: Deliver a magic link via e-mail.
     *
     *  - **``"otp_via_email"``**: Deliver an OTP security code via e-mail. This authentication method requires you to {@link publish} an
     *    `otpCodeSubmitted` event to the SDK. The event payload must be a string containing the OTP
     *    value, which your user will receive via e-mail.
     *
     *  - **``"sms_link"``**: Deliver a magic link via SMS.
     *
     *  - **``"otp_via_sms"``**: Deliver an OTP security code via SMS. This authentication method requires you to {@link publish} an
     *    `otpCodeSubmitted` event to the SDK. The event payload must be a string containing the OTP
     *    value, which your user will receive via SMS.
     *
     *  - **``oidc``**: Authenticate the user using OIDC through a preconfigured Identity Provider.
     *
     *  - **``totp``**: Authenticate the user with a TOTP code. This authentication method requires you to {@link publish} an
     *    `otpCodeSubmitted` event to the SDK. The event payload must be a string containing the OTP
     *    code, which your user will retrieve from their authenticator app or device.
     *
     * <a name="webauthn_scope"></a>
     * <b>WebAuthn scope</b>
     *
     * In case you have chosen the WebAuthn method, you have the option to specify a `scope`
     * in the `options` field. This field allows you to control the breadth of your users' WebAuthn credentials.
     * The field is optional, but if specified it can either be your domain or any "registrable domain suffix" of it.
     * E.g. if your domain is `shop.domain.com` you have two options to choose from:
     *
     *  - `shop.domain.com`: scope your users to the current domain. Credentials created here will not be shared with sibling domains such as `services.domain.com`;
     *  - `domain.com`: scope your users to the least specific domain. Credentials created here will be allowed to access all subdomains such as `services.domain.com`;
     *
     * Please consult the HTML spec for the formal definition of [registrable domain suffix](https://html.spec.whatwg.org/multipage/origin.html#is-a-registrable-domain-suffix-of-or-is-equal-to)
     * if you need detailed information. When not specified the `scope` option defaults to the current origin, `shop.domain.com`
     * in the example above.
     *
     * <a name="webauthn_attachment"></a>
     * <b>WebAuthn attachment</b>
     *
     * Users can perform WebAuthn either with built-in authenticators (FaceID, TouchID, fingerprint readers, etc.)
     * or external security keys, and in case you have a preference you can control which authenticator type to use
     * by specifying an `attachment` option field in the `options` field.
     * The field is optional and has 3 allowed values from the {@link WebAuthnAuthenticatorAttachment} enum:
     *
     *  - `"platform"`: mandate use of built-in authenticators;
     *  - `"cross-platform"`: mandate use of external security keys;
     *  - `"any"`: the default value if unspecified, allows both types;
     *
     * If left unspecified (or explicitly set to `"any"`) the user will be prompted with a system dialog to choose
     * which type of authenticator they prefer. By providing one of the other options instead (e.g. `"platform"`)
     * you explicitly limit the authenticator types the user can choose from. On most devices this results in the
     * most seamless WebAuthn user experience possible, as the system dialog will not be shown and the user will be
     * prompted to authenticate directly.
     *
     * @param oid Your organization ID.
     * @param handle How the user wishes to identify, e.g. their e-mail address.
     * @param authenticationFactor How to verify the user's identity matches the handle.
     *
     * @throws `slashid.errors_INTERNAL_ONLY.InvalidAuthenticationMethodError` if the chosen method is
     * incompatible with the given handle or is not available on the current device.
     *
     * @fires {@link Types.IdFlowSucceededEvent} when the flow resolves successfully
     *
     * @returns The authenticated user.
     *
     * @example
     *
     * Authenticating a user is as simple as:
     *
     * ```js
     * const user = await slashID.id({
     *   type: "phone_number",
     *   value: "+13337777777",
     * }, {
     *   method: "webauthn"
     * })
     * ```
     *
     * At this point the user has been authenticated; either registered or logged in.
     *
     * You can use it in a header in your HTTP requests:
     *
     * ```js
     * const response = await fetch(url, {
     *   ...
     *   headers: {
     *     'Authorization': `Bearer ${user.token}`,
     *      ...
     *   }
     * });
     * ```
     *
     * You can collect and associate user attributes:
     *
     * ```js
     * const userDetails = { name: "...", streetAddress: "..." }
     * await user.set(userDetails)
     * ```
     *
     * You can perform multi-factor authentication before proceeding with your application logic:
     *
     * ```js
     * await user.mfa({
     *   type: "email_address",
     *   value: "my.email@example.com"
     * }, {
     *   method: "email_link"
     * })
     * ```
     */ async id(oid, handle, authenticationFactor) {
        return this._id(oid, handle, authenticationFactor);
    }
    createAuthFlow() {
        const flow = new (0, $0c37c96de0d5eaeb$export$4d9fb5586e103031)(this, this.emitter);
        this.authFlow = flow;
        return flow;
    }
    clearAuthFlow(flow) {
        if (this.authFlow === flow) this.authFlow = null;
    }
    createRecoveryFlow() {
        const flow = new (0, $0c37c96de0d5eaeb$export$4d9fb5586e103031)(this, this.emitter);
        this.recoveryFlow = flow;
        return flow;
    }
    clearRecoveryFlow(flow) {
        if (this.recoveryFlow === flow) this.recoveryFlow = null;
    }
    /**
     * @internal
     */ async _id(oid, handle, authenticationFactor, prevToken) {
        const flow = this.createAuthFlow();
        try {
            const user = await flow._id({
                oid: oid,
                handle: handle,
                authenticationFactor: authenticationFactor,
                prevToken: prevToken
            });
            return user;
        } catch (e) {
            await this.processError(e, {
                authenticationFactor: authenticationFactor,
                handle: handle,
                previousToken: prevToken
            });
            if ($b18eec6826b7d21f$export$a98b3b17ec378e54(e)) throw await $b18eec6826b7d21f$export$65efd56077f75087(e, {
                handle: handle,
                authenticationFactor: authenticationFactor,
                oid: oid
            });
            throw await $b18eec6826b7d21f$export$ed0b6181311676c(e);
        } finally{
            this.clearAuthFlow(flow);
        }
    }
    /**
     * List the handles previously used to authenticate successfully.
     *
     * @remarks Use of this method is in no way required to authenticate with SlashID. The SDK
     * provides it to allow you to more easily implement loging suggestion drop-down lists
     * and similar UX niceties, by e.g. tying it to a `<datalist>`:
     *
     * ```js
     * const handles = await sid.getAvailableIdentifiers()
     * const options = handles.map((handle) => {
     *   const option = document.createElement("option")
     *   option.value = handle.value
     *   return option
     * })
     * const datalist = document.getElementById("available_identifiers")
     * datalist.replaceChildren(...options)
     *
     * ...
     *
     * <input ... list="available_identifiers" />
     * ```
     *
     * Depending on browser settings, it may not be possible to discover these
     * identifiers.
     *
     * @returns An array of identifiers of previously-authenticated users.
     */ async getAvailableIdentifiers() {
        try {
            return this.identifiersStorage.getAll();
        } catch (e) {
            console.warn(e);
            return [];
        }
    }
    /**
     * Use a verified handle and a factor to start the account recovery flow.
     * The user will receive instructions on how to proceed using a delivery mechanism based on the given handle.
     * After this method resolves, the user will be able to authenticate using the same handle and factor.
     */ async recover({ handle: handle, factor: factor }) {
        if (!this.oid) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            message: "oid is required - please initialize the SDK with an organization ID"
        });
        // @ts-expect-error ensure this works in runtime if someone ignores TypeScript
        if (handle.type === $eb92675354d724ac$export$885886f088cd0586.Username) throw new $b18eec6826b7d21f$export$f471a06c79be5983({
            name: (0, $43ff6ce83801d41a$export$daceac3b97803ce1).recoverNonReachableHandleType,
            message: "Username is not a reachable handle type"
        });
        const flow = this.createRecoveryFlow();
        this.emitter.emit({
            name: "recoveryFlowStarted",
            payload: {
                handle: handle,
                authenticationFactor: factor
            },
            meta: {
                access: "public",
                recoveryFlowId: flow.flowId
            }
        });
        try {
            await flow.recover({
                handle: handle,
                factor: factor
            });
            this.recoveryFlow = null;
            this.emitter.emit({
                name: "recoveryFlowSucceeded",
                payload: {
                    handle: handle,
                    authenticationFactor: factor
                },
                meta: {
                    access: "public",
                    recoveryFlowId: flow.flowId
                }
            });
        } catch (error) {
            const failureDetail = await $b18eec6826b7d21f$export$82f46aa4e6535a45(error);
            const errorEvent = {
                errorText: "recovery_failed",
                authenticationFactor: factor,
                handle: handle,
                failureDetail: failureDetail
            };
            this.emitter.emit({
                name: "recoveryFlowFailed",
                payload: errorEvent,
                meta: {
                    access: "public",
                    recoveryFlowId: flow.flowId
                }
            });
            throw await $b18eec6826b7d21f$export$ed0b6181311676c(error);
        } finally{
            this.clearRecoveryFlow(flow);
        }
    }
    getSDKUrl() {
        const sdkURL = new URL(this.sdkURL);
        sdkURL.searchParams.append("v", (0, $2ebaab364aa833bc$export$f9582ef3c55143f).raw);
        return sdkURL;
    }
    isLocalScope(rpID) {
        return window.location.hostname.endsWith(rpID);
    }
    /**
     * Examine the error object and publish the proper event as a reaction to it.
     */ async processError(error, { authenticationFactor: authenticationFactor, handle: handle, previousToken: previousToken, challengeId: challengeId }) {
        console.log({
            error: error
        });
        if ($43ff6ce83801d41a$export$fbcc115299f660c(error)) // cancelling a flow is not an error
        // TODO later turn this into a proper event
        return;
        const errorEvent = await $b18eec6826b7d21f$export$7f84d4628fc07381(error, {
            authenticationFactor: authenticationFactor,
            handle: handle,
            previousToken: previousToken,
            challengeId: challengeId
        });
        if ($76a5a02979c884f4$export$2d39cf9e3832749f(errorEvent)) {
            // TODO: dedupe this in @slashid/react
            const internal = $b5612fac2c319704$export$5f74d2b45f2a2732(this);
            internal.publish("clientSideError", errorEvent);
        } else this.emitter.emit({
            name: "idFlowFailed",
            payload: errorEvent,
            meta: {
                access: "public",
                authFlowId: this.authFlow?.flowId,
                recoveryFlowId: this.recoveryFlow?.flowId
            }
        });
    }
    async createAnonymousUser() {
        const createAnonUserOptions = (0, $06fb94e8077e467b$export$a96acc74924a1a1)(this);
        const token = await (0, $06fb94e8077e467b$export$48a8ffe18f8d9950)(createAnonUserOptions);
        return new (0, $ef74e25b7eeeddfd$export$97e23b13d26a722)(token, this);
    }
    createChallengeProcessor(flowMeta) {
        return new (0, $6e0c5c565800e425$export$3b603621c2caaf6c)(this, this.emitter, flowMeta);
    }
}





var $d9042465972ade86$exports = {};

$parcel$export($d9042465972ade86$exports, "runtimeSupportsBestPasskeyUX", function () { return $d9042465972ade86$export$bc87d993f6c87f93; });

var $81oe6 = parcelRequire("81oe6");
const $21451a1ccf180510$export$3af5f95c25016942 = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $21451a1ccf180510$export$a587e8cd55d12c1e = (version)=>{
    if (typeof version !== 'string') throw new TypeError('Invalid argument expected string');
    const match = version.match($21451a1ccf180510$export$3af5f95c25016942);
    if (!match) throw new Error(`Invalid argument not valid semver ('${version}' received)`);
    match.shift();
    return match;
};
const $21451a1ccf180510$var$isWildcard = (s)=>s === '*' || s === 'x' || s === 'X';
const $21451a1ccf180510$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $21451a1ccf180510$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $21451a1ccf180510$var$compareStrings = (a, b)=>{
    if ($21451a1ccf180510$var$isWildcard(a) || $21451a1ccf180510$var$isWildcard(b)) return 0;
    const [ap, bp] = $21451a1ccf180510$var$forceType($21451a1ccf180510$var$tryParse(a), $21451a1ccf180510$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $21451a1ccf180510$export$469e457e9b5db249 = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $21451a1ccf180510$var$compareStrings(a[i] || '0', b[i] || '0');
        if (r !== 0) return r;
    }
    return 0;
};


const $c0db99ad9a59b465$export$66e1c0999abad646 = (v1, v2)=>{
    // validate input and split into segments
    const n1 = (0, $21451a1ccf180510$export$a587e8cd55d12c1e)(v1);
    const n2 = (0, $21451a1ccf180510$export$a587e8cd55d12c1e)(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = (0, $21451a1ccf180510$export$469e457e9b5db249)(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return (0, $21451a1ccf180510$export$469e457e9b5db249)(p1.split('.'), p2.split('.'));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
};


const $d9042465972ade86$var$supported = {
    "Mac OS": {
        // Ventura
        osVersion: "13.0.0",
        browsers: {
            Chrome: "108",
            Safari: "16.1",
            Firefox: "122",
            Opera: "97"
        }
    },
    Windows: undefined,
    Linux: undefined,
    iOS: {
        osVersion: "16",
        browsers: {
            "Mobile Safari": "16",
            Chrome: "108"
        }
    },
    Android: {
        osVersion: "9",
        browsers: {
            Chrome: "108"
        }
    }
};
const $d9042465972ade86$var$useExperimentalUserAgentData = async ()=>{
    if ("userAgentData" in navigator) {
        const uad = navigator.userAgentData;
        if ("getHighEntropyValues" in uad) return await uad.getHighEntropyValues([
            "platform",
            "platformVersion",
            "fullVersionList",
            "mobile"
        ]);
    }
    return undefined;
};
const $d9042465972ade86$var$legacyUserAgentBasedDetection = ()=>{
    const runtime = new (0, $81oe6.UAParser)(globalThis.navigator.userAgent);
    const browser = runtime.getBrowser();
    const os = runtime.getOS();
    if (!browser.name || !browser.version || !os.name || !os.version) return false;
    const minimum = $d9042465972ade86$var$supported[os.name];
    if (!minimum) return false;
    const minimumBrowserVersion = minimum?.browsers[browser.name];
    if (!minimumBrowserVersion) return false;
    /**
     * We trust that any approved browser on MacOS will work
     *
     * Unfortunately we can't do better targeting on MacOS
     * for the platform version because it always returns
     * 10.15.7
     */ if (os.name === "Mac OS") return true;
    if ((0, $c0db99ad9a59b465$export$66e1c0999abad646)(browser.version, minimumBrowserVersion) === -1) return false;
    return (0, $c0db99ad9a59b465$export$66e1c0999abad646)(os.version, minimum.osVersion) !== -1;
};
const $d9042465972ade86$var$useExperimentalUserAgentDataBasedDetection = (uad)=>{
    const uadBrowserNames = [
        "Google Chrome",
        "Microsoft Edge",
        "Opera"
    ];
    const uadBrandToBrowserName = {
        "Google Chrome": "Chrome",
        "Microsoft Edge": "Edge",
        Opera: "Opera"
    };
    const uadBrandToBrowserNameMobile = {
        "Google Chrome": "Chrome",
        "Microsoft Edge": "Edge",
        Opera: "Opera Mini"
    };
    const uadPlatformToPlatform = {
        macOS: "Mac OS",
        Android: "Android"
    };
    const uadBrowser = uad.fullVersionList.find((entry)=>{
        return uadBrowserNames.includes(entry.brand);
    });
    if (!uadBrowser || !uad.platform || !uad.platformVersion) return false;
    const browserName = uad.mobile ? uadBrandToBrowserNameMobile[uadBrowser.brand] : uadBrandToBrowserName[uadBrowser.brand];
    const browserVersion = uadBrowser.version;
    const platformName = uadPlatformToPlatform[uad.platform];
    const minimum = $d9042465972ade86$var$supported[platformName];
    if (!minimum) return false;
    if ((0, $c0db99ad9a59b465$export$66e1c0999abad646)(uad.platformVersion, minimum.osVersion) === -1) return false;
    const minimumBrowserVersion = minimum?.browsers[browserName];
    if (!minimumBrowserVersion) return false;
    return (0, $c0db99ad9a59b465$export$66e1c0999abad646)(browserVersion, minimumBrowserVersion) !== -1;
};
const $d9042465972ade86$export$bc87d993f6c87f93 = async ()=>{
    try {
        const experimentalUserAgentData = await $d9042465972ade86$var$useExperimentalUserAgentData();
        if (experimentalUserAgentData) return $d9042465972ade86$var$useExperimentalUserAgentDataBasedDetection(experimentalUserAgentData);
        return $d9042465972ade86$var$legacyUserAgentBasedDetection();
    } catch  {
        return false;
    }
};


window.slashid = {
    SlashID: $b5612fac2c319704$export$261888861cdb8a55,
    User: $f6b03dd3570fd99b$export$ec7121d802e738bd,
    version: $2ebaab364aa833bc$export$f9582ef3c55143f,
    errors: {
        ...$43ff6ce83801d41a$exports,
        // TODO: remove this export
        ...$b18eec6826b7d21f$exports
    },
    utils: $d9042465972ade86$exports
};

})();
//# sourceMappingURL=slashid.js.map
